/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSJSON: { input: string; output: string; }
};

export type Attachment = {
  __typename?: 'Attachment';
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  scanError?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  tempSessionId?: Maybe<Scalars['String']['output']>;
  uploadedAt: Scalars['String']['output'];
};

export type AttachmentStatusInput = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  scanError?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  status: Scalars['String']['input'];
  tempSessionId?: InputMaybe<Scalars['String']['input']>;
  uploadedAt: Scalars['String']['input'];
};

export type AttachmentUploadTicket = {
  __typename?: 'AttachmentUploadTicket';
  attachmentId: Scalars['ID']['output'];
  expiresIn: Scalars['Int']['output'];
  fields: Scalars['AWSJSON']['output'];
  s3Key: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type BotResponse = {
  __typename?: 'BotResponse';
  answer?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Maybe<BotResponseItem>>>;
  threadId?: Maybe<Scalars['String']['output']>;
};

export type BotResponseItem = {
  __typename?: 'BotResponseItem';
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Comment = {
  __typename?: 'Comment';
  commentedAt?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectId: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type FishboneBranch = {
  __typename?: 'FishboneBranch';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endOn?: Maybe<Scalars['String']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorLinks?: Maybe<Array<Maybe<FishboneIndicatorLink>>>;
  items?: Maybe<Array<Maybe<FishboneItem>>>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  riskLinks?: Maybe<Array<Maybe<FishboneRiskLink>>>;
  scenarios?: Maybe<Array<Maybe<FishboneBranchScenarioSimulation>>>;
  stakeLinks?: Maybe<Array<Maybe<FishboneStakeLink>>>;
  stakeholderLinks?: Maybe<Array<Maybe<FishboneStakeholderLink>>>;
  startOn?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type FishboneBranchScenarioSimulation = {
  __typename?: 'FishboneBranchScenarioSimulation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type FishboneIndicatorLink = {
  __typename?: 'FishboneIndicatorLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  fishboneNodeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  indicatorId: Scalars['String']['output'];
  nodeType: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  strength?: Maybe<Scalars['Int']['output']>;
};

export type FishboneItem = {
  __typename?: 'FishboneItem';
  completion?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  endOn?: Maybe<Scalars['String']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  fishboneBranchId: Scalars['String']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorLinks?: Maybe<Array<Maybe<FishboneIndicatorLink>>>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  riskLinks?: Maybe<Array<Maybe<FishboneRiskLink>>>;
  scenarios?: Maybe<Array<Maybe<FishboneItemScenarioSimulation>>>;
  stakeLinks?: Maybe<Array<Maybe<FishboneStakeLink>>>;
  stakeholderLinks?: Maybe<Array<Maybe<FishboneStakeholderLink>>>;
  startOn?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type FishboneItemScenarioSimulation = {
  __typename?: 'FishboneItemScenarioSimulation';
  completion?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  trend?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type FishboneRiskLink = {
  __typename?: 'FishboneRiskLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  fishboneNodeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nodeType: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  riskId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type FishboneStakeLink = {
  __typename?: 'FishboneStakeLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  fishboneNodeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nodeType: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  stakeId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type FishboneStakeholderLink = {
  __typename?: 'FishboneStakeholderLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  fishboneNodeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nodeType: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  stakeholderId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type ImpactLevel = {
  __typename?: 'ImpactLevel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ImpactLevelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Indicator = {
  __typename?: 'Indicator';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  fishboneLinks?: Maybe<Array<Maybe<FishboneIndicatorLink>>>;
  frequency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorCategoryId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  scenarios?: Maybe<Array<Maybe<IndicatorScenarioSimulation>>>;
  trend?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type IndicatorCategory = {
  __typename?: 'IndicatorCategory';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type IndicatorScenarioSimulation = {
  __typename?: 'IndicatorScenarioSimulation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  trend?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type LikelihoodLevel = {
  __typename?: 'LikelihoodLevel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LikelihoodLevelInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type McpAccess = {
  __typename?: 'McpAccess';
  endpoint?: Maybe<Scalars['String']['output']>;
  info?: Maybe<McpTokenInfo>;
  token?: Maybe<Scalars['String']['output']>;
};

export type McpTokenInfo = {
  __typename?: 'McpTokenInfo';
  createdAt: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  prefix: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addProjectMember?: Maybe<ProjectMember>;
  claimAttachments?: Maybe<Scalars['String']['output']>;
  cloneProject?: Maybe<Scalars['String']['output']>;
  consumeCode?: Maybe<Scalars['String']['output']>;
  createComment?: Maybe<Comment>;
  createFishboneBranch?: Maybe<FishboneBranch>;
  createFishboneBranchIndicatorLink?: Maybe<FishboneIndicatorLink>;
  createFishboneBranchRiskLink?: Maybe<FishboneRiskLink>;
  createFishboneBranchStakeLink?: Maybe<FishboneStakeLink>;
  createFishboneBranchStakeholderLink?: Maybe<FishboneStakeholderLink>;
  createFishboneItem?: Maybe<FishboneItem>;
  createFishboneItemIndicatorLink?: Maybe<FishboneIndicatorLink>;
  createFishboneItemRiskLink?: Maybe<FishboneRiskLink>;
  createFishboneItemStakeLink?: Maybe<FishboneStakeLink>;
  createFishboneItemStakeholderLink?: Maybe<FishboneStakeholderLink>;
  createIndicator?: Maybe<Indicator>;
  createIndicatorCategory?: Maybe<IndicatorCategory>;
  createProject?: Maybe<Project>;
  createRisk?: Maybe<Risk>;
  createRiskCategory?: Maybe<RiskCategory>;
  createRiskIndicatorImpact?: Maybe<RiskIndicatorImpact>;
  createRiskOpeningLink?: Maybe<RiskOpeningLink>;
  createRiskStakeImpact?: Maybe<RiskStakeImpact>;
  createScenario?: Maybe<Scalars['String']['output']>;
  createStake?: Maybe<Stake>;
  createStakeIndicatorImpact?: Maybe<StakeIndicatorImpact>;
  createStakeholder?: Maybe<Stakeholder>;
  createStakeholderIndicatorImpact?: Maybe<StakeholderIndicatorImpact>;
  createStakeholderLink?: Maybe<StakeholderLink>;
  createStakeholderRiskImpact?: Maybe<StakeholderRiskImpact>;
  createStakeholderStakeImpact?: Maybe<StakeholderStakeImpact>;
  createTag?: Maybe<Tag>;
  createTagging?: Maybe<Tagging>;
  deleteAttachment?: Maybe<Scalars['String']['output']>;
  deleteComment?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneBranch?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneIndicatorLink?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneItem?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneRiskLink?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneStakeLink?: Maybe<Scalars['Boolean']['output']>;
  deleteFishboneStakeholderLink?: Maybe<Scalars['Boolean']['output']>;
  deleteIndicator?: Maybe<Scalars['Boolean']['output']>;
  deleteIndicatorCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteProject?: Maybe<Scalars['Boolean']['output']>;
  deleteRisk?: Maybe<Scalars['Boolean']['output']>;
  deleteRiskCategory?: Maybe<Scalars['Boolean']['output']>;
  deleteRiskIndicatorImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteRiskOpeningLink?: Maybe<Scalars['Boolean']['output']>;
  deleteRiskStakeImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteScenario?: Maybe<Scalars['Boolean']['output']>;
  deleteStake?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeIndicatorImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeholder?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeholderIndicatorImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeholderLink?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeholderRiskImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteStakeholderStakeImpact?: Maybe<Scalars['Boolean']['output']>;
  deleteTag?: Maybe<Scalars['Boolean']['output']>;
  deleteTagging?: Maybe<Scalars['Boolean']['output']>;
  deleteWatchReport?: Maybe<Scalars['Boolean']['output']>;
  generateMcpToken?: Maybe<McpAccess>;
  getAssetUrl?: Maybe<Scalars['String']['output']>;
  getCustomerPortalUrl?: Maybe<Scalars['String']['output']>;
  importScenarioImpacts?: Maybe<Scalars['String']['output']>;
  makePayment?: Maybe<Scalars['String']['output']>;
  promoteScenarioAsBaseline?: Maybe<Scalars['Boolean']['output']>;
  publishAttachmentStatus?: Maybe<Attachment>;
  publishProjectChange?: Maybe<ProjectChangeSet>;
  publishProjectMessage?: Maybe<ProjectMessage>;
  regenerateMcpToken?: Maybe<McpAccess>;
  removeProjectMember?: Maybe<Scalars['Boolean']['output']>;
  requestAttachmentUpload?: Maybe<Scalars['String']['output']>;
  revokeMcpToken?: Maybe<McpAccess>;
  updateComment?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneBranch?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneBranchScenario?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneIndicatorLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneItem?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneItemBranch?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneItemScenario?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneRiskLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneStakeLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateFishboneStakeholderLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateIndicator?: Maybe<Scalars['Boolean']['output']>;
  updateIndicatorCategory?: Maybe<Scalars['Boolean']['output']>;
  updateIndicatorScenario?: Maybe<Scalars['Boolean']['output']>;
  updateProject?: Maybe<Scalars['Boolean']['output']>;
  updateRisk?: Maybe<Scalars['Boolean']['output']>;
  updateRiskCategory?: Maybe<Scalars['Boolean']['output']>;
  updateRiskIndicatorImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateRiskOpeningLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateRiskScenario?: Maybe<Scalars['Boolean']['output']>;
  updateRiskStakeImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateScenario?: Maybe<Scalars['Boolean']['output']>;
  updateStake?: Maybe<Scalars['Boolean']['output']>;
  updateStakeIndicatorImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateStakeScenario?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholder?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholderIndicatorImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholderLinkStrength?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholderRiskImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholderScenario?: Maybe<Scalars['Boolean']['output']>;
  updateStakeholderStakeImpactStrength?: Maybe<Scalars['Boolean']['output']>;
  updateTag?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationAddProjectMemberArgs = {
  email: Scalars['String']['input'];
  locale?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
};


export type MutationClaimAttachmentsArgs = {
  projectId: Scalars['String']['input'];
  tempSessionId: Scalars['String']['input'];
};


export type MutationCloneProjectArgs = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MutationConsumeCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateCommentArgs = {
  commentedAt: Scalars['String']['input'];
  description: Scalars['String']['input'];
  objectId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationCreateFishboneBranchArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endOn?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  responsible?: InputMaybe<Scalars['String']['input']>;
  startOn?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateFishboneBranchIndicatorLinkArgs = {
  fishboneBranchId: Scalars['String']['input'];
  indicatorId: Scalars['String']['input'];
};


export type MutationCreateFishboneBranchRiskLinkArgs = {
  fishboneBranchId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};


export type MutationCreateFishboneBranchStakeLinkArgs = {
  fishboneBranchId: Scalars['String']['input'];
  stakeId: Scalars['String']['input'];
};


export type MutationCreateFishboneBranchStakeholderLinkArgs = {
  fishboneBranchId: Scalars['String']['input'];
  stakeholderId: Scalars['String']['input'];
};


export type MutationCreateFishboneItemArgs = {
  completion?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endOn?: InputMaybe<Scalars['String']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  fishboneBranchId: Scalars['String']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  responsible?: InputMaybe<Scalars['String']['input']>;
  startOn?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateFishboneItemIndicatorLinkArgs = {
  fishboneItemId: Scalars['String']['input'];
  indicatorId: Scalars['String']['input'];
};


export type MutationCreateFishboneItemRiskLinkArgs = {
  fishboneItemId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};


export type MutationCreateFishboneItemStakeLinkArgs = {
  fishboneItemId: Scalars['String']['input'];
  stakeId: Scalars['String']['input'];
};


export type MutationCreateFishboneItemStakeholderLinkArgs = {
  fishboneItemId: Scalars['String']['input'];
  stakeholderId: Scalars['String']['input'];
};


export type MutationCreateIndicatorArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  indicatorCategoryId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateIndicatorCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateProjectArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  impacts?: InputMaybe<Array<InputMaybe<ImpactLevelInput>>>;
  likelihoods?: InputMaybe<Array<InputMaybe<LikelihoodLevelInput>>>;
  name: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vision?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRiskArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  impact?: InputMaybe<Scalars['Float']['input']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  likelihood?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  riskCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRiskCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateRiskIndicatorImpactArgs = {
  indicatorId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};


export type MutationCreateRiskOpeningLinkArgs = {
  openingId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
  strength?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateRiskStakeImpactArgs = {
  riskId: Scalars['String']['input'];
  stakeId: Scalars['String']['input'];
};


export type MutationCreateScenarioArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  impacts?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  referenceScenarioId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateStakeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  reference?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateStakeIndicatorImpactArgs = {
  indicatorId: Scalars['String']['input'];
  stakeId: Scalars['String']['input'];
};


export type MutationCreateStakeholderArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  impact?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  trend?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateStakeholderIndicatorImpactArgs = {
  indicatorId: Scalars['String']['input'];
  stakeholderId: Scalars['String']['input'];
};


export type MutationCreateStakeholderLinkArgs = {
  originId: Scalars['String']['input'];
  targetId: Scalars['String']['input'];
};


export type MutationCreateStakeholderRiskImpactArgs = {
  riskId: Scalars['String']['input'];
  stakeholderId: Scalars['String']['input'];
};


export type MutationCreateStakeholderStakeImpactArgs = {
  stakeId: Scalars['String']['input'];
  stakeholderId: Scalars['String']['input'];
};


export type MutationCreateTagArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationCreateTaggingArgs = {
  objectId: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationDeleteAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


export type MutationDeleteCommentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneBranchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneIndicatorLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneRiskLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneStakeLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFishboneStakeholderLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIndicatorArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteIndicatorCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProjectArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRiskArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRiskCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRiskIndicatorImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRiskOpeningLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteRiskStakeImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScenarioArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeIndicatorImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeholderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeholderIndicatorImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeholderLinkArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeholderRiskImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteStakeholderStakeImpactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTaggingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteWatchReportArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateMcpTokenArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetAssetUrlArgs = {
  id: Scalars['String']['input'];
};


export type MutationImportScenarioImpactsArgs = {
  impacts: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  scenarioId: Scalars['String']['input'];
};


export type MutationMakePaymentArgs = {
  price: Scalars['String']['input'];
  referer: Scalars['String']['input'];
};


export type MutationPromoteScenarioAsBaselineArgs = {
  baselineNewName?: InputMaybe<Scalars['String']['input']>;
  keepBaselineAsScenario: Scalars['Boolean']['input'];
  keepScenario: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
  scenarioId: Scalars['ID']['input'];
};


export type MutationPublishAttachmentStatusArgs = {
  input: AttachmentStatusInput;
};


export type MutationPublishProjectChangeArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  changes?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['String']['input'];
  operation: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationPublishProjectMessageArgs = {
  message: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type MutationRegenerateMcpTokenArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveProjectMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRequestAttachmentUploadArgs = {
  contentType: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['String']['input']>;
  size: Scalars['Float']['input'];
  tempSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCommentArgs = {
  commentedAt: Scalars['String']['input'];
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateFishboneBranchArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endOn?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  responsible?: InputMaybe<Scalars['String']['input']>;
  startOn?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFishboneBranchScenarioArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFishboneIndicatorLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateFishboneItemArgs = {
  completion?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  endOn?: InputMaybe<Scalars['String']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  responsible?: InputMaybe<Scalars['String']['input']>;
  startOn?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFishboneItemBranchArgs = {
  fishboneBranchId: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateFishboneItemScenarioArgs = {
  completion?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateFishboneRiskLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateFishboneStakeLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateFishboneStakeholderLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateIndicatorArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  indicatorCategoryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateIndicatorCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateIndicatorScenarioArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateProjectArgs = {
  analysisSummary?: InputMaybe<Scalars['String']['input']>;
  baselineScenarioDescription?: InputMaybe<Scalars['String']['input']>;
  baselineScenarioImpacts?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionLong?: InputMaybe<Scalars['String']['input']>;
  fishboneDescription?: InputMaybe<Scalars['String']['input']>;
  fishboneEndOn?: InputMaybe<Scalars['String']['input']>;
  fishboneStartOn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impacts?: InputMaybe<Array<InputMaybe<ImpactLevelInput>>>;
  likelihoods?: InputMaybe<Array<InputMaybe<LikelihoodLevelInput>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  responsible?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  vision?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRiskArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impact?: InputMaybe<Scalars['Float']['input']>;
  isOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  likelihood?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  riskCategoryId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRiskCategoryArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateRiskIndicatorImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateRiskOpeningLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateRiskScenarioArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  impact?: InputMaybe<Scalars['Float']['input']>;
  likelihood?: InputMaybe<Scalars['Float']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateRiskStakeImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateScenarioArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impacts?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateStakeArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  evaluatedAt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateStakeIndicatorImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateStakeScenarioArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateStakeholderArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impact?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateStakeholderIndicatorImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateStakeholderLinkStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateStakeholderRiskImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateStakeholderScenarioArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  impact?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  trend?: InputMaybe<Scalars['String']['input']>;
  x?: InputMaybe<Scalars['Float']['input']>;
  y?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateStakeholderStakeImpactStrengthArgs = {
  id: Scalars['ID']['input'];
  strength: Scalars['Int']['input'];
};


export type MutationUpdateTagArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type PricePlan = {
  __typename?: 'PricePlan';
  currency: Scalars['String']['output'];
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['String']['output']>;
  recurring?: Maybe<Scalars['String']['output']>;
  unit_amount?: Maybe<Scalars['Float']['output']>;
};

export type Project = {
  __typename?: 'Project';
  analysisSummary?: Maybe<Scalars['String']['output']>;
  baselineScenarioDescription?: Maybe<Scalars['String']['output']>;
  baselineScenarioImpacts?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionLong?: Maybe<Scalars['String']['output']>;
  fishboneBranchs?: Maybe<Array<Maybe<FishboneBranch>>>;
  fishboneDescription?: Maybe<Scalars['String']['output']>;
  fishboneEndOn?: Maybe<Scalars['String']['output']>;
  fishboneStartOn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impacts?: Maybe<Array<Maybe<ImpactLevel>>>;
  indicatorCategories?: Maybe<Array<Maybe<IndicatorCategory>>>;
  indicators?: Maybe<Array<Maybe<Indicator>>>;
  likelihoods?: Maybe<Array<Maybe<LikelihoodLevel>>>;
  members?: Maybe<Array<Maybe<ProjectMember>>>;
  myRole?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  readerCount?: Maybe<Scalars['Int']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  riskCategories?: Maybe<Array<Maybe<RiskCategory>>>;
  risks?: Maybe<Array<Maybe<Risk>>>;
  scenarios?: Maybe<Array<Maybe<Scenario>>>;
  stakeholders?: Maybe<Array<Maybe<Stakeholder>>>;
  stakes?: Maybe<Array<Maybe<Stake>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  type?: Maybe<Scalars['String']['output']>;
  vision?: Maybe<Scalars['String']['output']>;
};

export type ProjectChange = {
  __typename?: 'ProjectChange';
  field?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type ProjectChangeInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueType?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectChangeSet = {
  __typename?: 'ProjectChangeSet';
  author?: Maybe<Scalars['String']['output']>;
  changes?: Maybe<Scalars['String']['output']>;
  objectId: Scalars['String']['output'];
  operation: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  items?: Maybe<Array<Maybe<Project>>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ProjectMember = {
  __typename?: 'ProjectMember';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedBy?: Maybe<Scalars['String']['output']>;
  invitedEmail: Scalars['String']['output'];
  project?: Maybe<Project>;
  projectId: Scalars['String']['output'];
  role: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type ProjectMessage = {
  __typename?: 'ProjectMessage';
  message: Scalars['String']['output'];
  projectId: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  analyzeSituation?: Maybe<Scalars['Boolean']['output']>;
  askBot: Scalars['Boolean']['output'];
  disambiguateSubject?: Maybe<Scalars['AWSJSON']['output']>;
  generateWatchReport?: Maybe<WatchReport>;
  getComments?: Maybe<Array<Maybe<Comment>>>;
  getMcpAccess?: Maybe<McpAccess>;
  getPrices?: Maybe<Array<Maybe<PricePlan>>>;
  getProject?: Maybe<Project>;
  getSubscriptionStatus?: Maybe<SubscriptionStatus>;
  getWatchReports?: Maybe<Array<Maybe<WatchReport>>>;
  listProjectAttachments?: Maybe<Array<Maybe<Attachment>>>;
  listProjects?: Maybe<ProjectConnection>;
  listSharedProjects?: Maybe<Array<Maybe<ProjectMember>>>;
  previewAiQuery?: Maybe<Scalars['String']['output']>;
  queryProjectsByCreatedByIndex?: Maybe<ProjectConnection>;
  suggestScenarioHypotheses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


export type QueryAnalyzeSituationArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  hypothesis?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['AWSJSON']['input']>;
  projectId: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  scenarios?: InputMaybe<Scalars['AWSJSON']['input']>;
};


export type QueryAskBotArgs = {
  history?: InputMaybe<Scalars['AWSJSON']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['String']['input']>;
  question: Scalars['String']['input'];
  scenarioId?: InputMaybe<Scalars['String']['input']>;
  screen?: InputMaybe<Scalars['String']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDisambiguateSubjectArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type QueryGenerateWatchReportArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};


export type QueryGetCommentsArgs = {
  objectId: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  projectId: Scalars['String']['input'];
};


export type QueryGetPricesArgs = {
  filter?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWatchReportsArgs = {
  projectId: Scalars['String']['input'];
};


export type QueryListProjectAttachmentsArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  tempSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListProjectsArgs = {
  filter?: InputMaybe<TableProjectFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPreviewAiQueryArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  mission?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type QueryQueryProjectsByCreatedByIndexArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySuggestScenarioHypothesesArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['String']['input'];
};

export type Risk = {
  __typename?: 'Risk';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  fishboneLinks?: Maybe<Array<Maybe<FishboneRiskLink>>>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['Float']['output']>;
  impactedIndicators?: Maybe<Array<Maybe<RiskIndicatorImpact>>>;
  impactedStakes?: Maybe<Array<Maybe<RiskStakeImpact>>>;
  isOpportunity?: Maybe<Scalars['Boolean']['output']>;
  likelihood?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  openingLinks?: Maybe<Array<Maybe<RiskOpeningLink>>>;
  reference?: Maybe<Scalars['String']['output']>;
  riskCategoryId?: Maybe<Scalars['String']['output']>;
  scenarios?: Maybe<Array<Maybe<RiskScenarioSimulation>>>;
  taggings?: Maybe<Array<Maybe<Tagging>>>;
};

export type RiskCategory = {
  __typename?: 'RiskCategory';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
};

export type RiskIndicatorImpact = {
  __typename?: 'RiskIndicatorImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorId: Scalars['String']['output'];
  riskId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type RiskOpeningLink = {
  __typename?: 'RiskOpeningLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  openingId: Scalars['String']['output'];
  projectId?: Maybe<Scalars['String']['output']>;
  riskId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type RiskScenarioSimulation = {
  __typename?: 'RiskScenarioSimulation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['Float']['output']>;
  likelihood?: Maybe<Scalars['Float']['output']>;
  scenarioId: Scalars['String']['output'];
};

export type RiskStakeImpact = {
  __typename?: 'RiskStakeImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  riskId: Scalars['String']['output'];
  stakeId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type Scenario = {
  __typename?: 'Scenario';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  impacts?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Stake = {
  __typename?: 'Stake';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  evaluatedAt?: Maybe<Scalars['String']['output']>;
  fishboneLinks?: Maybe<Array<Maybe<FishboneStakeLink>>>;
  id: Scalars['ID']['output'];
  impactedIndicators?: Maybe<Array<Maybe<StakeIndicatorImpact>>>;
  name?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  scenarios?: Maybe<Array<Maybe<StakeScenarioSimulation>>>;
  trend?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type StakeIndicatorImpact = {
  __typename?: 'StakeIndicatorImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorId: Scalars['String']['output'];
  stakeId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type StakeScenarioSimulation = {
  __typename?: 'StakeScenarioSimulation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  scenarioId: Scalars['String']['output'];
  trend?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
};

export type Stakeholder = {
  __typename?: 'Stakeholder';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fishboneLinks?: Maybe<Array<Maybe<FishboneStakeholderLink>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  impactedIndicators?: Maybe<Array<Maybe<StakeholderIndicatorImpact>>>;
  impactedRisks?: Maybe<Array<Maybe<StakeholderRiskImpact>>>;
  impactedStakes?: Maybe<Array<Maybe<StakeholderStakeImpact>>>;
  links?: Maybe<Array<Maybe<StakeholderLink>>>;
  name?: Maybe<Scalars['String']['output']>;
  scenarios?: Maybe<Array<Maybe<StakeholderScenarioSimulation>>>;
  taggings?: Maybe<Array<Maybe<Tagging>>>;
  trend?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type StakeholderBase = {
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type StakeholderBaseFields = StakeholderBase & {
  __typename?: 'StakeholderBaseFields';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  trend?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type StakeholderIconFields = {
  __typename?: 'StakeholderIconFields';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type StakeholderImpactFields = {
  __typename?: 'StakeholderImpactFields';
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
};

export type StakeholderIndicatorImpact = {
  __typename?: 'StakeholderIndicatorImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  indicatorId: Scalars['String']['output'];
  stakeholderId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type StakeholderLink = {
  __typename?: 'StakeholderLink';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
  targetId: Scalars['String']['output'];
};

export type StakeholderPositionFields = {
  __typename?: 'StakeholderPositionFields';
  id: Scalars['ID']['output'];
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type StakeholderRiskImpact = {
  __typename?: 'StakeholderRiskImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  riskId: Scalars['String']['output'];
  stakeholderId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type StakeholderScenarioSimulation = {
  __typename?: 'StakeholderScenarioSimulation';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  scenarioId: Scalars['String']['output'];
  trend?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['Float']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export type StakeholderStakeImpact = {
  __typename?: 'StakeholderStakeImpact';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stakeId: Scalars['String']['output'];
  stakeholderId: Scalars['String']['output'];
  strength?: Maybe<Scalars['Int']['output']>;
};

export type StakeholderTrendFields = {
  __typename?: 'StakeholderTrendFields';
  id: Scalars['ID']['output'];
  trend?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAttachmentStatusChanged?: Maybe<Attachment>;
  onCreateProject?: Maybe<Project>;
  onProjectAnyChange?: Maybe<Project>;
  onProjectChange?: Maybe<ProjectChangeSet>;
  onProjectMessage?: Maybe<ProjectMessage>;
};


export type SubscriptionOnAttachmentStatusChangedArgs = {
  projectId?: InputMaybe<Scalars['String']['input']>;
  tempSessionId?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnProjectChangeArgs = {
  projectId: Scalars['String']['input'];
};


export type SubscriptionOnProjectMessageArgs = {
  projectId: Scalars['String']['input'];
};

export type SubscriptionStatus = {
  __typename?: 'SubscriptionStatus';
  email: Scalars['String']['output'];
  endAt?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  projects?: Maybe<Scalars['Float']['output']>;
  startAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type TableBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TableFloatFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
};

export type TableIdFilterInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
};

export type TableIntFilterInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
};

export type TableProjectFilterInput = {
  createdAt?: InputMaybe<TableStringFilterInput>;
  description?: InputMaybe<TableStringFilterInput>;
  id?: InputMaybe<TableIdFilterInput>;
  name?: InputMaybe<TableStringFilterInput>;
};

export type TableStringFilterInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Tagging = {
  __typename?: 'Tagging';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  objectId: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type WatchReport = {
  __typename?: 'WatchReport';
  completedAt?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  neutralSubject?: Maybe<Scalars['String']['output']>;
  projectId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type AnalyzeSituationQueryVariables = Exact<{
  action?: string | null | undefined;
  hypothesis?: string | null | undefined;
  language?: string | null | undefined;
  params?: string | null | undefined;
  projectId: string;
  query?: string | null | undefined;
  scenarioId?: string | null | undefined;
  scenarios?: string | null | undefined;
}>;


export type AnalyzeSituationQuery = { analyzeSituation: boolean | null };

export type AskBotQueryVariables = Exact<{
  history?: string | null | undefined;
  language?: string | null | undefined;
  projectId?: string | null | undefined;
  question: string;
  scenarioId?: string | null | undefined;
  screen?: string | null | undefined;
  threadId?: string | null | undefined;
}>;


export type AskBotQuery = { askBot: boolean };

export type DisambiguateSubjectQueryVariables = Exact<{
  description?: string | null | undefined;
  language?: string | null | undefined;
  name: string;
}>;


export type DisambiguateSubjectQuery = { disambiguateSubject: string | null };

export type GenerateWatchReportQueryVariables = Exact<{
  context?: string | null | undefined;
  language?: string | null | undefined;
  projectId: string;
}>;


export type GenerateWatchReportQuery = { generateWatchReport: { completedAt: string | null, content: string | null, createdAt: string | null, createdBy: string | null, id: string, language: string | null, neutralSubject: string | null, projectId: string | null, status: string | null, title: string | null } | null };

export type GetCommentsQueryVariables = Exact<{
  objectId: string;
  objectType: string;
  projectId: string;
}>;


export type GetCommentsQuery = { getComments: Array<{ commentedAt: string | null, createdAt: string | null, description: string | null, id: string, objectId: string, objectType: string, projectId: string } | null> | null };

export type GetMcpAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMcpAccessQuery = { getMcpAccess: { endpoint: string | null, token: string | null, info: { createdAt: string, lastUsedAt: string | null, name: string | null, prefix: string, revokedAt: string | null } | null } | null };

export type GetPricesQueryVariables = Exact<{
  filter?: string | null | undefined;
}>;


export type GetPricesQuery = { getPrices: Array<{ currency: string, id: string, metadata: string | null, recurring: string | null, unit_amount: number | null } | null> | null };

export type GetProjectQueryVariables = Exact<{
  id: string | number;
}>;


export type GetProjectQuery = { getProject: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null };

export type GetSubscriptionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionStatusQuery = { getSubscriptionStatus: { email: string, endAt: string | null, features: Array<string | null> | null, projects: number | null, startAt: string | null, status: string | null } | null };

export type GetWatchReportsQueryVariables = Exact<{
  projectId: string;
}>;


export type GetWatchReportsQuery = { getWatchReports: Array<{ completedAt: string | null, content: string | null, createdAt: string | null, createdBy: string | null, id: string, language: string | null, neutralSubject: string | null, projectId: string | null, status: string | null, title: string | null } | null> | null };

export type ListProjectAttachmentsQueryVariables = Exact<{
  projectId?: string | null | undefined;
  tempSessionId?: string | null | undefined;
}>;


export type ListProjectAttachmentsQuery = { listProjectAttachments: Array<{ contentType: string, filename: string, id: string, projectId: string | null, scanError: string | null, size: number, status: string, tempSessionId: string | null, uploadedAt: string } | null> | null };

export type ListProjectsQueryVariables = Exact<{
  filter?: TableProjectFilterInput | null | undefined;
  limit?: number | null | undefined;
  nextToken?: string | null | undefined;
}>;


export type ListProjectsQuery = { listProjects: { nextToken: string | null, items: Array<{ analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null> | null } | null };

export type ListSharedProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListSharedProjectsQuery = { listSharedProjects: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null> | null };

export type PreviewAiQueryQueryVariables = Exact<{
  context?: string | null | undefined;
  description?: string | null | undefined;
  language?: string | null | undefined;
  mission?: string | null | undefined;
  name: string;
}>;


export type PreviewAiQueryQuery = { previewAiQuery: string | null };

export type QueryProjectsByCreatedByIndexQueryVariables = Exact<{
  after?: string | null | undefined;
  first?: number | null | undefined;
}>;


export type QueryProjectsByCreatedByIndexQuery = { queryProjectsByCreatedByIndex: { nextToken: string | null, items: Array<{ analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null> | null } | null };

export type SuggestScenarioHypothesesQueryVariables = Exact<{
  language?: string | null | undefined;
  projectId: string;
}>;


export type SuggestScenarioHypothesesQuery = { suggestScenarioHypotheses: Array<string | null> | null };

export type AddProjectMemberMutationVariables = Exact<{
  email: string;
  locale?: string | null | undefined;
  projectId: string;
  role?: string | null | undefined;
}>;


export type AddProjectMemberMutation = { addProjectMember: { createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null };

export type ClaimAttachmentsMutationVariables = Exact<{
  projectId: string;
  tempSessionId: string;
}>;


export type ClaimAttachmentsMutation = { claimAttachments: string | null };

export type CloneProjectMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  reference?: string | null | undefined;
  type?: string | null | undefined;
}>;


export type CloneProjectMutation = { cloneProject: string | null };

export type ConsumeCodeMutationVariables = Exact<{
  id: string;
}>;


export type ConsumeCodeMutation = { consumeCode: string | null };

export type CreateCommentMutationVariables = Exact<{
  commentedAt: string;
  description: string;
  objectId: string;
  objectType: string;
  projectId: string;
}>;


export type CreateCommentMutation = { createComment: { commentedAt: string | null, createdAt: string | null, description: string | null, id: string, objectId: string, objectType: string, projectId: string } | null };

export type CreateFishboneBranchMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endOn?: string | null | undefined;
  icon?: string | null | undefined;
  name: string;
  projectId: string;
  responsible?: string | null | undefined;
  startOn?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type CreateFishboneBranchMutation = { createFishboneBranch: { createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null };

export type CreateFishboneBranchIndicatorLinkMutationVariables = Exact<{
  fishboneBranchId: string;
  indicatorId: string;
}>;


export type CreateFishboneBranchIndicatorLinkMutation = { createFishboneBranchIndicatorLink: { createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null };

export type CreateFishboneBranchRiskLinkMutationVariables = Exact<{
  fishboneBranchId: string;
  riskId: string;
}>;


export type CreateFishboneBranchRiskLinkMutation = { createFishboneBranchRiskLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null };

export type CreateFishboneBranchStakeLinkMutationVariables = Exact<{
  fishboneBranchId: string;
  stakeId: string;
}>;


export type CreateFishboneBranchStakeLinkMutation = { createFishboneBranchStakeLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null };

export type CreateFishboneBranchStakeholderLinkMutationVariables = Exact<{
  fishboneBranchId: string;
  stakeholderId: string;
}>;


export type CreateFishboneBranchStakeholderLinkMutation = { createFishboneBranchStakeholderLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null };

export type CreateFishboneItemMutationVariables = Exact<{
  completion?: number | null | undefined;
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endOn?: string | null | undefined;
  evaluatedAt?: string | null | undefined;
  fishboneBranchId: string;
  icon?: string | null | undefined;
  name: string;
  responsible?: string | null | undefined;
  startOn?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type CreateFishboneItemMutation = { createFishboneItem: { completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null };

export type CreateFishboneItemIndicatorLinkMutationVariables = Exact<{
  fishboneItemId: string;
  indicatorId: string;
}>;


export type CreateFishboneItemIndicatorLinkMutation = { createFishboneItemIndicatorLink: { createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null };

export type CreateFishboneItemRiskLinkMutationVariables = Exact<{
  fishboneItemId: string;
  riskId: string;
}>;


export type CreateFishboneItemRiskLinkMutation = { createFishboneItemRiskLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null };

export type CreateFishboneItemStakeLinkMutationVariables = Exact<{
  fishboneItemId: string;
  stakeId: string;
}>;


export type CreateFishboneItemStakeLinkMutation = { createFishboneItemStakeLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null };

export type CreateFishboneItemStakeholderLinkMutationVariables = Exact<{
  fishboneItemId: string;
  stakeholderId: string;
}>;


export type CreateFishboneItemStakeholderLinkMutation = { createFishboneItemStakeholderLink: { createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null };

export type CreateIndicatorMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  frequency?: string | null | undefined;
  indicatorCategoryId?: string | null | undefined;
  name: string;
  projectId: string;
  reference?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type CreateIndicatorMutation = { createIndicator: { createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, frequency: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null };

export type CreateIndicatorCategoryMutationVariables = Exact<{
  description?: string | null | undefined;
  name: string;
  projectId: string;
  weight?: number | null | undefined;
}>;


export type CreateIndicatorCategoryMutation = { createIndicatorCategory: { createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null };

export type CreateProjectMutationVariables = Exact<{
  description?: string | null | undefined;
  descriptionLong?: string | null | undefined;
  impacts?: Array<ImpactLevelInput | null | undefined> | ImpactLevelInput | null | undefined;
  likelihoods?: Array<LikelihoodLevelInput | null | undefined> | LikelihoodLevelInput | null | undefined;
  name: string;
  reference?: string | null | undefined;
  type?: string | null | undefined;
  vision?: string | null | undefined;
}>;


export type CreateProjectMutation = { createProject: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null };

export type CreateRiskMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  impact?: number | null | undefined;
  isOpportunity?: boolean | null | undefined;
  likelihood?: number | null | undefined;
  name: string;
  projectId: string;
  reference?: string | null | undefined;
  riskCategoryId?: string | null | undefined;
}>;


export type CreateRiskMutation = { createRisk: { createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null };

export type CreateRiskCategoryMutationVariables = Exact<{
  description?: string | null | undefined;
  name: string;
  projectId: string;
  weight?: number | null | undefined;
}>;


export type CreateRiskCategoryMutation = { createRiskCategory: { createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null };

export type CreateRiskIndicatorImpactMutationVariables = Exact<{
  indicatorId: string;
  riskId: string;
}>;


export type CreateRiskIndicatorImpactMutation = { createRiskIndicatorImpact: { createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null };

export type CreateRiskOpeningLinkMutationVariables = Exact<{
  openingId: string;
  riskId: string;
  strength?: number | null | undefined;
}>;


export type CreateRiskOpeningLinkMutation = { createRiskOpeningLink: { createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null };

export type CreateRiskStakeImpactMutationVariables = Exact<{
  riskId: string;
  stakeId: string;
}>;


export type CreateRiskStakeImpactMutation = { createRiskStakeImpact: { createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null };

export type CreateScenarioMutationVariables = Exact<{
  description?: string | null | undefined;
  impacts?: string | null | undefined;
  name: string;
  projectId: string;
  referenceScenarioId?: string | null | undefined;
}>;


export type CreateScenarioMutation = { createScenario: string | null };

export type CreateStakeMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  name: string;
  projectId: string;
  reference?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type CreateStakeMutation = { createStake: { createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null };

export type CreateStakeIndicatorImpactMutationVariables = Exact<{
  indicatorId: string;
  stakeId: string;
}>;


export type CreateStakeIndicatorImpactMutation = { createStakeIndicatorImpact: { createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null };

export type CreateStakeholderMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  icon?: string | null | undefined;
  impact?: string | null | undefined;
  name: string;
  projectId: string;
  trend?: string | null | undefined;
  x?: number | null | undefined;
  y?: number | null | undefined;
}>;


export type CreateStakeholderMutation = { createStakeholder: { createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null };

export type CreateStakeholderIndicatorImpactMutationVariables = Exact<{
  indicatorId: string;
  stakeholderId: string;
}>;


export type CreateStakeholderIndicatorImpactMutation = { createStakeholderIndicatorImpact: { createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null };

export type CreateStakeholderLinkMutationVariables = Exact<{
  originId: string;
  targetId: string;
}>;


export type CreateStakeholderLinkMutation = { createStakeholderLink: { createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null };

export type CreateStakeholderRiskImpactMutationVariables = Exact<{
  riskId: string;
  stakeholderId: string;
}>;


export type CreateStakeholderRiskImpactMutation = { createStakeholderRiskImpact: { createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null };

export type CreateStakeholderStakeImpactMutationVariables = Exact<{
  stakeId: string;
  stakeholderId: string;
}>;


export type CreateStakeholderStakeImpactMutation = { createStakeholderStakeImpact: { createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null };

export type CreateTagMutationVariables = Exact<{
  description?: string | null | undefined;
  name: string;
  projectId: string;
}>;


export type CreateTagMutation = { createTag: { createdAt: string | null, description: string | null, id: string, name: string | null } | null };

export type CreateTaggingMutationVariables = Exact<{
  objectId: string;
  projectId: string;
  tagId: string;
  type: string;
}>;


export type CreateTaggingMutation = { createTagging: { createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null };

export type DeleteAttachmentMutationVariables = Exact<{
  attachmentId: string | number;
}>;


export type DeleteAttachmentMutation = { deleteAttachment: string | null };

export type DeleteCommentMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteCommentMutation = { deleteComment: boolean | null };

export type DeleteFishboneBranchMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneBranchMutation = { deleteFishboneBranch: boolean | null };

export type DeleteFishboneIndicatorLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneIndicatorLinkMutation = { deleteFishboneIndicatorLink: boolean | null };

export type DeleteFishboneItemMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneItemMutation = { deleteFishboneItem: boolean | null };

export type DeleteFishboneRiskLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneRiskLinkMutation = { deleteFishboneRiskLink: boolean | null };

export type DeleteFishboneStakeLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneStakeLinkMutation = { deleteFishboneStakeLink: boolean | null };

export type DeleteFishboneStakeholderLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteFishboneStakeholderLinkMutation = { deleteFishboneStakeholderLink: boolean | null };

export type DeleteIndicatorMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteIndicatorMutation = { deleteIndicator: boolean | null };

export type DeleteIndicatorCategoryMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteIndicatorCategoryMutation = { deleteIndicatorCategory: boolean | null };

export type DeleteProjectMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteProjectMutation = { deleteProject: boolean | null };

export type DeleteRiskMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRiskMutation = { deleteRisk: boolean | null };

export type DeleteRiskCategoryMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRiskCategoryMutation = { deleteRiskCategory: boolean | null };

export type DeleteRiskIndicatorImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRiskIndicatorImpactMutation = { deleteRiskIndicatorImpact: boolean | null };

export type DeleteRiskOpeningLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRiskOpeningLinkMutation = { deleteRiskOpeningLink: boolean | null };

export type DeleteRiskStakeImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteRiskStakeImpactMutation = { deleteRiskStakeImpact: boolean | null };

export type DeleteScenarioMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteScenarioMutation = { deleteScenario: boolean | null };

export type DeleteStakeMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeMutation = { deleteStake: boolean | null };

export type DeleteStakeIndicatorImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeIndicatorImpactMutation = { deleteStakeIndicatorImpact: boolean | null };

export type DeleteStakeholderMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeholderMutation = { deleteStakeholder: boolean | null };

export type DeleteStakeholderIndicatorImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeholderIndicatorImpactMutation = { deleteStakeholderIndicatorImpact: boolean | null };

export type DeleteStakeholderLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeholderLinkMutation = { deleteStakeholderLink: boolean | null };

export type DeleteStakeholderRiskImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeholderRiskImpactMutation = { deleteStakeholderRiskImpact: boolean | null };

export type DeleteStakeholderStakeImpactMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteStakeholderStakeImpactMutation = { deleteStakeholderStakeImpact: boolean | null };

export type DeleteTagMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteTagMutation = { deleteTag: boolean | null };

export type DeleteTaggingMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteTaggingMutation = { deleteTagging: boolean | null };

export type DeleteWatchReportMutationVariables = Exact<{
  id: string | number;
}>;


export type DeleteWatchReportMutation = { deleteWatchReport: boolean | null };

export type GenerateMcpTokenMutationVariables = Exact<{
  name?: string | null | undefined;
}>;


export type GenerateMcpTokenMutation = { generateMcpToken: { endpoint: string | null, token: string | null, info: { createdAt: string, lastUsedAt: string | null, name: string | null, prefix: string, revokedAt: string | null } | null } | null };

export type GetAssetUrlMutationVariables = Exact<{
  id: string;
}>;


export type GetAssetUrlMutation = { getAssetUrl: string | null };

export type GetCustomerPortalUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerPortalUrlMutation = { getCustomerPortalUrl: string | null };

export type ImportScenarioImpactsMutationVariables = Exact<{
  impacts: string;
  projectId: string;
  scenarioId: string;
}>;


export type ImportScenarioImpactsMutation = { importScenarioImpacts: string | null };

export type MakePaymentMutationVariables = Exact<{
  price: string;
  referer: string;
}>;


export type MakePaymentMutation = { makePayment: string | null };

export type PromoteScenarioAsBaselineMutationVariables = Exact<{
  baselineNewName?: string | null | undefined;
  keepBaselineAsScenario: boolean;
  keepScenario: boolean;
  projectId: string | number;
  scenarioId: string | number;
}>;


export type PromoteScenarioAsBaselineMutation = { promoteScenarioAsBaseline: boolean | null };

export type PublishAttachmentStatusMutationVariables = Exact<{
  input: AttachmentStatusInput;
}>;


export type PublishAttachmentStatusMutation = { publishAttachmentStatus: { contentType: string, filename: string, id: string, projectId: string | null, scanError: string | null, size: number, status: string, tempSessionId: string | null, uploadedAt: string } | null };

export type PublishProjectChangeMutationVariables = Exact<{
  author?: string | null | undefined;
  changes?: string | null | undefined;
  objectId: string;
  operation: string;
  projectId: string;
  type: string;
}>;


export type PublishProjectChangeMutation = { publishProjectChange: { author: string | null, changes: string | null, objectId: string, operation: string, projectId: string, type: string } | null };

export type PublishProjectMessageMutationVariables = Exact<{
  message: string;
  projectId: string;
}>;


export type PublishProjectMessageMutation = { publishProjectMessage: { message: string, projectId: string } | null };

export type RegenerateMcpTokenMutationVariables = Exact<{
  name?: string | null | undefined;
}>;


export type RegenerateMcpTokenMutation = { regenerateMcpToken: { endpoint: string | null, token: string | null, info: { createdAt: string, lastUsedAt: string | null, name: string | null, prefix: string, revokedAt: string | null } | null } | null };

export type RemoveProjectMemberMutationVariables = Exact<{
  id: string | number;
}>;


export type RemoveProjectMemberMutation = { removeProjectMember: boolean | null };

export type RequestAttachmentUploadMutationVariables = Exact<{
  contentType: string;
  filename: string;
  projectId?: string | null | undefined;
  size: number;
  tempSessionId?: string | null | undefined;
}>;


export type RequestAttachmentUploadMutation = { requestAttachmentUpload: string | null };

export type RevokeMcpTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeMcpTokenMutation = { revokeMcpToken: { endpoint: string | null, token: string | null, info: { createdAt: string, lastUsedAt: string | null, name: string | null, prefix: string, revokedAt: string | null } | null } | null };

export type UpdateCommentMutationVariables = Exact<{
  commentedAt: string;
  description: string;
  id: string | number;
}>;


export type UpdateCommentMutation = { updateComment: boolean | null };

export type UpdateFishboneBranchMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endOn?: string | null | undefined;
  evaluatedAt?: string | null | undefined;
  icon?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
  position?: number | null | undefined;
  responsible?: string | null | undefined;
  startOn?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateFishboneBranchMutation = { updateFishboneBranch: boolean | null };

export type UpdateFishboneBranchScenarioMutationVariables = Exact<{
  enabled?: boolean | null | undefined;
  id: string | number;
  scenarioId?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateFishboneBranchScenarioMutation = { updateFishboneBranchScenario: boolean | null };

export type UpdateFishboneIndicatorLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateFishboneIndicatorLinkStrengthMutation = { updateFishboneIndicatorLinkStrength: boolean | null };

export type UpdateFishboneItemMutationVariables = Exact<{
  completion?: number | null | undefined;
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  endOn?: string | null | undefined;
  evaluatedAt?: string | null | undefined;
  icon?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
  position?: number | null | undefined;
  reference?: string | null | undefined;
  responsible?: string | null | undefined;
  startOn?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateFishboneItemMutation = { updateFishboneItem: boolean | null };

export type UpdateFishboneItemBranchMutationVariables = Exact<{
  fishboneBranchId: string;
  id: string | number;
}>;


export type UpdateFishboneItemBranchMutation = { updateFishboneItemBranch: boolean | null };

export type UpdateFishboneItemScenarioMutationVariables = Exact<{
  completion?: number | null | undefined;
  enabled?: boolean | null | undefined;
  id: string | number;
  scenarioId?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateFishboneItemScenarioMutation = { updateFishboneItemScenario: boolean | null };

export type UpdateFishboneRiskLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateFishboneRiskLinkStrengthMutation = { updateFishboneRiskLinkStrength: boolean | null };

export type UpdateFishboneStakeLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateFishboneStakeLinkStrengthMutation = { updateFishboneStakeLinkStrength: boolean | null };

export type UpdateFishboneStakeholderLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateFishboneStakeholderLinkStrengthMutation = { updateFishboneStakeholderLinkStrength: boolean | null };

export type UpdateIndicatorMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  frequency?: string | null | undefined;
  id: string | number;
  indicatorCategoryId?: string | null | undefined;
  name?: string | null | undefined;
  reference?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateIndicatorMutation = { updateIndicator: boolean | null };

export type UpdateIndicatorCategoryMutationVariables = Exact<{
  description?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateIndicatorCategoryMutation = { updateIndicatorCategory: boolean | null };

export type UpdateIndicatorScenarioMutationVariables = Exact<{
  enabled?: boolean | null | undefined;
  id: string | number;
  scenarioId?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateIndicatorScenarioMutation = { updateIndicatorScenario: boolean | null };

export type UpdateProjectMutationVariables = Exact<{
  analysisSummary?: string | null | undefined;
  baselineScenarioDescription?: string | null | undefined;
  baselineScenarioImpacts?: string | null | undefined;
  description?: string | null | undefined;
  descriptionLong?: string | null | undefined;
  fishboneDescription?: string | null | undefined;
  fishboneEndOn?: string | null | undefined;
  fishboneStartOn?: string | null | undefined;
  id: string | number;
  impacts?: Array<ImpactLevelInput | null | undefined> | ImpactLevelInput | null | undefined;
  likelihoods?: Array<LikelihoodLevelInput | null | undefined> | LikelihoodLevelInput | null | undefined;
  name?: string | null | undefined;
  reference?: string | null | undefined;
  responsible?: string | null | undefined;
  type?: string | null | undefined;
  vision?: string | null | undefined;
}>;


export type UpdateProjectMutation = { updateProject: boolean | null };

export type UpdateRiskMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  id: string | number;
  impact?: number | null | undefined;
  isOpportunity?: boolean | null | undefined;
  likelihood?: number | null | undefined;
  name?: string | null | undefined;
  reference?: string | null | undefined;
  riskCategoryId?: string | null | undefined;
}>;


export type UpdateRiskMutation = { updateRisk: boolean | null };

export type UpdateRiskCategoryMutationVariables = Exact<{
  description?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateRiskCategoryMutation = { updateRiskCategory: boolean | null };

export type UpdateRiskIndicatorImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateRiskIndicatorImpactStrengthMutation = { updateRiskIndicatorImpactStrength: boolean | null };

export type UpdateRiskOpeningLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateRiskOpeningLinkStrengthMutation = { updateRiskOpeningLinkStrength: boolean | null };

export type UpdateRiskScenarioMutationVariables = Exact<{
  enabled?: boolean | null | undefined;
  id: string | number;
  impact?: number | null | undefined;
  likelihood?: number | null | undefined;
  scenarioId?: string | null | undefined;
}>;


export type UpdateRiskScenarioMutation = { updateRiskScenario: boolean | null };

export type UpdateRiskStakeImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateRiskStakeImpactStrengthMutation = { updateRiskStakeImpactStrength: boolean | null };

export type UpdateScenarioMutationVariables = Exact<{
  description?: string | null | undefined;
  id: string | number;
  impacts?: string | null | undefined;
  name?: string | null | undefined;
}>;


export type UpdateScenarioMutation = { updateScenario: boolean | null };

export type UpdateStakeMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  evaluatedAt?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
  reference?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateStakeMutation = { updateStake: boolean | null };

export type UpdateStakeIndicatorImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateStakeIndicatorImpactStrengthMutation = { updateStakeIndicatorImpactStrength: boolean | null };

export type UpdateStakeScenarioMutationVariables = Exact<{
  enabled?: boolean | null | undefined;
  id: string | number;
  scenarioId?: string | null | undefined;
  trend?: string | null | undefined;
  weight?: number | null | undefined;
}>;


export type UpdateStakeScenarioMutation = { updateStakeScenario: boolean | null };

export type UpdateStakeholderMutationVariables = Exact<{
  description?: string | null | undefined;
  enabled?: boolean | null | undefined;
  icon?: string | null | undefined;
  id: string | number;
  impact?: string | null | undefined;
  name?: string | null | undefined;
  trend?: string | null | undefined;
  x?: number | null | undefined;
  y?: number | null | undefined;
}>;


export type UpdateStakeholderMutation = { updateStakeholder: boolean | null };

export type UpdateStakeholderIndicatorImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateStakeholderIndicatorImpactStrengthMutation = { updateStakeholderIndicatorImpactStrength: boolean | null };

export type UpdateStakeholderLinkStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateStakeholderLinkStrengthMutation = { updateStakeholderLinkStrength: boolean | null };

export type UpdateStakeholderRiskImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateStakeholderRiskImpactStrengthMutation = { updateStakeholderRiskImpactStrength: boolean | null };

export type UpdateStakeholderScenarioMutationVariables = Exact<{
  enabled?: boolean | null | undefined;
  id: string | number;
  impact?: string | null | undefined;
  scenarioId?: string | null | undefined;
  trend?: string | null | undefined;
  x?: number | null | undefined;
  y?: number | null | undefined;
}>;


export type UpdateStakeholderScenarioMutation = { updateStakeholderScenario: boolean | null };

export type UpdateStakeholderStakeImpactStrengthMutationVariables = Exact<{
  id: string | number;
  strength: number;
}>;


export type UpdateStakeholderStakeImpactStrengthMutation = { updateStakeholderStakeImpactStrength: boolean | null };

export type UpdateTagMutationVariables = Exact<{
  description?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
}>;


export type UpdateTagMutation = { updateTag: boolean | null };

export type OnAttachmentStatusChangedSubscriptionVariables = Exact<{
  projectId?: string | null | undefined;
  tempSessionId?: string | null | undefined;
}>;


export type OnAttachmentStatusChangedSubscription = { onAttachmentStatusChanged: { contentType: string, filename: string, id: string, projectId: string | null, scanError: string | null, size: number, status: string, tempSessionId: string | null, uploadedAt: string } | null };

export type OnCreateProjectSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnCreateProjectSubscription = { onCreateProject: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null };

export type OnProjectAnyChangeSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnProjectAnyChangeSubscription = { onProjectAnyChange: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, items: Array<{ completion: number | null, createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, fishboneBranchId: string, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, trend: string | null, updatedAt: string | null, weight: number | null, indicatorLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ completion: number | null, enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, riskLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, weight: number | null } | null> | null, stakeLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, stakeholderLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, indicatorId: string, nodeType: string, projectId: string | null, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string, project: { analysisSummary: string | null, baselineScenarioDescription: string | null, baselineScenarioImpacts: string | null, createdAt: string | null, description: string | null, descriptionLong: string | null, fishboneDescription: string | null, fishboneEndOn: string | null, fishboneStartOn: string | null, id: string, myRole: string | null, name: string | null, readerCount: number | null, reference: string | null, responsible: string | null, type: string | null, vision: string | null, fishboneBranchs: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, endOn: string | null, evaluatedAt: string | null, icon: string | null, id: string, name: string, position: number | null, reference: string | null, responsible: string | null, startOn: string | null, updatedAt: string | null, weight: number | null } | null> | null, impacts: Array<{ id: string, name: string | null } | null> | null, indicatorCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, indicators: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, indicatorCategoryId: string | null, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, likelihoods: Array<{ id: string, name: string | null } | null> | null, members: Array<{ createdAt: string | null, id: string, invitedBy: string | null, invitedEmail: string, projectId: string, role: string, status: string } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null } | null> | null, riskCategories: Array<{ createdAt: string | null, description: string | null, id: string, name: string, weight: number | null } | null> | null, risks: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, impact: number | null, isOpportunity: boolean | null, likelihood: number | null, name: string, reference: string | null, riskCategoryId: string | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, riskId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, riskId: string, stakeId: string, strength: number | null } | null> | null, openingLinks: Array<{ createdAt: string | null, id: string, openingId: string, projectId: string | null, riskId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: number | null, likelihood: number | null, scenarioId: string } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, scenarios: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, id: string, impacts: string | null, name: string | null } | null> | null, stakeholders: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, icon: string | null, id: string, impact: string | null, name: string | null, trend: string | null, x: number | null, y: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeholderId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeholderId: string, strength: number | null } | null> | null, impactedRisks: Array<{ createdAt: string | null, id: string, riskId: string, stakeholderId: string, strength: number | null } | null> | null, impactedStakes: Array<{ createdAt: string | null, id: string, stakeId: string, stakeholderId: string, strength: number | null } | null> | null, links: Array<{ createdAt: string | null, id: string, originId: string, strength: number | null, targetId: string } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, impact: string | null, scenarioId: string, trend: string | null, x: number | null, y: number | null } | null> | null, taggings: Array<{ createdAt: string | null, id: string, objectId: string, tagId: string, type: string } | null> | null } | null> | null, stakes: Array<{ createdAt: string | null, description: string | null, enabled: boolean | null, evaluatedAt: string | null, id: string, name: string | null, reference: string | null, trend: string | null, weight: number | null, fishboneLinks: Array<{ createdAt: string | null, fishboneNodeId: string, id: string, nodeType: string, projectId: string | null, stakeId: string, strength: number | null } | null> | null, impactedIndicators: Array<{ createdAt: string | null, id: string, indicatorId: string, stakeId: string, strength: number | null } | null> | null, scenarios: Array<{ enabled: boolean | null, id: string, scenarioId: string, trend: string | null, weight: number | null } | null> | null } | null> | null, tags: Array<{ createdAt: string | null, description: string | null, id: string, name: string | null } | null> | null } | null };

export type OnProjectChangeSubscriptionVariables = Exact<{
  projectId: string;
}>;


export type OnProjectChangeSubscription = { onProjectChange: { author: string | null, changes: string | null, objectId: string, operation: string, projectId: string, type: string } | null };

export type OnProjectMessageSubscriptionVariables = Exact<{
  projectId: string;
}>;


export type OnProjectMessageSubscription = { onProjectMessage: { message: string, projectId: string } | null };


export const AnalyzeSituationDocument = gql`
    query AnalyzeSituation($action: String, $hypothesis: String, $language: String, $params: AWSJSON, $projectId: String!, $query: String, $scenarioId: String, $scenarios: AWSJSON) {
  analyzeSituation(
    action: $action
    hypothesis: $hypothesis
    language: $language
    params: $params
    projectId: $projectId
    query: $query
    scenarioId: $scenarioId
    scenarios: $scenarios
  )
}
    `;

/**
 * __useAnalyzeSituationQuery__
 *
 * To run a query within a React component, call `useAnalyzeSituationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnalyzeSituationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnalyzeSituationQuery({
 *   variables: {
 *      action: // value for 'action'
 *      hypothesis: // value for 'hypothesis'
 *      language: // value for 'language'
 *      params: // value for 'params'
 *      projectId: // value for 'projectId'
 *      query: // value for 'query'
 *      scenarioId: // value for 'scenarioId'
 *      scenarios: // value for 'scenarios'
 *   },
 * });
 */
export function useAnalyzeSituationQuery(baseOptions: Apollo.QueryHookOptions<AnalyzeSituationQuery, AnalyzeSituationQueryVariables> & ({ variables: AnalyzeSituationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>(AnalyzeSituationDocument, options);
      }
export function useAnalyzeSituationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>(AnalyzeSituationDocument, options);
        }
// @ts-ignore
export function useAnalyzeSituationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>;
export function useAnalyzeSituationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>): Apollo.UseSuspenseQueryResult<AnalyzeSituationQuery | undefined, AnalyzeSituationQueryVariables>;
export function useAnalyzeSituationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>(AnalyzeSituationDocument, options);
        }
export type AnalyzeSituationQueryHookResult = ReturnType<typeof useAnalyzeSituationQuery>;
export type AnalyzeSituationLazyQueryHookResult = ReturnType<typeof useAnalyzeSituationLazyQuery>;
export type AnalyzeSituationSuspenseQueryHookResult = ReturnType<typeof useAnalyzeSituationSuspenseQuery>;
export type AnalyzeSituationQueryResult = Apollo.QueryResult<AnalyzeSituationQuery, AnalyzeSituationQueryVariables>;
export const AskBotDocument = gql`
    query AskBot($history: AWSJSON, $language: String, $projectId: String, $question: String!, $scenarioId: String, $screen: String, $threadId: String) {
  askBot(
    history: $history
    language: $language
    projectId: $projectId
    question: $question
    scenarioId: $scenarioId
    screen: $screen
    threadId: $threadId
  )
}
    `;

/**
 * __useAskBotQuery__
 *
 * To run a query within a React component, call `useAskBotQuery` and pass it any options that fit your needs.
 * When your component renders, `useAskBotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAskBotQuery({
 *   variables: {
 *      history: // value for 'history'
 *      language: // value for 'language'
 *      projectId: // value for 'projectId'
 *      question: // value for 'question'
 *      scenarioId: // value for 'scenarioId'
 *      screen: // value for 'screen'
 *      threadId: // value for 'threadId'
 *   },
 * });
 */
export function useAskBotQuery(baseOptions: Apollo.QueryHookOptions<AskBotQuery, AskBotQueryVariables> & ({ variables: AskBotQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AskBotQuery, AskBotQueryVariables>(AskBotDocument, options);
      }
export function useAskBotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AskBotQuery, AskBotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AskBotQuery, AskBotQueryVariables>(AskBotDocument, options);
        }
// @ts-ignore
export function useAskBotSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AskBotQuery, AskBotQueryVariables>): Apollo.UseSuspenseQueryResult<AskBotQuery, AskBotQueryVariables>;
export function useAskBotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AskBotQuery, AskBotQueryVariables>): Apollo.UseSuspenseQueryResult<AskBotQuery | undefined, AskBotQueryVariables>;
export function useAskBotSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AskBotQuery, AskBotQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AskBotQuery, AskBotQueryVariables>(AskBotDocument, options);
        }
export type AskBotQueryHookResult = ReturnType<typeof useAskBotQuery>;
export type AskBotLazyQueryHookResult = ReturnType<typeof useAskBotLazyQuery>;
export type AskBotSuspenseQueryHookResult = ReturnType<typeof useAskBotSuspenseQuery>;
export type AskBotQueryResult = Apollo.QueryResult<AskBotQuery, AskBotQueryVariables>;
export const DisambiguateSubjectDocument = gql`
    query DisambiguateSubject($description: String, $language: String, $name: String!) {
  disambiguateSubject(description: $description, language: $language, name: $name)
}
    `;

/**
 * __useDisambiguateSubjectQuery__
 *
 * To run a query within a React component, call `useDisambiguateSubjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useDisambiguateSubjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDisambiguateSubjectQuery({
 *   variables: {
 *      description: // value for 'description'
 *      language: // value for 'language'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useDisambiguateSubjectQuery(baseOptions: Apollo.QueryHookOptions<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables> & ({ variables: DisambiguateSubjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>(DisambiguateSubjectDocument, options);
      }
export function useDisambiguateSubjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>(DisambiguateSubjectDocument, options);
        }
// @ts-ignore
export function useDisambiguateSubjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>): Apollo.UseSuspenseQueryResult<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>;
export function useDisambiguateSubjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>): Apollo.UseSuspenseQueryResult<DisambiguateSubjectQuery | undefined, DisambiguateSubjectQueryVariables>;
export function useDisambiguateSubjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>(DisambiguateSubjectDocument, options);
        }
export type DisambiguateSubjectQueryHookResult = ReturnType<typeof useDisambiguateSubjectQuery>;
export type DisambiguateSubjectLazyQueryHookResult = ReturnType<typeof useDisambiguateSubjectLazyQuery>;
export type DisambiguateSubjectSuspenseQueryHookResult = ReturnType<typeof useDisambiguateSubjectSuspenseQuery>;
export type DisambiguateSubjectQueryResult = Apollo.QueryResult<DisambiguateSubjectQuery, DisambiguateSubjectQueryVariables>;
export const GenerateWatchReportDocument = gql`
    query GenerateWatchReport($context: String, $language: String, $projectId: String!) {
  generateWatchReport(
    context: $context
    language: $language
    projectId: $projectId
  ) {
    completedAt
    content
    createdAt
    createdBy
    id
    language
    neutralSubject
    projectId
    status
    title
  }
}
    `;

/**
 * __useGenerateWatchReportQuery__
 *
 * To run a query within a React component, call `useGenerateWatchReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenerateWatchReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGenerateWatchReportQuery({
 *   variables: {
 *      context: // value for 'context'
 *      language: // value for 'language'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGenerateWatchReportQuery(baseOptions: Apollo.QueryHookOptions<GenerateWatchReportQuery, GenerateWatchReportQueryVariables> & ({ variables: GenerateWatchReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>(GenerateWatchReportDocument, options);
      }
export function useGenerateWatchReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>(GenerateWatchReportDocument, options);
        }
// @ts-ignore
export function useGenerateWatchReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>): Apollo.UseSuspenseQueryResult<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>;
export function useGenerateWatchReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>): Apollo.UseSuspenseQueryResult<GenerateWatchReportQuery | undefined, GenerateWatchReportQueryVariables>;
export function useGenerateWatchReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>(GenerateWatchReportDocument, options);
        }
export type GenerateWatchReportQueryHookResult = ReturnType<typeof useGenerateWatchReportQuery>;
export type GenerateWatchReportLazyQueryHookResult = ReturnType<typeof useGenerateWatchReportLazyQuery>;
export type GenerateWatchReportSuspenseQueryHookResult = ReturnType<typeof useGenerateWatchReportSuspenseQuery>;
export type GenerateWatchReportQueryResult = Apollo.QueryResult<GenerateWatchReportQuery, GenerateWatchReportQueryVariables>;
export const GetCommentsDocument = gql`
    query GetComments($objectId: String!, $objectType: String!, $projectId: String!) {
  getComments(objectId: $objectId, objectType: $objectType, projectId: $projectId) {
    commentedAt
    createdAt
    description
    id
    objectId
    objectType
    projectId
  }
}
    `;

/**
 * __useGetCommentsQuery__
 *
 * To run a query within a React component, call `useGetCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsQuery({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      objectType: // value for 'objectType'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables> & ({ variables: GetCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
      }
export function useGetCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
// @ts-ignore
export function useGetCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export function useGetCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCommentsQuery | undefined, GetCommentsQueryVariables>;
export function useGetCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCommentsQuery, GetCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCommentsQuery, GetCommentsQueryVariables>(GetCommentsDocument, options);
        }
export type GetCommentsQueryHookResult = ReturnType<typeof useGetCommentsQuery>;
export type GetCommentsLazyQueryHookResult = ReturnType<typeof useGetCommentsLazyQuery>;
export type GetCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCommentsSuspenseQuery>;
export type GetCommentsQueryResult = Apollo.QueryResult<GetCommentsQuery, GetCommentsQueryVariables>;
export const GetMcpAccessDocument = gql`
    query GetMcpAccess {
  getMcpAccess {
    endpoint
    info {
      createdAt
      lastUsedAt
      name
      prefix
      revokedAt
    }
    token
  }
}
    `;

/**
 * __useGetMcpAccessQuery__
 *
 * To run a query within a React component, call `useGetMcpAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMcpAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMcpAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMcpAccessQuery(baseOptions?: Apollo.QueryHookOptions<GetMcpAccessQuery, GetMcpAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMcpAccessQuery, GetMcpAccessQueryVariables>(GetMcpAccessDocument, options);
      }
export function useGetMcpAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMcpAccessQuery, GetMcpAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMcpAccessQuery, GetMcpAccessQueryVariables>(GetMcpAccessDocument, options);
        }
// @ts-ignore
export function useGetMcpAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMcpAccessQuery, GetMcpAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpAccessQuery, GetMcpAccessQueryVariables>;
export function useGetMcpAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpAccessQuery, GetMcpAccessQueryVariables>): Apollo.UseSuspenseQueryResult<GetMcpAccessQuery | undefined, GetMcpAccessQueryVariables>;
export function useGetMcpAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMcpAccessQuery, GetMcpAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMcpAccessQuery, GetMcpAccessQueryVariables>(GetMcpAccessDocument, options);
        }
export type GetMcpAccessQueryHookResult = ReturnType<typeof useGetMcpAccessQuery>;
export type GetMcpAccessLazyQueryHookResult = ReturnType<typeof useGetMcpAccessLazyQuery>;
export type GetMcpAccessSuspenseQueryHookResult = ReturnType<typeof useGetMcpAccessSuspenseQuery>;
export type GetMcpAccessQueryResult = Apollo.QueryResult<GetMcpAccessQuery, GetMcpAccessQueryVariables>;
export const GetPricesDocument = gql`
    query GetPrices($filter: String) {
  getPrices(filter: $filter) {
    currency
    id
    metadata
    recurring
    unit_amount
  }
}
    `;

/**
 * __useGetPricesQuery__
 *
 * To run a query within a React component, call `useGetPricesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPricesQuery(baseOptions?: Apollo.QueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
      }
export function useGetPricesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
// @ts-ignore
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPricesQuery, GetPricesQueryVariables>;
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>): Apollo.UseSuspenseQueryResult<GetPricesQuery | undefined, GetPricesQueryVariables>;
export function useGetPricesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPricesQuery, GetPricesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPricesQuery, GetPricesQueryVariables>(GetPricesDocument, options);
        }
export type GetPricesQueryHookResult = ReturnType<typeof useGetPricesQuery>;
export type GetPricesLazyQueryHookResult = ReturnType<typeof useGetPricesLazyQuery>;
export type GetPricesSuspenseQueryHookResult = ReturnType<typeof useGetPricesSuspenseQuery>;
export type GetPricesQueryResult = Apollo.QueryResult<GetPricesQuery, GetPricesQueryVariables>;
export const GetProjectDocument = gql`
    query GetProject($id: ID!) {
  getProject(id: $id) {
    analysisSummary
    baselineScenarioDescription
    baselineScenarioImpacts
    createdAt
    description
    descriptionLong
    fishboneBranchs {
      createdAt
      description
      enabled
      endOn
      evaluatedAt
      icon
      id
      indicatorLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      items {
        completion
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        fishboneBranchId
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          completion
          enabled
          id
          scenarioId
          trend
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        trend
        updatedAt
        weight
      }
      name
      position
      reference
      responsible
      riskLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      scenarios {
        enabled
        id
        scenarioId
        weight
      }
      stakeLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      stakeholderLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      startOn
      updatedAt
      weight
    }
    fishboneDescription
    fishboneEndOn
    fishboneStartOn
    id
    impacts {
      id
      name
    }
    indicatorCategories {
      createdAt
      description
      id
      name
      weight
    }
    indicators {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      id
      indicatorCategoryId
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    likelihoods {
      id
      name
    }
    members {
      createdAt
      id
      invitedBy
      invitedEmail
      project {
        analysisSummary
        baselineScenarioDescription
        baselineScenarioImpacts
        createdAt
        description
        descriptionLong
        fishboneBranchs {
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          icon
          id
          name
          position
          reference
          responsible
          startOn
          updatedAt
          weight
        }
        fishboneDescription
        fishboneEndOn
        fishboneStartOn
        id
        impacts {
          id
          name
        }
        indicatorCategories {
          createdAt
          description
          id
          name
          weight
        }
        indicators {
          createdAt
          description
          enabled
          evaluatedAt
          id
          indicatorCategoryId
          name
          reference
          trend
          weight
        }
        likelihoods {
          id
          name
        }
        members {
          createdAt
          id
          invitedBy
          invitedEmail
          projectId
          role
          status
        }
        myRole
        name
        readerCount
        reference
        responsible
        riskCategories {
          createdAt
          description
          id
          name
          weight
        }
        risks {
          createdAt
          description
          enabled
          evaluatedAt
          id
          impact
          isOpportunity
          likelihood
          name
          reference
          riskCategoryId
        }
        scenarios {
          createdAt
          description
          enabled
          id
          impacts
          name
        }
        stakeholders {
          createdAt
          description
          enabled
          icon
          id
          impact
          name
          trend
          x
          y
        }
        stakes {
          createdAt
          description
          enabled
          evaluatedAt
          id
          name
          reference
          trend
          weight
        }
        tags {
          createdAt
          description
          id
          name
        }
        type
        vision
      }
      projectId
      role
      status
    }
    myRole
    name
    readerCount
    reference
    responsible
    riskCategories {
      createdAt
      description
      id
      name
      weight
    }
    risks {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        riskId
        strength
      }
      impactedStakes {
        createdAt
        id
        riskId
        stakeId
        strength
      }
      isOpportunity
      likelihood
      name
      openingLinks {
        createdAt
        id
        openingId
        projectId
        riskId
        strength
      }
      reference
      riskCategoryId
      scenarios {
        enabled
        id
        impact
        likelihood
        scenarioId
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
    }
    scenarios {
      createdAt
      description
      enabled
      id
      impacts
      name
    }
    stakeholders {
      createdAt
      description
      enabled
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      icon
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeholderId
        strength
      }
      impactedRisks {
        createdAt
        id
        riskId
        stakeholderId
        strength
      }
      impactedStakes {
        createdAt
        id
        stakeId
        stakeholderId
        strength
      }
      links {
        createdAt
        id
        originId
        strength
        targetId
      }
      name
      scenarios {
        enabled
        id
        impact
        scenarioId
        trend
        x
        y
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
      trend
      x
      y
    }
    stakes {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      id
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeId
        strength
      }
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    tags {
      createdAt
      description
      id
      name
    }
    type
    vision
  }
}
    `;

/**
 * __useGetProjectQuery__
 *
 * To run a query within a React component, call `useGetProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectQuery(baseOptions: Apollo.QueryHookOptions<GetProjectQuery, GetProjectQueryVariables> & ({ variables: GetProjectQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
      }
export function useGetProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
// @ts-ignore
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>): Apollo.UseSuspenseQueryResult<GetProjectQuery | undefined, GetProjectQueryVariables>;
export function useGetProjectSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProjectQuery, GetProjectQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProjectQuery, GetProjectQueryVariables>(GetProjectDocument, options);
        }
export type GetProjectQueryHookResult = ReturnType<typeof useGetProjectQuery>;
export type GetProjectLazyQueryHookResult = ReturnType<typeof useGetProjectLazyQuery>;
export type GetProjectSuspenseQueryHookResult = ReturnType<typeof useGetProjectSuspenseQuery>;
export type GetProjectQueryResult = Apollo.QueryResult<GetProjectQuery, GetProjectQueryVariables>;
export const GetSubscriptionStatusDocument = gql`
    query GetSubscriptionStatus {
  getSubscriptionStatus {
    email
    endAt
    features
    projects
    startAt
    status
  }
}
    `;

/**
 * __useGetSubscriptionStatusQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>(GetSubscriptionStatusDocument, options);
      }
export function useGetSubscriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>(GetSubscriptionStatusDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>;
export function useGetSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionStatusQuery | undefined, GetSubscriptionStatusQueryVariables>;
export function useGetSubscriptionStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>(GetSubscriptionStatusDocument, options);
        }
export type GetSubscriptionStatusQueryHookResult = ReturnType<typeof useGetSubscriptionStatusQuery>;
export type GetSubscriptionStatusLazyQueryHookResult = ReturnType<typeof useGetSubscriptionStatusLazyQuery>;
export type GetSubscriptionStatusSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionStatusSuspenseQuery>;
export type GetSubscriptionStatusQueryResult = Apollo.QueryResult<GetSubscriptionStatusQuery, GetSubscriptionStatusQueryVariables>;
export const GetWatchReportsDocument = gql`
    query GetWatchReports($projectId: String!) {
  getWatchReports(projectId: $projectId) {
    completedAt
    content
    createdAt
    createdBy
    id
    language
    neutralSubject
    projectId
    status
    title
  }
}
    `;

/**
 * __useGetWatchReportsQuery__
 *
 * To run a query within a React component, call `useGetWatchReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWatchReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWatchReportsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetWatchReportsQuery(baseOptions: Apollo.QueryHookOptions<GetWatchReportsQuery, GetWatchReportsQueryVariables> & ({ variables: GetWatchReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWatchReportsQuery, GetWatchReportsQueryVariables>(GetWatchReportsDocument, options);
      }
export function useGetWatchReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWatchReportsQuery, GetWatchReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWatchReportsQuery, GetWatchReportsQueryVariables>(GetWatchReportsDocument, options);
        }
// @ts-ignore
export function useGetWatchReportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWatchReportsQuery, GetWatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWatchReportsQuery, GetWatchReportsQueryVariables>;
export function useGetWatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWatchReportsQuery, GetWatchReportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWatchReportsQuery | undefined, GetWatchReportsQueryVariables>;
export function useGetWatchReportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWatchReportsQuery, GetWatchReportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWatchReportsQuery, GetWatchReportsQueryVariables>(GetWatchReportsDocument, options);
        }
export type GetWatchReportsQueryHookResult = ReturnType<typeof useGetWatchReportsQuery>;
export type GetWatchReportsLazyQueryHookResult = ReturnType<typeof useGetWatchReportsLazyQuery>;
export type GetWatchReportsSuspenseQueryHookResult = ReturnType<typeof useGetWatchReportsSuspenseQuery>;
export type GetWatchReportsQueryResult = Apollo.QueryResult<GetWatchReportsQuery, GetWatchReportsQueryVariables>;
export const ListProjectAttachmentsDocument = gql`
    query ListProjectAttachments($projectId: String, $tempSessionId: String) {
  listProjectAttachments(projectId: $projectId, tempSessionId: $tempSessionId) {
    contentType
    filename
    id
    projectId
    scanError
    size
    status
    tempSessionId
    uploadedAt
  }
}
    `;

/**
 * __useListProjectAttachmentsQuery__
 *
 * To run a query within a React component, call `useListProjectAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectAttachmentsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tempSessionId: // value for 'tempSessionId'
 *   },
 * });
 */
export function useListProjectAttachmentsQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>(ListProjectAttachmentsDocument, options);
      }
export function useListProjectAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>(ListProjectAttachmentsDocument, options);
        }
// @ts-ignore
export function useListProjectAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>;
export function useListProjectAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProjectAttachmentsQuery | undefined, ListProjectAttachmentsQueryVariables>;
export function useListProjectAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>(ListProjectAttachmentsDocument, options);
        }
export type ListProjectAttachmentsQueryHookResult = ReturnType<typeof useListProjectAttachmentsQuery>;
export type ListProjectAttachmentsLazyQueryHookResult = ReturnType<typeof useListProjectAttachmentsLazyQuery>;
export type ListProjectAttachmentsSuspenseQueryHookResult = ReturnType<typeof useListProjectAttachmentsSuspenseQuery>;
export type ListProjectAttachmentsQueryResult = Apollo.QueryResult<ListProjectAttachmentsQuery, ListProjectAttachmentsQueryVariables>;
export const ListProjectsDocument = gql`
    query ListProjects($filter: TableProjectFilterInput, $limit: Int, $nextToken: String) {
  listProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      analysisSummary
      baselineScenarioDescription
      baselineScenarioImpacts
      createdAt
      description
      descriptionLong
      fishboneBranchs {
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        items {
          completion
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          fishboneBranchId
          icon
          id
          name
          position
          reference
          responsible
          startOn
          trend
          updatedAt
          weight
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          enabled
          id
          scenarioId
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        updatedAt
        weight
      }
      fishboneDescription
      fishboneEndOn
      fishboneStartOn
      id
      impacts {
        id
        name
      }
      indicatorCategories {
        createdAt
        description
        id
        name
        weight
      }
      indicators {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        id
        indicatorCategoryId
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      likelihoods {
        id
        name
      }
      members {
        createdAt
        id
        invitedBy
        invitedEmail
        project {
          analysisSummary
          baselineScenarioDescription
          baselineScenarioImpacts
          createdAt
          description
          descriptionLong
          fishboneDescription
          fishboneEndOn
          fishboneStartOn
          id
          myRole
          name
          readerCount
          reference
          responsible
          type
          vision
        }
        projectId
        role
        status
      }
      myRole
      name
      readerCount
      reference
      responsible
      riskCategories {
        createdAt
        description
        id
        name
        weight
      }
      risks {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          riskId
          strength
        }
        impactedStakes {
          createdAt
          id
          riskId
          stakeId
          strength
        }
        isOpportunity
        likelihood
        name
        openingLinks {
          createdAt
          id
          openingId
          projectId
          riskId
          strength
        }
        reference
        riskCategoryId
        scenarios {
          enabled
          id
          impact
          likelihood
          scenarioId
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
      }
      scenarios {
        createdAt
        description
        enabled
        id
        impacts
        name
      }
      stakeholders {
        createdAt
        description
        enabled
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        icon
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeholderId
          strength
        }
        impactedRisks {
          createdAt
          id
          riskId
          stakeholderId
          strength
        }
        impactedStakes {
          createdAt
          id
          stakeId
          stakeholderId
          strength
        }
        links {
          createdAt
          id
          originId
          strength
          targetId
        }
        name
        scenarios {
          enabled
          id
          impact
          scenarioId
          trend
          x
          y
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
        trend
        x
        y
      }
      stakes {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        id
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeId
          strength
        }
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      tags {
        createdAt
        description
        id
        name
      }
      type
      vision
    }
    nextToken
  }
}
    `;

/**
 * __useListProjectsQuery__
 *
 * To run a query within a React component, call `useListProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      limit: // value for 'limit'
 *      nextToken: // value for 'nextToken'
 *   },
 * });
 */
export function useListProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
      }
export function useListProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
        }
// @ts-ignore
export function useListProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export function useListProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ListProjectsQuery | undefined, ListProjectsQueryVariables>;
export function useListProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListProjectsQuery, ListProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListProjectsQuery, ListProjectsQueryVariables>(ListProjectsDocument, options);
        }
export type ListProjectsQueryHookResult = ReturnType<typeof useListProjectsQuery>;
export type ListProjectsLazyQueryHookResult = ReturnType<typeof useListProjectsLazyQuery>;
export type ListProjectsSuspenseQueryHookResult = ReturnType<typeof useListProjectsSuspenseQuery>;
export type ListProjectsQueryResult = Apollo.QueryResult<ListProjectsQuery, ListProjectsQueryVariables>;
export const ListSharedProjectsDocument = gql`
    query ListSharedProjects {
  listSharedProjects {
    createdAt
    id
    invitedBy
    invitedEmail
    project {
      analysisSummary
      baselineScenarioDescription
      baselineScenarioImpacts
      createdAt
      description
      descriptionLong
      fishboneBranchs {
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        items {
          completion
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          fishboneBranchId
          icon
          id
          name
          position
          reference
          responsible
          startOn
          trend
          updatedAt
          weight
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          enabled
          id
          scenarioId
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        updatedAt
        weight
      }
      fishboneDescription
      fishboneEndOn
      fishboneStartOn
      id
      impacts {
        id
        name
      }
      indicatorCategories {
        createdAt
        description
        id
        name
        weight
      }
      indicators {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        id
        indicatorCategoryId
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      likelihoods {
        id
        name
      }
      members {
        createdAt
        id
        invitedBy
        invitedEmail
        project {
          analysisSummary
          baselineScenarioDescription
          baselineScenarioImpacts
          createdAt
          description
          descriptionLong
          fishboneDescription
          fishboneEndOn
          fishboneStartOn
          id
          myRole
          name
          readerCount
          reference
          responsible
          type
          vision
        }
        projectId
        role
        status
      }
      myRole
      name
      readerCount
      reference
      responsible
      riskCategories {
        createdAt
        description
        id
        name
        weight
      }
      risks {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          riskId
          strength
        }
        impactedStakes {
          createdAt
          id
          riskId
          stakeId
          strength
        }
        isOpportunity
        likelihood
        name
        openingLinks {
          createdAt
          id
          openingId
          projectId
          riskId
          strength
        }
        reference
        riskCategoryId
        scenarios {
          enabled
          id
          impact
          likelihood
          scenarioId
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
      }
      scenarios {
        createdAt
        description
        enabled
        id
        impacts
        name
      }
      stakeholders {
        createdAt
        description
        enabled
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        icon
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeholderId
          strength
        }
        impactedRisks {
          createdAt
          id
          riskId
          stakeholderId
          strength
        }
        impactedStakes {
          createdAt
          id
          stakeId
          stakeholderId
          strength
        }
        links {
          createdAt
          id
          originId
          strength
          targetId
        }
        name
        scenarios {
          enabled
          id
          impact
          scenarioId
          trend
          x
          y
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
        trend
        x
        y
      }
      stakes {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        id
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeId
          strength
        }
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      tags {
        createdAt
        description
        id
        name
      }
      type
      vision
    }
    projectId
    role
    status
  }
}
    `;

/**
 * __useListSharedProjectsQuery__
 *
 * To run a query within a React component, call `useListSharedProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSharedProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSharedProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListSharedProjectsQuery(baseOptions?: Apollo.QueryHookOptions<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>(ListSharedProjectsDocument, options);
      }
export function useListSharedProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>(ListSharedProjectsDocument, options);
        }
// @ts-ignore
export function useListSharedProjectsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>;
export function useListSharedProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>): Apollo.UseSuspenseQueryResult<ListSharedProjectsQuery | undefined, ListSharedProjectsQueryVariables>;
export function useListSharedProjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>(ListSharedProjectsDocument, options);
        }
export type ListSharedProjectsQueryHookResult = ReturnType<typeof useListSharedProjectsQuery>;
export type ListSharedProjectsLazyQueryHookResult = ReturnType<typeof useListSharedProjectsLazyQuery>;
export type ListSharedProjectsSuspenseQueryHookResult = ReturnType<typeof useListSharedProjectsSuspenseQuery>;
export type ListSharedProjectsQueryResult = Apollo.QueryResult<ListSharedProjectsQuery, ListSharedProjectsQueryVariables>;
export const PreviewAiQueryDocument = gql`
    query PreviewAiQuery($context: String, $description: String, $language: String, $mission: String, $name: String!) {
  previewAiQuery(
    context: $context
    description: $description
    language: $language
    mission: $mission
    name: $name
  )
}
    `;

/**
 * __usePreviewAiQueryQuery__
 *
 * To run a query within a React component, call `usePreviewAiQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewAiQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewAiQueryQuery({
 *   variables: {
 *      context: // value for 'context'
 *      description: // value for 'description'
 *      language: // value for 'language'
 *      mission: // value for 'mission'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePreviewAiQueryQuery(baseOptions: Apollo.QueryHookOptions<PreviewAiQueryQuery, PreviewAiQueryQueryVariables> & ({ variables: PreviewAiQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>(PreviewAiQueryDocument, options);
      }
export function usePreviewAiQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>(PreviewAiQueryDocument, options);
        }
// @ts-ignore
export function usePreviewAiQuerySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>;
export function usePreviewAiQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewAiQueryQuery | undefined, PreviewAiQueryQueryVariables>;
export function usePreviewAiQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>(PreviewAiQueryDocument, options);
        }
export type PreviewAiQueryQueryHookResult = ReturnType<typeof usePreviewAiQueryQuery>;
export type PreviewAiQueryLazyQueryHookResult = ReturnType<typeof usePreviewAiQueryLazyQuery>;
export type PreviewAiQuerySuspenseQueryHookResult = ReturnType<typeof usePreviewAiQuerySuspenseQuery>;
export type PreviewAiQueryQueryResult = Apollo.QueryResult<PreviewAiQueryQuery, PreviewAiQueryQueryVariables>;
export const QueryProjectsByCreatedByIndexDocument = gql`
    query QueryProjectsByCreatedByIndex($after: String, $first: Int) {
  queryProjectsByCreatedByIndex(after: $after, first: $first) {
    items {
      analysisSummary
      baselineScenarioDescription
      baselineScenarioImpacts
      createdAt
      description
      descriptionLong
      fishboneBranchs {
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        items {
          completion
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          fishboneBranchId
          icon
          id
          name
          position
          reference
          responsible
          startOn
          trend
          updatedAt
          weight
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          enabled
          id
          scenarioId
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        updatedAt
        weight
      }
      fishboneDescription
      fishboneEndOn
      fishboneStartOn
      id
      impacts {
        id
        name
      }
      indicatorCategories {
        createdAt
        description
        id
        name
        weight
      }
      indicators {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        id
        indicatorCategoryId
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      likelihoods {
        id
        name
      }
      members {
        createdAt
        id
        invitedBy
        invitedEmail
        project {
          analysisSummary
          baselineScenarioDescription
          baselineScenarioImpacts
          createdAt
          description
          descriptionLong
          fishboneDescription
          fishboneEndOn
          fishboneStartOn
          id
          myRole
          name
          readerCount
          reference
          responsible
          type
          vision
        }
        projectId
        role
        status
      }
      myRole
      name
      readerCount
      reference
      responsible
      riskCategories {
        createdAt
        description
        id
        name
        weight
      }
      risks {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          riskId
          strength
        }
        impactedStakes {
          createdAt
          id
          riskId
          stakeId
          strength
        }
        isOpportunity
        likelihood
        name
        openingLinks {
          createdAt
          id
          openingId
          projectId
          riskId
          strength
        }
        reference
        riskCategoryId
        scenarios {
          enabled
          id
          impact
          likelihood
          scenarioId
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
      }
      scenarios {
        createdAt
        description
        enabled
        id
        impacts
        name
      }
      stakeholders {
        createdAt
        description
        enabled
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        icon
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeholderId
          strength
        }
        impactedRisks {
          createdAt
          id
          riskId
          stakeholderId
          strength
        }
        impactedStakes {
          createdAt
          id
          stakeId
          stakeholderId
          strength
        }
        links {
          createdAt
          id
          originId
          strength
          targetId
        }
        name
        scenarios {
          enabled
          id
          impact
          scenarioId
          trend
          x
          y
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
        trend
        x
        y
      }
      stakes {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        id
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeId
          strength
        }
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      tags {
        createdAt
        description
        id
        name
      }
      type
      vision
    }
    nextToken
  }
}
    `;

/**
 * __useQueryProjectsByCreatedByIndexQuery__
 *
 * To run a query within a React component, call `useQueryProjectsByCreatedByIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryProjectsByCreatedByIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryProjectsByCreatedByIndexQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useQueryProjectsByCreatedByIndexQuery(baseOptions?: Apollo.QueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>(QueryProjectsByCreatedByIndexDocument, options);
      }
export function useQueryProjectsByCreatedByIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>(QueryProjectsByCreatedByIndexDocument, options);
        }
// @ts-ignore
export function useQueryProjectsByCreatedByIndexSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>): Apollo.UseSuspenseQueryResult<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>;
export function useQueryProjectsByCreatedByIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>): Apollo.UseSuspenseQueryResult<QueryProjectsByCreatedByIndexQuery | undefined, QueryProjectsByCreatedByIndexQueryVariables>;
export function useQueryProjectsByCreatedByIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>(QueryProjectsByCreatedByIndexDocument, options);
        }
export type QueryProjectsByCreatedByIndexQueryHookResult = ReturnType<typeof useQueryProjectsByCreatedByIndexQuery>;
export type QueryProjectsByCreatedByIndexLazyQueryHookResult = ReturnType<typeof useQueryProjectsByCreatedByIndexLazyQuery>;
export type QueryProjectsByCreatedByIndexSuspenseQueryHookResult = ReturnType<typeof useQueryProjectsByCreatedByIndexSuspenseQuery>;
export type QueryProjectsByCreatedByIndexQueryResult = Apollo.QueryResult<QueryProjectsByCreatedByIndexQuery, QueryProjectsByCreatedByIndexQueryVariables>;
export const SuggestScenarioHypothesesDocument = gql`
    query SuggestScenarioHypotheses($language: String, $projectId: String!) {
  suggestScenarioHypotheses(language: $language, projectId: $projectId)
}
    `;

/**
 * __useSuggestScenarioHypothesesQuery__
 *
 * To run a query within a React component, call `useSuggestScenarioHypothesesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestScenarioHypothesesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestScenarioHypothesesQuery({
 *   variables: {
 *      language: // value for 'language'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuggestScenarioHypothesesQuery(baseOptions: Apollo.QueryHookOptions<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables> & ({ variables: SuggestScenarioHypothesesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>(SuggestScenarioHypothesesDocument, options);
      }
export function useSuggestScenarioHypothesesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>(SuggestScenarioHypothesesDocument, options);
        }
// @ts-ignore
export function useSuggestScenarioHypothesesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>;
export function useSuggestScenarioHypothesesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestScenarioHypothesesQuery | undefined, SuggestScenarioHypothesesQueryVariables>;
export function useSuggestScenarioHypothesesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>(SuggestScenarioHypothesesDocument, options);
        }
export type SuggestScenarioHypothesesQueryHookResult = ReturnType<typeof useSuggestScenarioHypothesesQuery>;
export type SuggestScenarioHypothesesLazyQueryHookResult = ReturnType<typeof useSuggestScenarioHypothesesLazyQuery>;
export type SuggestScenarioHypothesesSuspenseQueryHookResult = ReturnType<typeof useSuggestScenarioHypothesesSuspenseQuery>;
export type SuggestScenarioHypothesesQueryResult = Apollo.QueryResult<SuggestScenarioHypothesesQuery, SuggestScenarioHypothesesQueryVariables>;
export const AddProjectMemberDocument = gql`
    mutation AddProjectMember($email: String!, $locale: String, $projectId: String!, $role: String) {
  addProjectMember(
    email: $email
    locale: $locale
    projectId: $projectId
    role: $role
  ) {
    createdAt
    id
    invitedBy
    invitedEmail
    project {
      analysisSummary
      baselineScenarioDescription
      baselineScenarioImpacts
      createdAt
      description
      descriptionLong
      fishboneBranchs {
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        items {
          completion
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          fishboneBranchId
          icon
          id
          name
          position
          reference
          responsible
          startOn
          trend
          updatedAt
          weight
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          enabled
          id
          scenarioId
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        updatedAt
        weight
      }
      fishboneDescription
      fishboneEndOn
      fishboneStartOn
      id
      impacts {
        id
        name
      }
      indicatorCategories {
        createdAt
        description
        id
        name
        weight
      }
      indicators {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        id
        indicatorCategoryId
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      likelihoods {
        id
        name
      }
      members {
        createdAt
        id
        invitedBy
        invitedEmail
        project {
          analysisSummary
          baselineScenarioDescription
          baselineScenarioImpacts
          createdAt
          description
          descriptionLong
          fishboneDescription
          fishboneEndOn
          fishboneStartOn
          id
          myRole
          name
          readerCount
          reference
          responsible
          type
          vision
        }
        projectId
        role
        status
      }
      myRole
      name
      readerCount
      reference
      responsible
      riskCategories {
        createdAt
        description
        id
        name
        weight
      }
      risks {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          riskId
          strength
        }
        impactedStakes {
          createdAt
          id
          riskId
          stakeId
          strength
        }
        isOpportunity
        likelihood
        name
        openingLinks {
          createdAt
          id
          openingId
          projectId
          riskId
          strength
        }
        reference
        riskCategoryId
        scenarios {
          enabled
          id
          impact
          likelihood
          scenarioId
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
      }
      scenarios {
        createdAt
        description
        enabled
        id
        impacts
        name
      }
      stakeholders {
        createdAt
        description
        enabled
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        icon
        id
        impact
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeholderId
          strength
        }
        impactedRisks {
          createdAt
          id
          riskId
          stakeholderId
          strength
        }
        impactedStakes {
          createdAt
          id
          stakeId
          stakeholderId
          strength
        }
        links {
          createdAt
          id
          originId
          strength
          targetId
        }
        name
        scenarios {
          enabled
          id
          impact
          scenarioId
          trend
          x
          y
        }
        taggings {
          createdAt
          id
          objectId
          tagId
          type
        }
        trend
        x
        y
      }
      stakes {
        createdAt
        description
        enabled
        evaluatedAt
        fishboneLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        id
        impactedIndicators {
          createdAt
          id
          indicatorId
          stakeId
          strength
        }
        name
        reference
        scenarios {
          enabled
          id
          scenarioId
          trend
          weight
        }
        trend
        weight
      }
      tags {
        createdAt
        description
        id
        name
      }
      type
      vision
    }
    projectId
    role
    status
  }
}
    `;
export type AddProjectMemberMutationFn = Apollo.MutationFunction<AddProjectMemberMutation, AddProjectMemberMutationVariables>;

/**
 * __useAddProjectMemberMutation__
 *
 * To run a mutation, you first call `useAddProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addProjectMemberMutation, { data, loading, error }] = useAddProjectMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *      projectId: // value for 'projectId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useAddProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddProjectMemberMutation, AddProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddProjectMemberMutation, AddProjectMemberMutationVariables>(AddProjectMemberDocument, options);
      }
export type AddProjectMemberMutationHookResult = ReturnType<typeof useAddProjectMemberMutation>;
export type AddProjectMemberMutationResult = Apollo.MutationResult<AddProjectMemberMutation>;
export type AddProjectMemberMutationOptions = Apollo.BaseMutationOptions<AddProjectMemberMutation, AddProjectMemberMutationVariables>;
export const ClaimAttachmentsDocument = gql`
    mutation ClaimAttachments($projectId: String!, $tempSessionId: String!) {
  claimAttachments(projectId: $projectId, tempSessionId: $tempSessionId)
}
    `;
export type ClaimAttachmentsMutationFn = Apollo.MutationFunction<ClaimAttachmentsMutation, ClaimAttachmentsMutationVariables>;

/**
 * __useClaimAttachmentsMutation__
 *
 * To run a mutation, you first call `useClaimAttachmentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimAttachmentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimAttachmentsMutation, { data, loading, error }] = useClaimAttachmentsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tempSessionId: // value for 'tempSessionId'
 *   },
 * });
 */
export function useClaimAttachmentsMutation(baseOptions?: Apollo.MutationHookOptions<ClaimAttachmentsMutation, ClaimAttachmentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimAttachmentsMutation, ClaimAttachmentsMutationVariables>(ClaimAttachmentsDocument, options);
      }
export type ClaimAttachmentsMutationHookResult = ReturnType<typeof useClaimAttachmentsMutation>;
export type ClaimAttachmentsMutationResult = Apollo.MutationResult<ClaimAttachmentsMutation>;
export type ClaimAttachmentsMutationOptions = Apollo.BaseMutationOptions<ClaimAttachmentsMutation, ClaimAttachmentsMutationVariables>;
export const CloneProjectDocument = gql`
    mutation CloneProject($id: ID!, $name: String, $reference: String, $type: String) {
  cloneProject(id: $id, name: $name, reference: $reference, type: $type)
}
    `;
export type CloneProjectMutationFn = Apollo.MutationFunction<CloneProjectMutation, CloneProjectMutationVariables>;

/**
 * __useCloneProjectMutation__
 *
 * To run a mutation, you first call `useCloneProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProjectMutation, { data, loading, error }] = useCloneProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCloneProjectMutation(baseOptions?: Apollo.MutationHookOptions<CloneProjectMutation, CloneProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProjectMutation, CloneProjectMutationVariables>(CloneProjectDocument, options);
      }
export type CloneProjectMutationHookResult = ReturnType<typeof useCloneProjectMutation>;
export type CloneProjectMutationResult = Apollo.MutationResult<CloneProjectMutation>;
export type CloneProjectMutationOptions = Apollo.BaseMutationOptions<CloneProjectMutation, CloneProjectMutationVariables>;
export const ConsumeCodeDocument = gql`
    mutation ConsumeCode($id: String!) {
  consumeCode(id: $id)
}
    `;
export type ConsumeCodeMutationFn = Apollo.MutationFunction<ConsumeCodeMutation, ConsumeCodeMutationVariables>;

/**
 * __useConsumeCodeMutation__
 *
 * To run a mutation, you first call `useConsumeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConsumeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [consumeCodeMutation, { data, loading, error }] = useConsumeCodeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConsumeCodeMutation(baseOptions?: Apollo.MutationHookOptions<ConsumeCodeMutation, ConsumeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConsumeCodeMutation, ConsumeCodeMutationVariables>(ConsumeCodeDocument, options);
      }
export type ConsumeCodeMutationHookResult = ReturnType<typeof useConsumeCodeMutation>;
export type ConsumeCodeMutationResult = Apollo.MutationResult<ConsumeCodeMutation>;
export type ConsumeCodeMutationOptions = Apollo.BaseMutationOptions<ConsumeCodeMutation, ConsumeCodeMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($commentedAt: String!, $description: String!, $objectId: String!, $objectType: String!, $projectId: String!) {
  createComment(
    commentedAt: $commentedAt
    description: $description
    objectId: $objectId
    objectType: $objectType
    projectId: $projectId
  ) {
    commentedAt
    createdAt
    description
    id
    objectId
    objectType
    projectId
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      commentedAt: // value for 'commentedAt'
 *      description: // value for 'description'
 *      objectId: // value for 'objectId'
 *      objectType: // value for 'objectType'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateFishboneBranchDocument = gql`
    mutation CreateFishboneBranch($description: String, $enabled: Boolean, $endOn: String, $icon: String, $name: String!, $projectId: String!, $responsible: String, $startOn: String, $weight: Int) {
  createFishboneBranch(
    description: $description
    enabled: $enabled
    endOn: $endOn
    icon: $icon
    name: $name
    projectId: $projectId
    responsible: $responsible
    startOn: $startOn
    weight: $weight
  ) {
    createdAt
    description
    enabled
    endOn
    evaluatedAt
    icon
    id
    indicatorLinks {
      createdAt
      fishboneNodeId
      id
      indicatorId
      nodeType
      projectId
      strength
    }
    items {
      completion
      createdAt
      description
      enabled
      endOn
      evaluatedAt
      fishboneBranchId
      icon
      id
      indicatorLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      name
      position
      reference
      responsible
      riskLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      scenarios {
        completion
        enabled
        id
        scenarioId
        trend
        weight
      }
      stakeLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      stakeholderLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      startOn
      trend
      updatedAt
      weight
    }
    name
    position
    reference
    responsible
    riskLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      riskId
      strength
    }
    scenarios {
      enabled
      id
      scenarioId
      weight
    }
    stakeLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeId
      strength
    }
    stakeholderLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeholderId
      strength
    }
    startOn
    updatedAt
    weight
  }
}
    `;
export type CreateFishboneBranchMutationFn = Apollo.MutationFunction<CreateFishboneBranchMutation, CreateFishboneBranchMutationVariables>;

/**
 * __useCreateFishboneBranchMutation__
 *
 * To run a mutation, you first call `useCreateFishboneBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneBranchMutation, { data, loading, error }] = useCreateFishboneBranchMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      endOn: // value for 'endOn'
 *      icon: // value for 'icon'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      responsible: // value for 'responsible'
 *      startOn: // value for 'startOn'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateFishboneBranchMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneBranchMutation, CreateFishboneBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneBranchMutation, CreateFishboneBranchMutationVariables>(CreateFishboneBranchDocument, options);
      }
export type CreateFishboneBranchMutationHookResult = ReturnType<typeof useCreateFishboneBranchMutation>;
export type CreateFishboneBranchMutationResult = Apollo.MutationResult<CreateFishboneBranchMutation>;
export type CreateFishboneBranchMutationOptions = Apollo.BaseMutationOptions<CreateFishboneBranchMutation, CreateFishboneBranchMutationVariables>;
export const CreateFishboneBranchIndicatorLinkDocument = gql`
    mutation CreateFishboneBranchIndicatorLink($fishboneBranchId: String!, $indicatorId: String!) {
  createFishboneBranchIndicatorLink(
    fishboneBranchId: $fishboneBranchId
    indicatorId: $indicatorId
  ) {
    createdAt
    fishboneNodeId
    id
    indicatorId
    nodeType
    projectId
    strength
  }
}
    `;
export type CreateFishboneBranchIndicatorLinkMutationFn = Apollo.MutationFunction<CreateFishboneBranchIndicatorLinkMutation, CreateFishboneBranchIndicatorLinkMutationVariables>;

/**
 * __useCreateFishboneBranchIndicatorLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneBranchIndicatorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneBranchIndicatorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneBranchIndicatorLinkMutation, { data, loading, error }] = useCreateFishboneBranchIndicatorLinkMutation({
 *   variables: {
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      indicatorId: // value for 'indicatorId'
 *   },
 * });
 */
export function useCreateFishboneBranchIndicatorLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneBranchIndicatorLinkMutation, CreateFishboneBranchIndicatorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneBranchIndicatorLinkMutation, CreateFishboneBranchIndicatorLinkMutationVariables>(CreateFishboneBranchIndicatorLinkDocument, options);
      }
export type CreateFishboneBranchIndicatorLinkMutationHookResult = ReturnType<typeof useCreateFishboneBranchIndicatorLinkMutation>;
export type CreateFishboneBranchIndicatorLinkMutationResult = Apollo.MutationResult<CreateFishboneBranchIndicatorLinkMutation>;
export type CreateFishboneBranchIndicatorLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneBranchIndicatorLinkMutation, CreateFishboneBranchIndicatorLinkMutationVariables>;
export const CreateFishboneBranchRiskLinkDocument = gql`
    mutation CreateFishboneBranchRiskLink($fishboneBranchId: String!, $riskId: String!) {
  createFishboneBranchRiskLink(
    fishboneBranchId: $fishboneBranchId
    riskId: $riskId
  ) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    riskId
    strength
  }
}
    `;
export type CreateFishboneBranchRiskLinkMutationFn = Apollo.MutationFunction<CreateFishboneBranchRiskLinkMutation, CreateFishboneBranchRiskLinkMutationVariables>;

/**
 * __useCreateFishboneBranchRiskLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneBranchRiskLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneBranchRiskLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneBranchRiskLinkMutation, { data, loading, error }] = useCreateFishboneBranchRiskLinkMutation({
 *   variables: {
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      riskId: // value for 'riskId'
 *   },
 * });
 */
export function useCreateFishboneBranchRiskLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneBranchRiskLinkMutation, CreateFishboneBranchRiskLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneBranchRiskLinkMutation, CreateFishboneBranchRiskLinkMutationVariables>(CreateFishboneBranchRiskLinkDocument, options);
      }
export type CreateFishboneBranchRiskLinkMutationHookResult = ReturnType<typeof useCreateFishboneBranchRiskLinkMutation>;
export type CreateFishboneBranchRiskLinkMutationResult = Apollo.MutationResult<CreateFishboneBranchRiskLinkMutation>;
export type CreateFishboneBranchRiskLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneBranchRiskLinkMutation, CreateFishboneBranchRiskLinkMutationVariables>;
export const CreateFishboneBranchStakeLinkDocument = gql`
    mutation CreateFishboneBranchStakeLink($fishboneBranchId: String!, $stakeId: String!) {
  createFishboneBranchStakeLink(
    fishboneBranchId: $fishboneBranchId
    stakeId: $stakeId
  ) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    stakeId
    strength
  }
}
    `;
export type CreateFishboneBranchStakeLinkMutationFn = Apollo.MutationFunction<CreateFishboneBranchStakeLinkMutation, CreateFishboneBranchStakeLinkMutationVariables>;

/**
 * __useCreateFishboneBranchStakeLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneBranchStakeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneBranchStakeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneBranchStakeLinkMutation, { data, loading, error }] = useCreateFishboneBranchStakeLinkMutation({
 *   variables: {
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      stakeId: // value for 'stakeId'
 *   },
 * });
 */
export function useCreateFishboneBranchStakeLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneBranchStakeLinkMutation, CreateFishboneBranchStakeLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneBranchStakeLinkMutation, CreateFishboneBranchStakeLinkMutationVariables>(CreateFishboneBranchStakeLinkDocument, options);
      }
export type CreateFishboneBranchStakeLinkMutationHookResult = ReturnType<typeof useCreateFishboneBranchStakeLinkMutation>;
export type CreateFishboneBranchStakeLinkMutationResult = Apollo.MutationResult<CreateFishboneBranchStakeLinkMutation>;
export type CreateFishboneBranchStakeLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneBranchStakeLinkMutation, CreateFishboneBranchStakeLinkMutationVariables>;
export const CreateFishboneBranchStakeholderLinkDocument = gql`
    mutation CreateFishboneBranchStakeholderLink($fishboneBranchId: String!, $stakeholderId: String!) {
  createFishboneBranchStakeholderLink(
    fishboneBranchId: $fishboneBranchId
    stakeholderId: $stakeholderId
  ) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    stakeholderId
    strength
  }
}
    `;
export type CreateFishboneBranchStakeholderLinkMutationFn = Apollo.MutationFunction<CreateFishboneBranchStakeholderLinkMutation, CreateFishboneBranchStakeholderLinkMutationVariables>;

/**
 * __useCreateFishboneBranchStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneBranchStakeholderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneBranchStakeholderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneBranchStakeholderLinkMutation, { data, loading, error }] = useCreateFishboneBranchStakeholderLinkMutation({
 *   variables: {
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useCreateFishboneBranchStakeholderLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneBranchStakeholderLinkMutation, CreateFishboneBranchStakeholderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneBranchStakeholderLinkMutation, CreateFishboneBranchStakeholderLinkMutationVariables>(CreateFishboneBranchStakeholderLinkDocument, options);
      }
export type CreateFishboneBranchStakeholderLinkMutationHookResult = ReturnType<typeof useCreateFishboneBranchStakeholderLinkMutation>;
export type CreateFishboneBranchStakeholderLinkMutationResult = Apollo.MutationResult<CreateFishboneBranchStakeholderLinkMutation>;
export type CreateFishboneBranchStakeholderLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneBranchStakeholderLinkMutation, CreateFishboneBranchStakeholderLinkMutationVariables>;
export const CreateFishboneItemDocument = gql`
    mutation CreateFishboneItem($completion: Int, $description: String, $enabled: Boolean, $endOn: String, $evaluatedAt: String, $fishboneBranchId: String!, $icon: String, $name: String!, $responsible: String, $startOn: String, $trend: String, $weight: Int) {
  createFishboneItem(
    completion: $completion
    description: $description
    enabled: $enabled
    endOn: $endOn
    evaluatedAt: $evaluatedAt
    fishboneBranchId: $fishboneBranchId
    icon: $icon
    name: $name
    responsible: $responsible
    startOn: $startOn
    trend: $trend
    weight: $weight
  ) {
    completion
    createdAt
    description
    enabled
    endOn
    evaluatedAt
    fishboneBranchId
    icon
    id
    indicatorLinks {
      createdAt
      fishboneNodeId
      id
      indicatorId
      nodeType
      projectId
      strength
    }
    name
    position
    reference
    responsible
    riskLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      riskId
      strength
    }
    scenarios {
      completion
      enabled
      id
      scenarioId
      trend
      weight
    }
    stakeLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeId
      strength
    }
    stakeholderLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeholderId
      strength
    }
    startOn
    trend
    updatedAt
    weight
  }
}
    `;
export type CreateFishboneItemMutationFn = Apollo.MutationFunction<CreateFishboneItemMutation, CreateFishboneItemMutationVariables>;

/**
 * __useCreateFishboneItemMutation__
 *
 * To run a mutation, you first call `useCreateFishboneItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneItemMutation, { data, loading, error }] = useCreateFishboneItemMutation({
 *   variables: {
 *      completion: // value for 'completion'
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      endOn: // value for 'endOn'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      icon: // value for 'icon'
 *      name: // value for 'name'
 *      responsible: // value for 'responsible'
 *      startOn: // value for 'startOn'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateFishboneItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneItemMutation, CreateFishboneItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneItemMutation, CreateFishboneItemMutationVariables>(CreateFishboneItemDocument, options);
      }
export type CreateFishboneItemMutationHookResult = ReturnType<typeof useCreateFishboneItemMutation>;
export type CreateFishboneItemMutationResult = Apollo.MutationResult<CreateFishboneItemMutation>;
export type CreateFishboneItemMutationOptions = Apollo.BaseMutationOptions<CreateFishboneItemMutation, CreateFishboneItemMutationVariables>;
export const CreateFishboneItemIndicatorLinkDocument = gql`
    mutation CreateFishboneItemIndicatorLink($fishboneItemId: String!, $indicatorId: String!) {
  createFishboneItemIndicatorLink(
    fishboneItemId: $fishboneItemId
    indicatorId: $indicatorId
  ) {
    createdAt
    fishboneNodeId
    id
    indicatorId
    nodeType
    projectId
    strength
  }
}
    `;
export type CreateFishboneItemIndicatorLinkMutationFn = Apollo.MutationFunction<CreateFishboneItemIndicatorLinkMutation, CreateFishboneItemIndicatorLinkMutationVariables>;

/**
 * __useCreateFishboneItemIndicatorLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneItemIndicatorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneItemIndicatorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneItemIndicatorLinkMutation, { data, loading, error }] = useCreateFishboneItemIndicatorLinkMutation({
 *   variables: {
 *      fishboneItemId: // value for 'fishboneItemId'
 *      indicatorId: // value for 'indicatorId'
 *   },
 * });
 */
export function useCreateFishboneItemIndicatorLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneItemIndicatorLinkMutation, CreateFishboneItemIndicatorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneItemIndicatorLinkMutation, CreateFishboneItemIndicatorLinkMutationVariables>(CreateFishboneItemIndicatorLinkDocument, options);
      }
export type CreateFishboneItemIndicatorLinkMutationHookResult = ReturnType<typeof useCreateFishboneItemIndicatorLinkMutation>;
export type CreateFishboneItemIndicatorLinkMutationResult = Apollo.MutationResult<CreateFishboneItemIndicatorLinkMutation>;
export type CreateFishboneItemIndicatorLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneItemIndicatorLinkMutation, CreateFishboneItemIndicatorLinkMutationVariables>;
export const CreateFishboneItemRiskLinkDocument = gql`
    mutation CreateFishboneItemRiskLink($fishboneItemId: String!, $riskId: String!) {
  createFishboneItemRiskLink(fishboneItemId: $fishboneItemId, riskId: $riskId) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    riskId
    strength
  }
}
    `;
export type CreateFishboneItemRiskLinkMutationFn = Apollo.MutationFunction<CreateFishboneItemRiskLinkMutation, CreateFishboneItemRiskLinkMutationVariables>;

/**
 * __useCreateFishboneItemRiskLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneItemRiskLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneItemRiskLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneItemRiskLinkMutation, { data, loading, error }] = useCreateFishboneItemRiskLinkMutation({
 *   variables: {
 *      fishboneItemId: // value for 'fishboneItemId'
 *      riskId: // value for 'riskId'
 *   },
 * });
 */
export function useCreateFishboneItemRiskLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneItemRiskLinkMutation, CreateFishboneItemRiskLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneItemRiskLinkMutation, CreateFishboneItemRiskLinkMutationVariables>(CreateFishboneItemRiskLinkDocument, options);
      }
export type CreateFishboneItemRiskLinkMutationHookResult = ReturnType<typeof useCreateFishboneItemRiskLinkMutation>;
export type CreateFishboneItemRiskLinkMutationResult = Apollo.MutationResult<CreateFishboneItemRiskLinkMutation>;
export type CreateFishboneItemRiskLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneItemRiskLinkMutation, CreateFishboneItemRiskLinkMutationVariables>;
export const CreateFishboneItemStakeLinkDocument = gql`
    mutation CreateFishboneItemStakeLink($fishboneItemId: String!, $stakeId: String!) {
  createFishboneItemStakeLink(fishboneItemId: $fishboneItemId, stakeId: $stakeId) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    stakeId
    strength
  }
}
    `;
export type CreateFishboneItemStakeLinkMutationFn = Apollo.MutationFunction<CreateFishboneItemStakeLinkMutation, CreateFishboneItemStakeLinkMutationVariables>;

/**
 * __useCreateFishboneItemStakeLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneItemStakeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneItemStakeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneItemStakeLinkMutation, { data, loading, error }] = useCreateFishboneItemStakeLinkMutation({
 *   variables: {
 *      fishboneItemId: // value for 'fishboneItemId'
 *      stakeId: // value for 'stakeId'
 *   },
 * });
 */
export function useCreateFishboneItemStakeLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneItemStakeLinkMutation, CreateFishboneItemStakeLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneItemStakeLinkMutation, CreateFishboneItemStakeLinkMutationVariables>(CreateFishboneItemStakeLinkDocument, options);
      }
export type CreateFishboneItemStakeLinkMutationHookResult = ReturnType<typeof useCreateFishboneItemStakeLinkMutation>;
export type CreateFishboneItemStakeLinkMutationResult = Apollo.MutationResult<CreateFishboneItemStakeLinkMutation>;
export type CreateFishboneItemStakeLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneItemStakeLinkMutation, CreateFishboneItemStakeLinkMutationVariables>;
export const CreateFishboneItemStakeholderLinkDocument = gql`
    mutation CreateFishboneItemStakeholderLink($fishboneItemId: String!, $stakeholderId: String!) {
  createFishboneItemStakeholderLink(
    fishboneItemId: $fishboneItemId
    stakeholderId: $stakeholderId
  ) {
    createdAt
    fishboneNodeId
    id
    nodeType
    projectId
    stakeholderId
    strength
  }
}
    `;
export type CreateFishboneItemStakeholderLinkMutationFn = Apollo.MutationFunction<CreateFishboneItemStakeholderLinkMutation, CreateFishboneItemStakeholderLinkMutationVariables>;

/**
 * __useCreateFishboneItemStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useCreateFishboneItemStakeholderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFishboneItemStakeholderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFishboneItemStakeholderLinkMutation, { data, loading, error }] = useCreateFishboneItemStakeholderLinkMutation({
 *   variables: {
 *      fishboneItemId: // value for 'fishboneItemId'
 *      stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useCreateFishboneItemStakeholderLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateFishboneItemStakeholderLinkMutation, CreateFishboneItemStakeholderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFishboneItemStakeholderLinkMutation, CreateFishboneItemStakeholderLinkMutationVariables>(CreateFishboneItemStakeholderLinkDocument, options);
      }
export type CreateFishboneItemStakeholderLinkMutationHookResult = ReturnType<typeof useCreateFishboneItemStakeholderLinkMutation>;
export type CreateFishboneItemStakeholderLinkMutationResult = Apollo.MutationResult<CreateFishboneItemStakeholderLinkMutation>;
export type CreateFishboneItemStakeholderLinkMutationOptions = Apollo.BaseMutationOptions<CreateFishboneItemStakeholderLinkMutation, CreateFishboneItemStakeholderLinkMutationVariables>;
export const CreateIndicatorDocument = gql`
    mutation CreateIndicator($description: String, $enabled: Boolean, $evaluatedAt: String, $indicatorCategoryId: String, $name: String!, $projectId: String!, $reference: String, $trend: String, $weight: Int) {
  createIndicator(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    indicatorCategoryId: $indicatorCategoryId
    name: $name
    projectId: $projectId
    reference: $reference
    trend: $trend
    weight: $weight
  ) {
    createdAt
    description
    enabled
    evaluatedAt
    fishboneLinks {
      createdAt
      fishboneNodeId
      id
      indicatorId
      nodeType
      projectId
      strength
    }
    id
    indicatorCategoryId
    name
    reference
    scenarios {
      enabled
      id
      scenarioId
      trend
      weight
    }
    trend
    weight
  }
}
    `;
export type CreateIndicatorMutationFn = Apollo.MutationFunction<CreateIndicatorMutation, CreateIndicatorMutationVariables>;

/**
 * __useCreateIndicatorMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorMutation, { data, loading, error }] = useCreateIndicatorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      indicatorCategoryId: // value for 'indicatorCategoryId'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      reference: // value for 'reference'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndicatorMutation, CreateIndicatorMutationVariables>(CreateIndicatorDocument, options);
      }
export type CreateIndicatorMutationHookResult = ReturnType<typeof useCreateIndicatorMutation>;
export type CreateIndicatorMutationResult = Apollo.MutationResult<CreateIndicatorMutation>;
export type CreateIndicatorMutationOptions = Apollo.BaseMutationOptions<CreateIndicatorMutation, CreateIndicatorMutationVariables>;
export const CreateIndicatorCategoryDocument = gql`
    mutation CreateIndicatorCategory($description: String, $name: String!, $projectId: String!, $weight: Int) {
  createIndicatorCategory(
    description: $description
    name: $name
    projectId: $projectId
    weight: $weight
  ) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type CreateIndicatorCategoryMutationFn = Apollo.MutationFunction<CreateIndicatorCategoryMutation, CreateIndicatorCategoryMutationVariables>;

/**
 * __useCreateIndicatorCategoryMutation__
 *
 * To run a mutation, you first call `useCreateIndicatorCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndicatorCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndicatorCategoryMutation, { data, loading, error }] = useCreateIndicatorCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateIndicatorCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndicatorCategoryMutation, CreateIndicatorCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndicatorCategoryMutation, CreateIndicatorCategoryMutationVariables>(CreateIndicatorCategoryDocument, options);
      }
export type CreateIndicatorCategoryMutationHookResult = ReturnType<typeof useCreateIndicatorCategoryMutation>;
export type CreateIndicatorCategoryMutationResult = Apollo.MutationResult<CreateIndicatorCategoryMutation>;
export type CreateIndicatorCategoryMutationOptions = Apollo.BaseMutationOptions<CreateIndicatorCategoryMutation, CreateIndicatorCategoryMutationVariables>;
export const CreateProjectDocument = gql`
    mutation CreateProject($description: String, $descriptionLong: String, $impacts: [ImpactLevelInput], $likelihoods: [LikelihoodLevelInput], $name: String!, $reference: String, $type: String, $vision: String) {
  createProject(
    description: $description
    descriptionLong: $descriptionLong
    impacts: $impacts
    likelihoods: $likelihoods
    name: $name
    reference: $reference
    type: $type
    vision: $vision
  ) {
    analysisSummary
    baselineScenarioDescription
    baselineScenarioImpacts
    createdAt
    description
    descriptionLong
    fishboneBranchs {
      createdAt
      description
      enabled
      endOn
      evaluatedAt
      icon
      id
      indicatorLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      items {
        completion
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        fishboneBranchId
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          completion
          enabled
          id
          scenarioId
          trend
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        trend
        updatedAt
        weight
      }
      name
      position
      reference
      responsible
      riskLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      scenarios {
        enabled
        id
        scenarioId
        weight
      }
      stakeLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      stakeholderLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      startOn
      updatedAt
      weight
    }
    fishboneDescription
    fishboneEndOn
    fishboneStartOn
    id
    impacts {
      id
      name
    }
    indicatorCategories {
      createdAt
      description
      id
      name
      weight
    }
    indicators {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      id
      indicatorCategoryId
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    likelihoods {
      id
      name
    }
    members {
      createdAt
      id
      invitedBy
      invitedEmail
      project {
        analysisSummary
        baselineScenarioDescription
        baselineScenarioImpacts
        createdAt
        description
        descriptionLong
        fishboneBranchs {
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          icon
          id
          name
          position
          reference
          responsible
          startOn
          updatedAt
          weight
        }
        fishboneDescription
        fishboneEndOn
        fishboneStartOn
        id
        impacts {
          id
          name
        }
        indicatorCategories {
          createdAt
          description
          id
          name
          weight
        }
        indicators {
          createdAt
          description
          enabled
          evaluatedAt
          id
          indicatorCategoryId
          name
          reference
          trend
          weight
        }
        likelihoods {
          id
          name
        }
        members {
          createdAt
          id
          invitedBy
          invitedEmail
          projectId
          role
          status
        }
        myRole
        name
        readerCount
        reference
        responsible
        riskCategories {
          createdAt
          description
          id
          name
          weight
        }
        risks {
          createdAt
          description
          enabled
          evaluatedAt
          id
          impact
          isOpportunity
          likelihood
          name
          reference
          riskCategoryId
        }
        scenarios {
          createdAt
          description
          enabled
          id
          impacts
          name
        }
        stakeholders {
          createdAt
          description
          enabled
          icon
          id
          impact
          name
          trend
          x
          y
        }
        stakes {
          createdAt
          description
          enabled
          evaluatedAt
          id
          name
          reference
          trend
          weight
        }
        tags {
          createdAt
          description
          id
          name
        }
        type
        vision
      }
      projectId
      role
      status
    }
    myRole
    name
    readerCount
    reference
    responsible
    riskCategories {
      createdAt
      description
      id
      name
      weight
    }
    risks {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        riskId
        strength
      }
      impactedStakes {
        createdAt
        id
        riskId
        stakeId
        strength
      }
      isOpportunity
      likelihood
      name
      openingLinks {
        createdAt
        id
        openingId
        projectId
        riskId
        strength
      }
      reference
      riskCategoryId
      scenarios {
        enabled
        id
        impact
        likelihood
        scenarioId
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
    }
    scenarios {
      createdAt
      description
      enabled
      id
      impacts
      name
    }
    stakeholders {
      createdAt
      description
      enabled
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      icon
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeholderId
        strength
      }
      impactedRisks {
        createdAt
        id
        riskId
        stakeholderId
        strength
      }
      impactedStakes {
        createdAt
        id
        stakeId
        stakeholderId
        strength
      }
      links {
        createdAt
        id
        originId
        strength
        targetId
      }
      name
      scenarios {
        enabled
        id
        impact
        scenarioId
        trend
        x
        y
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
      trend
      x
      y
    }
    stakes {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      id
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeId
        strength
      }
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    tags {
      createdAt
      description
      id
      name
    }
    type
    vision
  }
}
    `;
export type CreateProjectMutationFn = Apollo.MutationFunction<CreateProjectMutation, CreateProjectMutationVariables>;

/**
 * __useCreateProjectMutation__
 *
 * To run a mutation, you first call `useCreateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectMutation, { data, loading, error }] = useCreateProjectMutation({
 *   variables: {
 *      description: // value for 'description'
 *      descriptionLong: // value for 'descriptionLong'
 *      impacts: // value for 'impacts'
 *      likelihoods: // value for 'likelihoods'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      type: // value for 'type'
 *      vision: // value for 'vision'
 *   },
 * });
 */
export function useCreateProjectMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectMutation, CreateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectMutation, CreateProjectMutationVariables>(CreateProjectDocument, options);
      }
export type CreateProjectMutationHookResult = ReturnType<typeof useCreateProjectMutation>;
export type CreateProjectMutationResult = Apollo.MutationResult<CreateProjectMutation>;
export type CreateProjectMutationOptions = Apollo.BaseMutationOptions<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateRiskDocument = gql`
    mutation CreateRisk($description: String, $enabled: Boolean, $evaluatedAt: String, $impact: Float, $isOpportunity: Boolean, $likelihood: Float, $name: String!, $projectId: String!, $reference: String, $riskCategoryId: String) {
  createRisk(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    impact: $impact
    isOpportunity: $isOpportunity
    likelihood: $likelihood
    name: $name
    projectId: $projectId
    reference: $reference
    riskCategoryId: $riskCategoryId
  ) {
    createdAt
    description
    enabled
    evaluatedAt
    fishboneLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      riskId
      strength
    }
    id
    impact
    impactedIndicators {
      createdAt
      id
      indicatorId
      riskId
      strength
    }
    impactedStakes {
      createdAt
      id
      riskId
      stakeId
      strength
    }
    isOpportunity
    likelihood
    name
    openingLinks {
      createdAt
      id
      openingId
      projectId
      riskId
      strength
    }
    reference
    riskCategoryId
    scenarios {
      enabled
      id
      impact
      likelihood
      scenarioId
    }
    taggings {
      createdAt
      id
      objectId
      tagId
      type
    }
  }
}
    `;
export type CreateRiskMutationFn = Apollo.MutationFunction<CreateRiskMutation, CreateRiskMutationVariables>;

/**
 * __useCreateRiskMutation__
 *
 * To run a mutation, you first call `useCreateRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskMutation, { data, loading, error }] = useCreateRiskMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      impact: // value for 'impact'
 *      isOpportunity: // value for 'isOpportunity'
 *      likelihood: // value for 'likelihood'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      reference: // value for 'reference'
 *      riskCategoryId: // value for 'riskCategoryId'
 *   },
 * });
 */
export function useCreateRiskMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskMutation, CreateRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskMutation, CreateRiskMutationVariables>(CreateRiskDocument, options);
      }
export type CreateRiskMutationHookResult = ReturnType<typeof useCreateRiskMutation>;
export type CreateRiskMutationResult = Apollo.MutationResult<CreateRiskMutation>;
export type CreateRiskMutationOptions = Apollo.BaseMutationOptions<CreateRiskMutation, CreateRiskMutationVariables>;
export const CreateRiskCategoryDocument = gql`
    mutation CreateRiskCategory($description: String, $name: String!, $projectId: String!, $weight: Int) {
  createRiskCategory(
    description: $description
    name: $name
    projectId: $projectId
    weight: $weight
  ) {
    createdAt
    description
    id
    name
    weight
  }
}
    `;
export type CreateRiskCategoryMutationFn = Apollo.MutationFunction<CreateRiskCategoryMutation, CreateRiskCategoryMutationVariables>;

/**
 * __useCreateRiskCategoryMutation__
 *
 * To run a mutation, you first call `useCreateRiskCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskCategoryMutation, { data, loading, error }] = useCreateRiskCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateRiskCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskCategoryMutation, CreateRiskCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskCategoryMutation, CreateRiskCategoryMutationVariables>(CreateRiskCategoryDocument, options);
      }
export type CreateRiskCategoryMutationHookResult = ReturnType<typeof useCreateRiskCategoryMutation>;
export type CreateRiskCategoryMutationResult = Apollo.MutationResult<CreateRiskCategoryMutation>;
export type CreateRiskCategoryMutationOptions = Apollo.BaseMutationOptions<CreateRiskCategoryMutation, CreateRiskCategoryMutationVariables>;
export const CreateRiskIndicatorImpactDocument = gql`
    mutation CreateRiskIndicatorImpact($indicatorId: String!, $riskId: String!) {
  createRiskIndicatorImpact(indicatorId: $indicatorId, riskId: $riskId) {
    createdAt
    id
    indicatorId
    riskId
    strength
  }
}
    `;
export type CreateRiskIndicatorImpactMutationFn = Apollo.MutationFunction<CreateRiskIndicatorImpactMutation, CreateRiskIndicatorImpactMutationVariables>;

/**
 * __useCreateRiskIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useCreateRiskIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskIndicatorImpactMutation, { data, loading, error }] = useCreateRiskIndicatorImpactMutation({
 *   variables: {
 *      indicatorId: // value for 'indicatorId'
 *      riskId: // value for 'riskId'
 *   },
 * });
 */
export function useCreateRiskIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskIndicatorImpactMutation, CreateRiskIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskIndicatorImpactMutation, CreateRiskIndicatorImpactMutationVariables>(CreateRiskIndicatorImpactDocument, options);
      }
export type CreateRiskIndicatorImpactMutationHookResult = ReturnType<typeof useCreateRiskIndicatorImpactMutation>;
export type CreateRiskIndicatorImpactMutationResult = Apollo.MutationResult<CreateRiskIndicatorImpactMutation>;
export type CreateRiskIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<CreateRiskIndicatorImpactMutation, CreateRiskIndicatorImpactMutationVariables>;
export const CreateRiskOpeningLinkDocument = gql`
    mutation CreateRiskOpeningLink($openingId: String!, $riskId: String!, $strength: Int) {
  createRiskOpeningLink(
    openingId: $openingId
    riskId: $riskId
    strength: $strength
  ) {
    createdAt
    id
    openingId
    projectId
    riskId
    strength
  }
}
    `;
export type CreateRiskOpeningLinkMutationFn = Apollo.MutationFunction<CreateRiskOpeningLinkMutation, CreateRiskOpeningLinkMutationVariables>;

/**
 * __useCreateRiskOpeningLinkMutation__
 *
 * To run a mutation, you first call `useCreateRiskOpeningLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskOpeningLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskOpeningLinkMutation, { data, loading, error }] = useCreateRiskOpeningLinkMutation({
 *   variables: {
 *      openingId: // value for 'openingId'
 *      riskId: // value for 'riskId'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useCreateRiskOpeningLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskOpeningLinkMutation, CreateRiskOpeningLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskOpeningLinkMutation, CreateRiskOpeningLinkMutationVariables>(CreateRiskOpeningLinkDocument, options);
      }
export type CreateRiskOpeningLinkMutationHookResult = ReturnType<typeof useCreateRiskOpeningLinkMutation>;
export type CreateRiskOpeningLinkMutationResult = Apollo.MutationResult<CreateRiskOpeningLinkMutation>;
export type CreateRiskOpeningLinkMutationOptions = Apollo.BaseMutationOptions<CreateRiskOpeningLinkMutation, CreateRiskOpeningLinkMutationVariables>;
export const CreateRiskStakeImpactDocument = gql`
    mutation CreateRiskStakeImpact($riskId: String!, $stakeId: String!) {
  createRiskStakeImpact(riskId: $riskId, stakeId: $stakeId) {
    createdAt
    id
    riskId
    stakeId
    strength
  }
}
    `;
export type CreateRiskStakeImpactMutationFn = Apollo.MutationFunction<CreateRiskStakeImpactMutation, CreateRiskStakeImpactMutationVariables>;

/**
 * __useCreateRiskStakeImpactMutation__
 *
 * To run a mutation, you first call `useCreateRiskStakeImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRiskStakeImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRiskStakeImpactMutation, { data, loading, error }] = useCreateRiskStakeImpactMutation({
 *   variables: {
 *      riskId: // value for 'riskId'
 *      stakeId: // value for 'stakeId'
 *   },
 * });
 */
export function useCreateRiskStakeImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateRiskStakeImpactMutation, CreateRiskStakeImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRiskStakeImpactMutation, CreateRiskStakeImpactMutationVariables>(CreateRiskStakeImpactDocument, options);
      }
export type CreateRiskStakeImpactMutationHookResult = ReturnType<typeof useCreateRiskStakeImpactMutation>;
export type CreateRiskStakeImpactMutationResult = Apollo.MutationResult<CreateRiskStakeImpactMutation>;
export type CreateRiskStakeImpactMutationOptions = Apollo.BaseMutationOptions<CreateRiskStakeImpactMutation, CreateRiskStakeImpactMutationVariables>;
export const CreateScenarioDocument = gql`
    mutation CreateScenario($description: String, $impacts: String, $name: String!, $projectId: String!, $referenceScenarioId: String) {
  createScenario(
    description: $description
    impacts: $impacts
    name: $name
    projectId: $projectId
    referenceScenarioId: $referenceScenarioId
  )
}
    `;
export type CreateScenarioMutationFn = Apollo.MutationFunction<CreateScenarioMutation, CreateScenarioMutationVariables>;

/**
 * __useCreateScenarioMutation__
 *
 * To run a mutation, you first call `useCreateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScenarioMutation, { data, loading, error }] = useCreateScenarioMutation({
 *   variables: {
 *      description: // value for 'description'
 *      impacts: // value for 'impacts'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      referenceScenarioId: // value for 'referenceScenarioId'
 *   },
 * });
 */
export function useCreateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<CreateScenarioMutation, CreateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScenarioMutation, CreateScenarioMutationVariables>(CreateScenarioDocument, options);
      }
export type CreateScenarioMutationHookResult = ReturnType<typeof useCreateScenarioMutation>;
export type CreateScenarioMutationResult = Apollo.MutationResult<CreateScenarioMutation>;
export type CreateScenarioMutationOptions = Apollo.BaseMutationOptions<CreateScenarioMutation, CreateScenarioMutationVariables>;
export const CreateStakeDocument = gql`
    mutation CreateStake($description: String, $enabled: Boolean, $evaluatedAt: String, $name: String!, $projectId: String!, $reference: String, $trend: String, $weight: Int) {
  createStake(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    name: $name
    projectId: $projectId
    reference: $reference
    trend: $trend
    weight: $weight
  ) {
    createdAt
    description
    enabled
    evaluatedAt
    fishboneLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeId
      strength
    }
    id
    impactedIndicators {
      createdAt
      id
      indicatorId
      stakeId
      strength
    }
    name
    reference
    scenarios {
      enabled
      id
      scenarioId
      trend
      weight
    }
    trend
    weight
  }
}
    `;
export type CreateStakeMutationFn = Apollo.MutationFunction<CreateStakeMutation, CreateStakeMutationVariables>;

/**
 * __useCreateStakeMutation__
 *
 * To run a mutation, you first call `useCreateStakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeMutation, { data, loading, error }] = useCreateStakeMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      reference: // value for 'reference'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useCreateStakeMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeMutation, CreateStakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeMutation, CreateStakeMutationVariables>(CreateStakeDocument, options);
      }
export type CreateStakeMutationHookResult = ReturnType<typeof useCreateStakeMutation>;
export type CreateStakeMutationResult = Apollo.MutationResult<CreateStakeMutation>;
export type CreateStakeMutationOptions = Apollo.BaseMutationOptions<CreateStakeMutation, CreateStakeMutationVariables>;
export const CreateStakeIndicatorImpactDocument = gql`
    mutation CreateStakeIndicatorImpact($indicatorId: String!, $stakeId: String!) {
  createStakeIndicatorImpact(indicatorId: $indicatorId, stakeId: $stakeId) {
    createdAt
    id
    indicatorId
    stakeId
    strength
  }
}
    `;
export type CreateStakeIndicatorImpactMutationFn = Apollo.MutationFunction<CreateStakeIndicatorImpactMutation, CreateStakeIndicatorImpactMutationVariables>;

/**
 * __useCreateStakeIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useCreateStakeIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeIndicatorImpactMutation, { data, loading, error }] = useCreateStakeIndicatorImpactMutation({
 *   variables: {
 *      indicatorId: // value for 'indicatorId'
 *      stakeId: // value for 'stakeId'
 *   },
 * });
 */
export function useCreateStakeIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeIndicatorImpactMutation, CreateStakeIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeIndicatorImpactMutation, CreateStakeIndicatorImpactMutationVariables>(CreateStakeIndicatorImpactDocument, options);
      }
export type CreateStakeIndicatorImpactMutationHookResult = ReturnType<typeof useCreateStakeIndicatorImpactMutation>;
export type CreateStakeIndicatorImpactMutationResult = Apollo.MutationResult<CreateStakeIndicatorImpactMutation>;
export type CreateStakeIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<CreateStakeIndicatorImpactMutation, CreateStakeIndicatorImpactMutationVariables>;
export const CreateStakeholderDocument = gql`
    mutation CreateStakeholder($description: String, $enabled: Boolean, $icon: String, $impact: String, $name: String!, $projectId: String!, $trend: String, $x: Float, $y: Float) {
  createStakeholder(
    description: $description
    enabled: $enabled
    icon: $icon
    impact: $impact
    name: $name
    projectId: $projectId
    trend: $trend
    x: $x
    y: $y
  ) {
    createdAt
    description
    enabled
    fishboneLinks {
      createdAt
      fishboneNodeId
      id
      nodeType
      projectId
      stakeholderId
      strength
    }
    icon
    id
    impact
    impactedIndicators {
      createdAt
      id
      indicatorId
      stakeholderId
      strength
    }
    impactedRisks {
      createdAt
      id
      riskId
      stakeholderId
      strength
    }
    impactedStakes {
      createdAt
      id
      stakeId
      stakeholderId
      strength
    }
    links {
      createdAt
      id
      originId
      strength
      targetId
    }
    name
    scenarios {
      enabled
      id
      impact
      scenarioId
      trend
      x
      y
    }
    taggings {
      createdAt
      id
      objectId
      tagId
      type
    }
    trend
    x
    y
  }
}
    `;
export type CreateStakeholderMutationFn = Apollo.MutationFunction<CreateStakeholderMutation, CreateStakeholderMutationVariables>;

/**
 * __useCreateStakeholderMutation__
 *
 * To run a mutation, you first call `useCreateStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeholderMutation, { data, loading, error }] = useCreateStakeholderMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      icon: // value for 'icon'
 *      impact: // value for 'impact'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *      trend: // value for 'trend'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *   },
 * });
 */
export function useCreateStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeholderMutation, CreateStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeholderMutation, CreateStakeholderMutationVariables>(CreateStakeholderDocument, options);
      }
export type CreateStakeholderMutationHookResult = ReturnType<typeof useCreateStakeholderMutation>;
export type CreateStakeholderMutationResult = Apollo.MutationResult<CreateStakeholderMutation>;
export type CreateStakeholderMutationOptions = Apollo.BaseMutationOptions<CreateStakeholderMutation, CreateStakeholderMutationVariables>;
export const CreateStakeholderIndicatorImpactDocument = gql`
    mutation CreateStakeholderIndicatorImpact($indicatorId: String!, $stakeholderId: String!) {
  createStakeholderIndicatorImpact(
    indicatorId: $indicatorId
    stakeholderId: $stakeholderId
  ) {
    createdAt
    id
    indicatorId
    stakeholderId
    strength
  }
}
    `;
export type CreateStakeholderIndicatorImpactMutationFn = Apollo.MutationFunction<CreateStakeholderIndicatorImpactMutation, CreateStakeholderIndicatorImpactMutationVariables>;

/**
 * __useCreateStakeholderIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useCreateStakeholderIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeholderIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeholderIndicatorImpactMutation, { data, loading, error }] = useCreateStakeholderIndicatorImpactMutation({
 *   variables: {
 *      indicatorId: // value for 'indicatorId'
 *      stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useCreateStakeholderIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeholderIndicatorImpactMutation, CreateStakeholderIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeholderIndicatorImpactMutation, CreateStakeholderIndicatorImpactMutationVariables>(CreateStakeholderIndicatorImpactDocument, options);
      }
export type CreateStakeholderIndicatorImpactMutationHookResult = ReturnType<typeof useCreateStakeholderIndicatorImpactMutation>;
export type CreateStakeholderIndicatorImpactMutationResult = Apollo.MutationResult<CreateStakeholderIndicatorImpactMutation>;
export type CreateStakeholderIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<CreateStakeholderIndicatorImpactMutation, CreateStakeholderIndicatorImpactMutationVariables>;
export const CreateStakeholderLinkDocument = gql`
    mutation CreateStakeholderLink($originId: String!, $targetId: String!) {
  createStakeholderLink(originId: $originId, targetId: $targetId) {
    createdAt
    id
    originId
    strength
    targetId
  }
}
    `;
export type CreateStakeholderLinkMutationFn = Apollo.MutationFunction<CreateStakeholderLinkMutation, CreateStakeholderLinkMutationVariables>;

/**
 * __useCreateStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useCreateStakeholderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeholderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeholderLinkMutation, { data, loading, error }] = useCreateStakeholderLinkMutation({
 *   variables: {
 *      originId: // value for 'originId'
 *      targetId: // value for 'targetId'
 *   },
 * });
 */
export function useCreateStakeholderLinkMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeholderLinkMutation, CreateStakeholderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeholderLinkMutation, CreateStakeholderLinkMutationVariables>(CreateStakeholderLinkDocument, options);
      }
export type CreateStakeholderLinkMutationHookResult = ReturnType<typeof useCreateStakeholderLinkMutation>;
export type CreateStakeholderLinkMutationResult = Apollo.MutationResult<CreateStakeholderLinkMutation>;
export type CreateStakeholderLinkMutationOptions = Apollo.BaseMutationOptions<CreateStakeholderLinkMutation, CreateStakeholderLinkMutationVariables>;
export const CreateStakeholderRiskImpactDocument = gql`
    mutation CreateStakeholderRiskImpact($riskId: String!, $stakeholderId: String!) {
  createStakeholderRiskImpact(riskId: $riskId, stakeholderId: $stakeholderId) {
    createdAt
    id
    riskId
    stakeholderId
    strength
  }
}
    `;
export type CreateStakeholderRiskImpactMutationFn = Apollo.MutationFunction<CreateStakeholderRiskImpactMutation, CreateStakeholderRiskImpactMutationVariables>;

/**
 * __useCreateStakeholderRiskImpactMutation__
 *
 * To run a mutation, you first call `useCreateStakeholderRiskImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeholderRiskImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeholderRiskImpactMutation, { data, loading, error }] = useCreateStakeholderRiskImpactMutation({
 *   variables: {
 *      riskId: // value for 'riskId'
 *      stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useCreateStakeholderRiskImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeholderRiskImpactMutation, CreateStakeholderRiskImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeholderRiskImpactMutation, CreateStakeholderRiskImpactMutationVariables>(CreateStakeholderRiskImpactDocument, options);
      }
export type CreateStakeholderRiskImpactMutationHookResult = ReturnType<typeof useCreateStakeholderRiskImpactMutation>;
export type CreateStakeholderRiskImpactMutationResult = Apollo.MutationResult<CreateStakeholderRiskImpactMutation>;
export type CreateStakeholderRiskImpactMutationOptions = Apollo.BaseMutationOptions<CreateStakeholderRiskImpactMutation, CreateStakeholderRiskImpactMutationVariables>;
export const CreateStakeholderStakeImpactDocument = gql`
    mutation CreateStakeholderStakeImpact($stakeId: String!, $stakeholderId: String!) {
  createStakeholderStakeImpact(stakeId: $stakeId, stakeholderId: $stakeholderId) {
    createdAt
    id
    stakeId
    stakeholderId
    strength
  }
}
    `;
export type CreateStakeholderStakeImpactMutationFn = Apollo.MutationFunction<CreateStakeholderStakeImpactMutation, CreateStakeholderStakeImpactMutationVariables>;

/**
 * __useCreateStakeholderStakeImpactMutation__
 *
 * To run a mutation, you first call `useCreateStakeholderStakeImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStakeholderStakeImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStakeholderStakeImpactMutation, { data, loading, error }] = useCreateStakeholderStakeImpactMutation({
 *   variables: {
 *      stakeId: // value for 'stakeId'
 *      stakeholderId: // value for 'stakeholderId'
 *   },
 * });
 */
export function useCreateStakeholderStakeImpactMutation(baseOptions?: Apollo.MutationHookOptions<CreateStakeholderStakeImpactMutation, CreateStakeholderStakeImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStakeholderStakeImpactMutation, CreateStakeholderStakeImpactMutationVariables>(CreateStakeholderStakeImpactDocument, options);
      }
export type CreateStakeholderStakeImpactMutationHookResult = ReturnType<typeof useCreateStakeholderStakeImpactMutation>;
export type CreateStakeholderStakeImpactMutationResult = Apollo.MutationResult<CreateStakeholderStakeImpactMutation>;
export type CreateStakeholderStakeImpactMutationOptions = Apollo.BaseMutationOptions<CreateStakeholderStakeImpactMutation, CreateStakeholderStakeImpactMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($description: String, $name: String!, $projectId: String!) {
  createTag(description: $description, name: $name, projectId: $projectId) {
    createdAt
    description
    id
    name
  }
}
    `;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      description: // value for 'description'
 *      name: // value for 'name'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const CreateTaggingDocument = gql`
    mutation CreateTagging($objectId: String!, $projectId: String!, $tagId: String!, $type: String!) {
  createTagging(
    objectId: $objectId
    projectId: $projectId
    tagId: $tagId
    type: $type
  ) {
    createdAt
    id
    objectId
    tagId
    type
  }
}
    `;
export type CreateTaggingMutationFn = Apollo.MutationFunction<CreateTaggingMutation, CreateTaggingMutationVariables>;

/**
 * __useCreateTaggingMutation__
 *
 * To run a mutation, you first call `useCreateTaggingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaggingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaggingMutation, { data, loading, error }] = useCreateTaggingMutation({
 *   variables: {
 *      objectId: // value for 'objectId'
 *      projectId: // value for 'projectId'
 *      tagId: // value for 'tagId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateTaggingMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaggingMutation, CreateTaggingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaggingMutation, CreateTaggingMutationVariables>(CreateTaggingDocument, options);
      }
export type CreateTaggingMutationHookResult = ReturnType<typeof useCreateTaggingMutation>;
export type CreateTaggingMutationResult = Apollo.MutationResult<CreateTaggingMutation>;
export type CreateTaggingMutationOptions = Apollo.BaseMutationOptions<CreateTaggingMutation, CreateTaggingMutationVariables>;
export const DeleteAttachmentDocument = gql`
    mutation DeleteAttachment($attachmentId: ID!) {
  deleteAttachment(attachmentId: $attachmentId)
}
    `;
export type DeleteAttachmentMutationFn = Apollo.MutationFunction<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;

/**
 * __useDeleteAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAttachmentMutation, { data, loading, error }] = useDeleteAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>(DeleteAttachmentDocument, options);
      }
export type DeleteAttachmentMutationHookResult = ReturnType<typeof useDeleteAttachmentMutation>;
export type DeleteAttachmentMutationResult = Apollo.MutationResult<DeleteAttachmentMutation>;
export type DeleteAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteAttachmentMutation, DeleteAttachmentMutationVariables>;
export const DeleteCommentDocument = gql`
    mutation DeleteComment($id: ID!) {
  deleteComment(id: $id)
}
    `;
export type DeleteCommentMutationFn = Apollo.MutationFunction<DeleteCommentMutation, DeleteCommentMutationVariables>;

/**
 * __useDeleteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentMutation, { data, loading, error }] = useDeleteCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentMutation, DeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, options);
      }
export type DeleteCommentMutationHookResult = ReturnType<typeof useDeleteCommentMutation>;
export type DeleteCommentMutationResult = Apollo.MutationResult<DeleteCommentMutation>;
export type DeleteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCommentMutation, DeleteCommentMutationVariables>;
export const DeleteFishboneBranchDocument = gql`
    mutation DeleteFishboneBranch($id: ID!) {
  deleteFishboneBranch(id: $id)
}
    `;
export type DeleteFishboneBranchMutationFn = Apollo.MutationFunction<DeleteFishboneBranchMutation, DeleteFishboneBranchMutationVariables>;

/**
 * __useDeleteFishboneBranchMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneBranchMutation, { data, loading, error }] = useDeleteFishboneBranchMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneBranchMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneBranchMutation, DeleteFishboneBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneBranchMutation, DeleteFishboneBranchMutationVariables>(DeleteFishboneBranchDocument, options);
      }
export type DeleteFishboneBranchMutationHookResult = ReturnType<typeof useDeleteFishboneBranchMutation>;
export type DeleteFishboneBranchMutationResult = Apollo.MutationResult<DeleteFishboneBranchMutation>;
export type DeleteFishboneBranchMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneBranchMutation, DeleteFishboneBranchMutationVariables>;
export const DeleteFishboneIndicatorLinkDocument = gql`
    mutation DeleteFishboneIndicatorLink($id: ID!) {
  deleteFishboneIndicatorLink(id: $id)
}
    `;
export type DeleteFishboneIndicatorLinkMutationFn = Apollo.MutationFunction<DeleteFishboneIndicatorLinkMutation, DeleteFishboneIndicatorLinkMutationVariables>;

/**
 * __useDeleteFishboneIndicatorLinkMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneIndicatorLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneIndicatorLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneIndicatorLinkMutation, { data, loading, error }] = useDeleteFishboneIndicatorLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneIndicatorLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneIndicatorLinkMutation, DeleteFishboneIndicatorLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneIndicatorLinkMutation, DeleteFishboneIndicatorLinkMutationVariables>(DeleteFishboneIndicatorLinkDocument, options);
      }
export type DeleteFishboneIndicatorLinkMutationHookResult = ReturnType<typeof useDeleteFishboneIndicatorLinkMutation>;
export type DeleteFishboneIndicatorLinkMutationResult = Apollo.MutationResult<DeleteFishboneIndicatorLinkMutation>;
export type DeleteFishboneIndicatorLinkMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneIndicatorLinkMutation, DeleteFishboneIndicatorLinkMutationVariables>;
export const DeleteFishboneItemDocument = gql`
    mutation DeleteFishboneItem($id: ID!) {
  deleteFishboneItem(id: $id)
}
    `;
export type DeleteFishboneItemMutationFn = Apollo.MutationFunction<DeleteFishboneItemMutation, DeleteFishboneItemMutationVariables>;

/**
 * __useDeleteFishboneItemMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneItemMutation, { data, loading, error }] = useDeleteFishboneItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneItemMutation, DeleteFishboneItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneItemMutation, DeleteFishboneItemMutationVariables>(DeleteFishboneItemDocument, options);
      }
export type DeleteFishboneItemMutationHookResult = ReturnType<typeof useDeleteFishboneItemMutation>;
export type DeleteFishboneItemMutationResult = Apollo.MutationResult<DeleteFishboneItemMutation>;
export type DeleteFishboneItemMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneItemMutation, DeleteFishboneItemMutationVariables>;
export const DeleteFishboneRiskLinkDocument = gql`
    mutation DeleteFishboneRiskLink($id: ID!) {
  deleteFishboneRiskLink(id: $id)
}
    `;
export type DeleteFishboneRiskLinkMutationFn = Apollo.MutationFunction<DeleteFishboneRiskLinkMutation, DeleteFishboneRiskLinkMutationVariables>;

/**
 * __useDeleteFishboneRiskLinkMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneRiskLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneRiskLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneRiskLinkMutation, { data, loading, error }] = useDeleteFishboneRiskLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneRiskLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneRiskLinkMutation, DeleteFishboneRiskLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneRiskLinkMutation, DeleteFishboneRiskLinkMutationVariables>(DeleteFishboneRiskLinkDocument, options);
      }
export type DeleteFishboneRiskLinkMutationHookResult = ReturnType<typeof useDeleteFishboneRiskLinkMutation>;
export type DeleteFishboneRiskLinkMutationResult = Apollo.MutationResult<DeleteFishboneRiskLinkMutation>;
export type DeleteFishboneRiskLinkMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneRiskLinkMutation, DeleteFishboneRiskLinkMutationVariables>;
export const DeleteFishboneStakeLinkDocument = gql`
    mutation DeleteFishboneStakeLink($id: ID!) {
  deleteFishboneStakeLink(id: $id)
}
    `;
export type DeleteFishboneStakeLinkMutationFn = Apollo.MutationFunction<DeleteFishboneStakeLinkMutation, DeleteFishboneStakeLinkMutationVariables>;

/**
 * __useDeleteFishboneStakeLinkMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneStakeLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneStakeLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneStakeLinkMutation, { data, loading, error }] = useDeleteFishboneStakeLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneStakeLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneStakeLinkMutation, DeleteFishboneStakeLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneStakeLinkMutation, DeleteFishboneStakeLinkMutationVariables>(DeleteFishboneStakeLinkDocument, options);
      }
export type DeleteFishboneStakeLinkMutationHookResult = ReturnType<typeof useDeleteFishboneStakeLinkMutation>;
export type DeleteFishboneStakeLinkMutationResult = Apollo.MutationResult<DeleteFishboneStakeLinkMutation>;
export type DeleteFishboneStakeLinkMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneStakeLinkMutation, DeleteFishboneStakeLinkMutationVariables>;
export const DeleteFishboneStakeholderLinkDocument = gql`
    mutation DeleteFishboneStakeholderLink($id: ID!) {
  deleteFishboneStakeholderLink(id: $id)
}
    `;
export type DeleteFishboneStakeholderLinkMutationFn = Apollo.MutationFunction<DeleteFishboneStakeholderLinkMutation, DeleteFishboneStakeholderLinkMutationVariables>;

/**
 * __useDeleteFishboneStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useDeleteFishboneStakeholderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFishboneStakeholderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFishboneStakeholderLinkMutation, { data, loading, error }] = useDeleteFishboneStakeholderLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFishboneStakeholderLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFishboneStakeholderLinkMutation, DeleteFishboneStakeholderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFishboneStakeholderLinkMutation, DeleteFishboneStakeholderLinkMutationVariables>(DeleteFishboneStakeholderLinkDocument, options);
      }
export type DeleteFishboneStakeholderLinkMutationHookResult = ReturnType<typeof useDeleteFishboneStakeholderLinkMutation>;
export type DeleteFishboneStakeholderLinkMutationResult = Apollo.MutationResult<DeleteFishboneStakeholderLinkMutation>;
export type DeleteFishboneStakeholderLinkMutationOptions = Apollo.BaseMutationOptions<DeleteFishboneStakeholderLinkMutation, DeleteFishboneStakeholderLinkMutationVariables>;
export const DeleteIndicatorDocument = gql`
    mutation DeleteIndicator($id: ID!) {
  deleteIndicator(id: $id)
}
    `;
export type DeleteIndicatorMutationFn = Apollo.MutationFunction<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;

/**
 * __useDeleteIndicatorMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorMutation, { data, loading, error }] = useDeleteIndicatorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>(DeleteIndicatorDocument, options);
      }
export type DeleteIndicatorMutationHookResult = ReturnType<typeof useDeleteIndicatorMutation>;
export type DeleteIndicatorMutationResult = Apollo.MutationResult<DeleteIndicatorMutation>;
export type DeleteIndicatorMutationOptions = Apollo.BaseMutationOptions<DeleteIndicatorMutation, DeleteIndicatorMutationVariables>;
export const DeleteIndicatorCategoryDocument = gql`
    mutation DeleteIndicatorCategory($id: ID!) {
  deleteIndicatorCategory(id: $id)
}
    `;
export type DeleteIndicatorCategoryMutationFn = Apollo.MutationFunction<DeleteIndicatorCategoryMutation, DeleteIndicatorCategoryMutationVariables>;

/**
 * __useDeleteIndicatorCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteIndicatorCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndicatorCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndicatorCategoryMutation, { data, loading, error }] = useDeleteIndicatorCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndicatorCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndicatorCategoryMutation, DeleteIndicatorCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndicatorCategoryMutation, DeleteIndicatorCategoryMutationVariables>(DeleteIndicatorCategoryDocument, options);
      }
export type DeleteIndicatorCategoryMutationHookResult = ReturnType<typeof useDeleteIndicatorCategoryMutation>;
export type DeleteIndicatorCategoryMutationResult = Apollo.MutationResult<DeleteIndicatorCategoryMutation>;
export type DeleteIndicatorCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteIndicatorCategoryMutation, DeleteIndicatorCategoryMutationVariables>;
export const DeleteProjectDocument = gql`
    mutation DeleteProject($id: ID!) {
  deleteProject(id: $id)
}
    `;
export type DeleteProjectMutationFn = Apollo.MutationFunction<DeleteProjectMutation, DeleteProjectMutationVariables>;

/**
 * __useDeleteProjectMutation__
 *
 * To run a mutation, you first call `useDeleteProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProjectMutation, { data, loading, error }] = useDeleteProjectMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProjectMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProjectMutation, DeleteProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProjectMutation, DeleteProjectMutationVariables>(DeleteProjectDocument, options);
      }
export type DeleteProjectMutationHookResult = ReturnType<typeof useDeleteProjectMutation>;
export type DeleteProjectMutationResult = Apollo.MutationResult<DeleteProjectMutation>;
export type DeleteProjectMutationOptions = Apollo.BaseMutationOptions<DeleteProjectMutation, DeleteProjectMutationVariables>;
export const DeleteRiskDocument = gql`
    mutation DeleteRisk($id: ID!) {
  deleteRisk(id: $id)
}
    `;
export type DeleteRiskMutationFn = Apollo.MutationFunction<DeleteRiskMutation, DeleteRiskMutationVariables>;

/**
 * __useDeleteRiskMutation__
 *
 * To run a mutation, you first call `useDeleteRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskMutation, { data, loading, error }] = useDeleteRiskMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskMutation, DeleteRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRiskMutation, DeleteRiskMutationVariables>(DeleteRiskDocument, options);
      }
export type DeleteRiskMutationHookResult = ReturnType<typeof useDeleteRiskMutation>;
export type DeleteRiskMutationResult = Apollo.MutationResult<DeleteRiskMutation>;
export type DeleteRiskMutationOptions = Apollo.BaseMutationOptions<DeleteRiskMutation, DeleteRiskMutationVariables>;
export const DeleteRiskCategoryDocument = gql`
    mutation DeleteRiskCategory($id: ID!) {
  deleteRiskCategory(id: $id)
}
    `;
export type DeleteRiskCategoryMutationFn = Apollo.MutationFunction<DeleteRiskCategoryMutation, DeleteRiskCategoryMutationVariables>;

/**
 * __useDeleteRiskCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteRiskCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskCategoryMutation, { data, loading, error }] = useDeleteRiskCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskCategoryMutation, DeleteRiskCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRiskCategoryMutation, DeleteRiskCategoryMutationVariables>(DeleteRiskCategoryDocument, options);
      }
export type DeleteRiskCategoryMutationHookResult = ReturnType<typeof useDeleteRiskCategoryMutation>;
export type DeleteRiskCategoryMutationResult = Apollo.MutationResult<DeleteRiskCategoryMutation>;
export type DeleteRiskCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteRiskCategoryMutation, DeleteRiskCategoryMutationVariables>;
export const DeleteRiskIndicatorImpactDocument = gql`
    mutation DeleteRiskIndicatorImpact($id: ID!) {
  deleteRiskIndicatorImpact(id: $id)
}
    `;
export type DeleteRiskIndicatorImpactMutationFn = Apollo.MutationFunction<DeleteRiskIndicatorImpactMutation, DeleteRiskIndicatorImpactMutationVariables>;

/**
 * __useDeleteRiskIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useDeleteRiskIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskIndicatorImpactMutation, { data, loading, error }] = useDeleteRiskIndicatorImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskIndicatorImpactMutation, DeleteRiskIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRiskIndicatorImpactMutation, DeleteRiskIndicatorImpactMutationVariables>(DeleteRiskIndicatorImpactDocument, options);
      }
export type DeleteRiskIndicatorImpactMutationHookResult = ReturnType<typeof useDeleteRiskIndicatorImpactMutation>;
export type DeleteRiskIndicatorImpactMutationResult = Apollo.MutationResult<DeleteRiskIndicatorImpactMutation>;
export type DeleteRiskIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<DeleteRiskIndicatorImpactMutation, DeleteRiskIndicatorImpactMutationVariables>;
export const DeleteRiskOpeningLinkDocument = gql`
    mutation DeleteRiskOpeningLink($id: ID!) {
  deleteRiskOpeningLink(id: $id)
}
    `;
export type DeleteRiskOpeningLinkMutationFn = Apollo.MutationFunction<DeleteRiskOpeningLinkMutation, DeleteRiskOpeningLinkMutationVariables>;

/**
 * __useDeleteRiskOpeningLinkMutation__
 *
 * To run a mutation, you first call `useDeleteRiskOpeningLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskOpeningLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskOpeningLinkMutation, { data, loading, error }] = useDeleteRiskOpeningLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskOpeningLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskOpeningLinkMutation, DeleteRiskOpeningLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRiskOpeningLinkMutation, DeleteRiskOpeningLinkMutationVariables>(DeleteRiskOpeningLinkDocument, options);
      }
export type DeleteRiskOpeningLinkMutationHookResult = ReturnType<typeof useDeleteRiskOpeningLinkMutation>;
export type DeleteRiskOpeningLinkMutationResult = Apollo.MutationResult<DeleteRiskOpeningLinkMutation>;
export type DeleteRiskOpeningLinkMutationOptions = Apollo.BaseMutationOptions<DeleteRiskOpeningLinkMutation, DeleteRiskOpeningLinkMutationVariables>;
export const DeleteRiskStakeImpactDocument = gql`
    mutation DeleteRiskStakeImpact($id: ID!) {
  deleteRiskStakeImpact(id: $id)
}
    `;
export type DeleteRiskStakeImpactMutationFn = Apollo.MutationFunction<DeleteRiskStakeImpactMutation, DeleteRiskStakeImpactMutationVariables>;

/**
 * __useDeleteRiskStakeImpactMutation__
 *
 * To run a mutation, you first call `useDeleteRiskStakeImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRiskStakeImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRiskStakeImpactMutation, { data, loading, error }] = useDeleteRiskStakeImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRiskStakeImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRiskStakeImpactMutation, DeleteRiskStakeImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRiskStakeImpactMutation, DeleteRiskStakeImpactMutationVariables>(DeleteRiskStakeImpactDocument, options);
      }
export type DeleteRiskStakeImpactMutationHookResult = ReturnType<typeof useDeleteRiskStakeImpactMutation>;
export type DeleteRiskStakeImpactMutationResult = Apollo.MutationResult<DeleteRiskStakeImpactMutation>;
export type DeleteRiskStakeImpactMutationOptions = Apollo.BaseMutationOptions<DeleteRiskStakeImpactMutation, DeleteRiskStakeImpactMutationVariables>;
export const DeleteScenarioDocument = gql`
    mutation DeleteScenario($id: ID!) {
  deleteScenario(id: $id)
}
    `;
export type DeleteScenarioMutationFn = Apollo.MutationFunction<DeleteScenarioMutation, DeleteScenarioMutationVariables>;

/**
 * __useDeleteScenarioMutation__
 *
 * To run a mutation, you first call `useDeleteScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScenarioMutation, { data, loading, error }] = useDeleteScenarioMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScenarioMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScenarioMutation, DeleteScenarioMutationVariables>(DeleteScenarioDocument, options);
      }
export type DeleteScenarioMutationHookResult = ReturnType<typeof useDeleteScenarioMutation>;
export type DeleteScenarioMutationResult = Apollo.MutationResult<DeleteScenarioMutation>;
export type DeleteScenarioMutationOptions = Apollo.BaseMutationOptions<DeleteScenarioMutation, DeleteScenarioMutationVariables>;
export const DeleteStakeDocument = gql`
    mutation DeleteStake($id: ID!) {
  deleteStake(id: $id)
}
    `;
export type DeleteStakeMutationFn = Apollo.MutationFunction<DeleteStakeMutation, DeleteStakeMutationVariables>;

/**
 * __useDeleteStakeMutation__
 *
 * To run a mutation, you first call `useDeleteStakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeMutation, { data, loading, error }] = useDeleteStakeMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeMutation, DeleteStakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeMutation, DeleteStakeMutationVariables>(DeleteStakeDocument, options);
      }
export type DeleteStakeMutationHookResult = ReturnType<typeof useDeleteStakeMutation>;
export type DeleteStakeMutationResult = Apollo.MutationResult<DeleteStakeMutation>;
export type DeleteStakeMutationOptions = Apollo.BaseMutationOptions<DeleteStakeMutation, DeleteStakeMutationVariables>;
export const DeleteStakeIndicatorImpactDocument = gql`
    mutation DeleteStakeIndicatorImpact($id: ID!) {
  deleteStakeIndicatorImpact(id: $id)
}
    `;
export type DeleteStakeIndicatorImpactMutationFn = Apollo.MutationFunction<DeleteStakeIndicatorImpactMutation, DeleteStakeIndicatorImpactMutationVariables>;

/**
 * __useDeleteStakeIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useDeleteStakeIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeIndicatorImpactMutation, { data, loading, error }] = useDeleteStakeIndicatorImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeIndicatorImpactMutation, DeleteStakeIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeIndicatorImpactMutation, DeleteStakeIndicatorImpactMutationVariables>(DeleteStakeIndicatorImpactDocument, options);
      }
export type DeleteStakeIndicatorImpactMutationHookResult = ReturnType<typeof useDeleteStakeIndicatorImpactMutation>;
export type DeleteStakeIndicatorImpactMutationResult = Apollo.MutationResult<DeleteStakeIndicatorImpactMutation>;
export type DeleteStakeIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<DeleteStakeIndicatorImpactMutation, DeleteStakeIndicatorImpactMutationVariables>;
export const DeleteStakeholderDocument = gql`
    mutation DeleteStakeholder($id: ID!) {
  deleteStakeholder(id: $id)
}
    `;
export type DeleteStakeholderMutationFn = Apollo.MutationFunction<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>;

/**
 * __useDeleteStakeholderMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderMutation, { data, loading, error }] = useDeleteStakeholderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>(DeleteStakeholderDocument, options);
      }
export type DeleteStakeholderMutationHookResult = ReturnType<typeof useDeleteStakeholderMutation>;
export type DeleteStakeholderMutationResult = Apollo.MutationResult<DeleteStakeholderMutation>;
export type DeleteStakeholderMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderMutation, DeleteStakeholderMutationVariables>;
export const DeleteStakeholderIndicatorImpactDocument = gql`
    mutation DeleteStakeholderIndicatorImpact($id: ID!) {
  deleteStakeholderIndicatorImpact(id: $id)
}
    `;
export type DeleteStakeholderIndicatorImpactMutationFn = Apollo.MutationFunction<DeleteStakeholderIndicatorImpactMutation, DeleteStakeholderIndicatorImpactMutationVariables>;

/**
 * __useDeleteStakeholderIndicatorImpactMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderIndicatorImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderIndicatorImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderIndicatorImpactMutation, { data, loading, error }] = useDeleteStakeholderIndicatorImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeholderIndicatorImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderIndicatorImpactMutation, DeleteStakeholderIndicatorImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderIndicatorImpactMutation, DeleteStakeholderIndicatorImpactMutationVariables>(DeleteStakeholderIndicatorImpactDocument, options);
      }
export type DeleteStakeholderIndicatorImpactMutationHookResult = ReturnType<typeof useDeleteStakeholderIndicatorImpactMutation>;
export type DeleteStakeholderIndicatorImpactMutationResult = Apollo.MutationResult<DeleteStakeholderIndicatorImpactMutation>;
export type DeleteStakeholderIndicatorImpactMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderIndicatorImpactMutation, DeleteStakeholderIndicatorImpactMutationVariables>;
export const DeleteStakeholderLinkDocument = gql`
    mutation DeleteStakeholderLink($id: ID!) {
  deleteStakeholderLink(id: $id)
}
    `;
export type DeleteStakeholderLinkMutationFn = Apollo.MutationFunction<DeleteStakeholderLinkMutation, DeleteStakeholderLinkMutationVariables>;

/**
 * __useDeleteStakeholderLinkMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderLinkMutation, { data, loading, error }] = useDeleteStakeholderLinkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeholderLinkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderLinkMutation, DeleteStakeholderLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderLinkMutation, DeleteStakeholderLinkMutationVariables>(DeleteStakeholderLinkDocument, options);
      }
export type DeleteStakeholderLinkMutationHookResult = ReturnType<typeof useDeleteStakeholderLinkMutation>;
export type DeleteStakeholderLinkMutationResult = Apollo.MutationResult<DeleteStakeholderLinkMutation>;
export type DeleteStakeholderLinkMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderLinkMutation, DeleteStakeholderLinkMutationVariables>;
export const DeleteStakeholderRiskImpactDocument = gql`
    mutation DeleteStakeholderRiskImpact($id: ID!) {
  deleteStakeholderRiskImpact(id: $id)
}
    `;
export type DeleteStakeholderRiskImpactMutationFn = Apollo.MutationFunction<DeleteStakeholderRiskImpactMutation, DeleteStakeholderRiskImpactMutationVariables>;

/**
 * __useDeleteStakeholderRiskImpactMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderRiskImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderRiskImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderRiskImpactMutation, { data, loading, error }] = useDeleteStakeholderRiskImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeholderRiskImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderRiskImpactMutation, DeleteStakeholderRiskImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderRiskImpactMutation, DeleteStakeholderRiskImpactMutationVariables>(DeleteStakeholderRiskImpactDocument, options);
      }
export type DeleteStakeholderRiskImpactMutationHookResult = ReturnType<typeof useDeleteStakeholderRiskImpactMutation>;
export type DeleteStakeholderRiskImpactMutationResult = Apollo.MutationResult<DeleteStakeholderRiskImpactMutation>;
export type DeleteStakeholderRiskImpactMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderRiskImpactMutation, DeleteStakeholderRiskImpactMutationVariables>;
export const DeleteStakeholderStakeImpactDocument = gql`
    mutation DeleteStakeholderStakeImpact($id: ID!) {
  deleteStakeholderStakeImpact(id: $id)
}
    `;
export type DeleteStakeholderStakeImpactMutationFn = Apollo.MutationFunction<DeleteStakeholderStakeImpactMutation, DeleteStakeholderStakeImpactMutationVariables>;

/**
 * __useDeleteStakeholderStakeImpactMutation__
 *
 * To run a mutation, you first call `useDeleteStakeholderStakeImpactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStakeholderStakeImpactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStakeholderStakeImpactMutation, { data, loading, error }] = useDeleteStakeholderStakeImpactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteStakeholderStakeImpactMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStakeholderStakeImpactMutation, DeleteStakeholderStakeImpactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStakeholderStakeImpactMutation, DeleteStakeholderStakeImpactMutationVariables>(DeleteStakeholderStakeImpactDocument, options);
      }
export type DeleteStakeholderStakeImpactMutationHookResult = ReturnType<typeof useDeleteStakeholderStakeImpactMutation>;
export type DeleteStakeholderStakeImpactMutationResult = Apollo.MutationResult<DeleteStakeholderStakeImpactMutation>;
export type DeleteStakeholderStakeImpactMutationOptions = Apollo.BaseMutationOptions<DeleteStakeholderStakeImpactMutation, DeleteStakeholderStakeImpactMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteTag(id: $id)
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const DeleteTaggingDocument = gql`
    mutation DeleteTagging($id: ID!) {
  deleteTagging(id: $id)
}
    `;
export type DeleteTaggingMutationFn = Apollo.MutationFunction<DeleteTaggingMutation, DeleteTaggingMutationVariables>;

/**
 * __useDeleteTaggingMutation__
 *
 * To run a mutation, you first call `useDeleteTaggingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTaggingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTaggingMutation, { data, loading, error }] = useDeleteTaggingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTaggingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTaggingMutation, DeleteTaggingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTaggingMutation, DeleteTaggingMutationVariables>(DeleteTaggingDocument, options);
      }
export type DeleteTaggingMutationHookResult = ReturnType<typeof useDeleteTaggingMutation>;
export type DeleteTaggingMutationResult = Apollo.MutationResult<DeleteTaggingMutation>;
export type DeleteTaggingMutationOptions = Apollo.BaseMutationOptions<DeleteTaggingMutation, DeleteTaggingMutationVariables>;
export const DeleteWatchReportDocument = gql`
    mutation DeleteWatchReport($id: ID!) {
  deleteWatchReport(id: $id)
}
    `;
export type DeleteWatchReportMutationFn = Apollo.MutationFunction<DeleteWatchReportMutation, DeleteWatchReportMutationVariables>;

/**
 * __useDeleteWatchReportMutation__
 *
 * To run a mutation, you first call `useDeleteWatchReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWatchReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWatchReportMutation, { data, loading, error }] = useDeleteWatchReportMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWatchReportMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWatchReportMutation, DeleteWatchReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWatchReportMutation, DeleteWatchReportMutationVariables>(DeleteWatchReportDocument, options);
      }
export type DeleteWatchReportMutationHookResult = ReturnType<typeof useDeleteWatchReportMutation>;
export type DeleteWatchReportMutationResult = Apollo.MutationResult<DeleteWatchReportMutation>;
export type DeleteWatchReportMutationOptions = Apollo.BaseMutationOptions<DeleteWatchReportMutation, DeleteWatchReportMutationVariables>;
export const GenerateMcpTokenDocument = gql`
    mutation GenerateMcpToken($name: String) {
  generateMcpToken(name: $name) {
    endpoint
    info {
      createdAt
      lastUsedAt
      name
      prefix
      revokedAt
    }
    token
  }
}
    `;
export type GenerateMcpTokenMutationFn = Apollo.MutationFunction<GenerateMcpTokenMutation, GenerateMcpTokenMutationVariables>;

/**
 * __useGenerateMcpTokenMutation__
 *
 * To run a mutation, you first call `useGenerateMcpTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateMcpTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateMcpTokenMutation, { data, loading, error }] = useGenerateMcpTokenMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGenerateMcpTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateMcpTokenMutation, GenerateMcpTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateMcpTokenMutation, GenerateMcpTokenMutationVariables>(GenerateMcpTokenDocument, options);
      }
export type GenerateMcpTokenMutationHookResult = ReturnType<typeof useGenerateMcpTokenMutation>;
export type GenerateMcpTokenMutationResult = Apollo.MutationResult<GenerateMcpTokenMutation>;
export type GenerateMcpTokenMutationOptions = Apollo.BaseMutationOptions<GenerateMcpTokenMutation, GenerateMcpTokenMutationVariables>;
export const GetAssetUrlDocument = gql`
    mutation GetAssetUrl($id: String!) {
  getAssetUrl(id: $id)
}
    `;
export type GetAssetUrlMutationFn = Apollo.MutationFunction<GetAssetUrlMutation, GetAssetUrlMutationVariables>;

/**
 * __useGetAssetUrlMutation__
 *
 * To run a mutation, you first call `useGetAssetUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAssetUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAssetUrlMutation, { data, loading, error }] = useGetAssetUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAssetUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetAssetUrlMutation, GetAssetUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAssetUrlMutation, GetAssetUrlMutationVariables>(GetAssetUrlDocument, options);
      }
export type GetAssetUrlMutationHookResult = ReturnType<typeof useGetAssetUrlMutation>;
export type GetAssetUrlMutationResult = Apollo.MutationResult<GetAssetUrlMutation>;
export type GetAssetUrlMutationOptions = Apollo.BaseMutationOptions<GetAssetUrlMutation, GetAssetUrlMutationVariables>;
export const GetCustomerPortalUrlDocument = gql`
    mutation GetCustomerPortalUrl {
  getCustomerPortalUrl
}
    `;
export type GetCustomerPortalUrlMutationFn = Apollo.MutationFunction<GetCustomerPortalUrlMutation, GetCustomerPortalUrlMutationVariables>;

/**
 * __useGetCustomerPortalUrlMutation__
 *
 * To run a mutation, you first call `useGetCustomerPortalUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerPortalUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getCustomerPortalUrlMutation, { data, loading, error }] = useGetCustomerPortalUrlMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomerPortalUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetCustomerPortalUrlMutation, GetCustomerPortalUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetCustomerPortalUrlMutation, GetCustomerPortalUrlMutationVariables>(GetCustomerPortalUrlDocument, options);
      }
export type GetCustomerPortalUrlMutationHookResult = ReturnType<typeof useGetCustomerPortalUrlMutation>;
export type GetCustomerPortalUrlMutationResult = Apollo.MutationResult<GetCustomerPortalUrlMutation>;
export type GetCustomerPortalUrlMutationOptions = Apollo.BaseMutationOptions<GetCustomerPortalUrlMutation, GetCustomerPortalUrlMutationVariables>;
export const ImportScenarioImpactsDocument = gql`
    mutation ImportScenarioImpacts($impacts: String!, $projectId: String!, $scenarioId: String!) {
  importScenarioImpacts(
    impacts: $impacts
    projectId: $projectId
    scenarioId: $scenarioId
  )
}
    `;
export type ImportScenarioImpactsMutationFn = Apollo.MutationFunction<ImportScenarioImpactsMutation, ImportScenarioImpactsMutationVariables>;

/**
 * __useImportScenarioImpactsMutation__
 *
 * To run a mutation, you first call `useImportScenarioImpactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportScenarioImpactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importScenarioImpactsMutation, { data, loading, error }] = useImportScenarioImpactsMutation({
 *   variables: {
 *      impacts: // value for 'impacts'
 *      projectId: // value for 'projectId'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useImportScenarioImpactsMutation(baseOptions?: Apollo.MutationHookOptions<ImportScenarioImpactsMutation, ImportScenarioImpactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportScenarioImpactsMutation, ImportScenarioImpactsMutationVariables>(ImportScenarioImpactsDocument, options);
      }
export type ImportScenarioImpactsMutationHookResult = ReturnType<typeof useImportScenarioImpactsMutation>;
export type ImportScenarioImpactsMutationResult = Apollo.MutationResult<ImportScenarioImpactsMutation>;
export type ImportScenarioImpactsMutationOptions = Apollo.BaseMutationOptions<ImportScenarioImpactsMutation, ImportScenarioImpactsMutationVariables>;
export const MakePaymentDocument = gql`
    mutation MakePayment($price: String!, $referer: String!) {
  makePayment(price: $price, referer: $referer)
}
    `;
export type MakePaymentMutationFn = Apollo.MutationFunction<MakePaymentMutation, MakePaymentMutationVariables>;

/**
 * __useMakePaymentMutation__
 *
 * To run a mutation, you first call `useMakePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makePaymentMutation, { data, loading, error }] = useMakePaymentMutation({
 *   variables: {
 *      price: // value for 'price'
 *      referer: // value for 'referer'
 *   },
 * });
 */
export function useMakePaymentMutation(baseOptions?: Apollo.MutationHookOptions<MakePaymentMutation, MakePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakePaymentMutation, MakePaymentMutationVariables>(MakePaymentDocument, options);
      }
export type MakePaymentMutationHookResult = ReturnType<typeof useMakePaymentMutation>;
export type MakePaymentMutationResult = Apollo.MutationResult<MakePaymentMutation>;
export type MakePaymentMutationOptions = Apollo.BaseMutationOptions<MakePaymentMutation, MakePaymentMutationVariables>;
export const PromoteScenarioAsBaselineDocument = gql`
    mutation PromoteScenarioAsBaseline($baselineNewName: String, $keepBaselineAsScenario: Boolean!, $keepScenario: Boolean!, $projectId: ID!, $scenarioId: ID!) {
  promoteScenarioAsBaseline(
    baselineNewName: $baselineNewName
    keepBaselineAsScenario: $keepBaselineAsScenario
    keepScenario: $keepScenario
    projectId: $projectId
    scenarioId: $scenarioId
  )
}
    `;
export type PromoteScenarioAsBaselineMutationFn = Apollo.MutationFunction<PromoteScenarioAsBaselineMutation, PromoteScenarioAsBaselineMutationVariables>;

/**
 * __usePromoteScenarioAsBaselineMutation__
 *
 * To run a mutation, you first call `usePromoteScenarioAsBaselineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteScenarioAsBaselineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteScenarioAsBaselineMutation, { data, loading, error }] = usePromoteScenarioAsBaselineMutation({
 *   variables: {
 *      baselineNewName: // value for 'baselineNewName'
 *      keepBaselineAsScenario: // value for 'keepBaselineAsScenario'
 *      keepScenario: // value for 'keepScenario'
 *      projectId: // value for 'projectId'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function usePromoteScenarioAsBaselineMutation(baseOptions?: Apollo.MutationHookOptions<PromoteScenarioAsBaselineMutation, PromoteScenarioAsBaselineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteScenarioAsBaselineMutation, PromoteScenarioAsBaselineMutationVariables>(PromoteScenarioAsBaselineDocument, options);
      }
export type PromoteScenarioAsBaselineMutationHookResult = ReturnType<typeof usePromoteScenarioAsBaselineMutation>;
export type PromoteScenarioAsBaselineMutationResult = Apollo.MutationResult<PromoteScenarioAsBaselineMutation>;
export type PromoteScenarioAsBaselineMutationOptions = Apollo.BaseMutationOptions<PromoteScenarioAsBaselineMutation, PromoteScenarioAsBaselineMutationVariables>;
export const PublishAttachmentStatusDocument = gql`
    mutation PublishAttachmentStatus($input: AttachmentStatusInput!) {
  publishAttachmentStatus(input: $input) {
    contentType
    filename
    id
    projectId
    scanError
    size
    status
    tempSessionId
    uploadedAt
  }
}
    `;
export type PublishAttachmentStatusMutationFn = Apollo.MutationFunction<PublishAttachmentStatusMutation, PublishAttachmentStatusMutationVariables>;

/**
 * __usePublishAttachmentStatusMutation__
 *
 * To run a mutation, you first call `usePublishAttachmentStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishAttachmentStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishAttachmentStatusMutation, { data, loading, error }] = usePublishAttachmentStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishAttachmentStatusMutation(baseOptions?: Apollo.MutationHookOptions<PublishAttachmentStatusMutation, PublishAttachmentStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishAttachmentStatusMutation, PublishAttachmentStatusMutationVariables>(PublishAttachmentStatusDocument, options);
      }
export type PublishAttachmentStatusMutationHookResult = ReturnType<typeof usePublishAttachmentStatusMutation>;
export type PublishAttachmentStatusMutationResult = Apollo.MutationResult<PublishAttachmentStatusMutation>;
export type PublishAttachmentStatusMutationOptions = Apollo.BaseMutationOptions<PublishAttachmentStatusMutation, PublishAttachmentStatusMutationVariables>;
export const PublishProjectChangeDocument = gql`
    mutation PublishProjectChange($author: String, $changes: String, $objectId: String!, $operation: String!, $projectId: String!, $type: String!) {
  publishProjectChange(
    author: $author
    changes: $changes
    objectId: $objectId
    operation: $operation
    projectId: $projectId
    type: $type
  ) {
    author
    changes
    objectId
    operation
    projectId
    type
  }
}
    `;
export type PublishProjectChangeMutationFn = Apollo.MutationFunction<PublishProjectChangeMutation, PublishProjectChangeMutationVariables>;

/**
 * __usePublishProjectChangeMutation__
 *
 * To run a mutation, you first call `usePublishProjectChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishProjectChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishProjectChangeMutation, { data, loading, error }] = usePublishProjectChangeMutation({
 *   variables: {
 *      author: // value for 'author'
 *      changes: // value for 'changes'
 *      objectId: // value for 'objectId'
 *      operation: // value for 'operation'
 *      projectId: // value for 'projectId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function usePublishProjectChangeMutation(baseOptions?: Apollo.MutationHookOptions<PublishProjectChangeMutation, PublishProjectChangeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishProjectChangeMutation, PublishProjectChangeMutationVariables>(PublishProjectChangeDocument, options);
      }
export type PublishProjectChangeMutationHookResult = ReturnType<typeof usePublishProjectChangeMutation>;
export type PublishProjectChangeMutationResult = Apollo.MutationResult<PublishProjectChangeMutation>;
export type PublishProjectChangeMutationOptions = Apollo.BaseMutationOptions<PublishProjectChangeMutation, PublishProjectChangeMutationVariables>;
export const PublishProjectMessageDocument = gql`
    mutation PublishProjectMessage($message: String!, $projectId: String!) {
  publishProjectMessage(message: $message, projectId: $projectId) {
    message
    projectId
  }
}
    `;
export type PublishProjectMessageMutationFn = Apollo.MutationFunction<PublishProjectMessageMutation, PublishProjectMessageMutationVariables>;

/**
 * __usePublishProjectMessageMutation__
 *
 * To run a mutation, you first call `usePublishProjectMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishProjectMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishProjectMessageMutation, { data, loading, error }] = usePublishProjectMessageMutation({
 *   variables: {
 *      message: // value for 'message'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePublishProjectMessageMutation(baseOptions?: Apollo.MutationHookOptions<PublishProjectMessageMutation, PublishProjectMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishProjectMessageMutation, PublishProjectMessageMutationVariables>(PublishProjectMessageDocument, options);
      }
export type PublishProjectMessageMutationHookResult = ReturnType<typeof usePublishProjectMessageMutation>;
export type PublishProjectMessageMutationResult = Apollo.MutationResult<PublishProjectMessageMutation>;
export type PublishProjectMessageMutationOptions = Apollo.BaseMutationOptions<PublishProjectMessageMutation, PublishProjectMessageMutationVariables>;
export const RegenerateMcpTokenDocument = gql`
    mutation RegenerateMcpToken($name: String) {
  regenerateMcpToken(name: $name) {
    endpoint
    info {
      createdAt
      lastUsedAt
      name
      prefix
      revokedAt
    }
    token
  }
}
    `;
export type RegenerateMcpTokenMutationFn = Apollo.MutationFunction<RegenerateMcpTokenMutation, RegenerateMcpTokenMutationVariables>;

/**
 * __useRegenerateMcpTokenMutation__
 *
 * To run a mutation, you first call `useRegenerateMcpTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateMcpTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateMcpTokenMutation, { data, loading, error }] = useRegenerateMcpTokenMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRegenerateMcpTokenMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateMcpTokenMutation, RegenerateMcpTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateMcpTokenMutation, RegenerateMcpTokenMutationVariables>(RegenerateMcpTokenDocument, options);
      }
export type RegenerateMcpTokenMutationHookResult = ReturnType<typeof useRegenerateMcpTokenMutation>;
export type RegenerateMcpTokenMutationResult = Apollo.MutationResult<RegenerateMcpTokenMutation>;
export type RegenerateMcpTokenMutationOptions = Apollo.BaseMutationOptions<RegenerateMcpTokenMutation, RegenerateMcpTokenMutationVariables>;
export const RemoveProjectMemberDocument = gql`
    mutation RemoveProjectMember($id: ID!) {
  removeProjectMember(id: $id)
}
    `;
export type RemoveProjectMemberMutationFn = Apollo.MutationFunction<RemoveProjectMemberMutation, RemoveProjectMemberMutationVariables>;

/**
 * __useRemoveProjectMemberMutation__
 *
 * To run a mutation, you first call `useRemoveProjectMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectMemberMutation, { data, loading, error }] = useRemoveProjectMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveProjectMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectMemberMutation, RemoveProjectMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectMemberMutation, RemoveProjectMemberMutationVariables>(RemoveProjectMemberDocument, options);
      }
export type RemoveProjectMemberMutationHookResult = ReturnType<typeof useRemoveProjectMemberMutation>;
export type RemoveProjectMemberMutationResult = Apollo.MutationResult<RemoveProjectMemberMutation>;
export type RemoveProjectMemberMutationOptions = Apollo.BaseMutationOptions<RemoveProjectMemberMutation, RemoveProjectMemberMutationVariables>;
export const RequestAttachmentUploadDocument = gql`
    mutation RequestAttachmentUpload($contentType: String!, $filename: String!, $projectId: String, $size: Float!, $tempSessionId: String) {
  requestAttachmentUpload(
    contentType: $contentType
    filename: $filename
    projectId: $projectId
    size: $size
    tempSessionId: $tempSessionId
  )
}
    `;
export type RequestAttachmentUploadMutationFn = Apollo.MutationFunction<RequestAttachmentUploadMutation, RequestAttachmentUploadMutationVariables>;

/**
 * __useRequestAttachmentUploadMutation__
 *
 * To run a mutation, you first call `useRequestAttachmentUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAttachmentUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAttachmentUploadMutation, { data, loading, error }] = useRequestAttachmentUploadMutation({
 *   variables: {
 *      contentType: // value for 'contentType'
 *      filename: // value for 'filename'
 *      projectId: // value for 'projectId'
 *      size: // value for 'size'
 *      tempSessionId: // value for 'tempSessionId'
 *   },
 * });
 */
export function useRequestAttachmentUploadMutation(baseOptions?: Apollo.MutationHookOptions<RequestAttachmentUploadMutation, RequestAttachmentUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAttachmentUploadMutation, RequestAttachmentUploadMutationVariables>(RequestAttachmentUploadDocument, options);
      }
export type RequestAttachmentUploadMutationHookResult = ReturnType<typeof useRequestAttachmentUploadMutation>;
export type RequestAttachmentUploadMutationResult = Apollo.MutationResult<RequestAttachmentUploadMutation>;
export type RequestAttachmentUploadMutationOptions = Apollo.BaseMutationOptions<RequestAttachmentUploadMutation, RequestAttachmentUploadMutationVariables>;
export const RevokeMcpTokenDocument = gql`
    mutation RevokeMcpToken {
  revokeMcpToken {
    endpoint
    info {
      createdAt
      lastUsedAt
      name
      prefix
      revokedAt
    }
    token
  }
}
    `;
export type RevokeMcpTokenMutationFn = Apollo.MutationFunction<RevokeMcpTokenMutation, RevokeMcpTokenMutationVariables>;

/**
 * __useRevokeMcpTokenMutation__
 *
 * To run a mutation, you first call `useRevokeMcpTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeMcpTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeMcpTokenMutation, { data, loading, error }] = useRevokeMcpTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRevokeMcpTokenMutation(baseOptions?: Apollo.MutationHookOptions<RevokeMcpTokenMutation, RevokeMcpTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeMcpTokenMutation, RevokeMcpTokenMutationVariables>(RevokeMcpTokenDocument, options);
      }
export type RevokeMcpTokenMutationHookResult = ReturnType<typeof useRevokeMcpTokenMutation>;
export type RevokeMcpTokenMutationResult = Apollo.MutationResult<RevokeMcpTokenMutation>;
export type RevokeMcpTokenMutationOptions = Apollo.BaseMutationOptions<RevokeMcpTokenMutation, RevokeMcpTokenMutationVariables>;
export const UpdateCommentDocument = gql`
    mutation UpdateComment($commentedAt: String!, $description: String!, $id: ID!) {
  updateComment(commentedAt: $commentedAt, description: $description, id: $id)
}
    `;
export type UpdateCommentMutationFn = Apollo.MutationFunction<UpdateCommentMutation, UpdateCommentMutationVariables>;

/**
 * __useUpdateCommentMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutation, { data, loading, error }] = useUpdateCommentMutation({
 *   variables: {
 *      commentedAt: // value for 'commentedAt'
 *      description: // value for 'description'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutation, UpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, options);
      }
export type UpdateCommentMutationHookResult = ReturnType<typeof useUpdateCommentMutation>;
export type UpdateCommentMutationResult = Apollo.MutationResult<UpdateCommentMutation>;
export type UpdateCommentMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutation, UpdateCommentMutationVariables>;
export const UpdateFishboneBranchDocument = gql`
    mutation UpdateFishboneBranch($description: String, $enabled: Boolean, $endOn: String, $icon: String, $id: ID!, $name: String, $position: Int, $responsible: String, $startOn: String, $weight: Int) {
  updateFishboneBranch(
    description: $description
    enabled: $enabled
    endOn: $endOn
    icon: $icon
    id: $id
    name: $name
    position: $position
    responsible: $responsible
    startOn: $startOn
    weight: $weight
  )
}
    `;
export type UpdateFishboneBranchMutationFn = Apollo.MutationFunction<UpdateFishboneBranchMutation, UpdateFishboneBranchMutationVariables>;

/**
 * __useUpdateFishboneBranchMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneBranchMutation, { data, loading, error }] = useUpdateFishboneBranchMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      endOn: // value for 'endOn'
 *      icon: // value for 'icon'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      position: // value for 'position'
 *      responsible: // value for 'responsible'
 *      startOn: // value for 'startOn'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateFishboneBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneBranchMutation, UpdateFishboneBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneBranchMutation, UpdateFishboneBranchMutationVariables>(UpdateFishboneBranchDocument, options);
      }
export type UpdateFishboneBranchMutationHookResult = ReturnType<typeof useUpdateFishboneBranchMutation>;
export type UpdateFishboneBranchMutationResult = Apollo.MutationResult<UpdateFishboneBranchMutation>;
export type UpdateFishboneBranchMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneBranchMutation, UpdateFishboneBranchMutationVariables>;
export const UpdateFishboneBranchScenarioDocument = gql`
    mutation UpdateFishboneBranchScenario($enabled: Boolean, $id: ID!, $scenarioId: String, $weight: Int) {
  updateFishboneBranchScenario(
    enabled: $enabled
    id: $id
    scenarioId: $scenarioId
    weight: $weight
  )
}
    `;
export type UpdateFishboneBranchScenarioMutationFn = Apollo.MutationFunction<UpdateFishboneBranchScenarioMutation, UpdateFishboneBranchScenarioMutationVariables>;

/**
 * __useUpdateFishboneBranchScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneBranchScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneBranchScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneBranchScenarioMutation, { data, loading, error }] = useUpdateFishboneBranchScenarioMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      scenarioId: // value for 'scenarioId'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateFishboneBranchScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneBranchScenarioMutation, UpdateFishboneBranchScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneBranchScenarioMutation, UpdateFishboneBranchScenarioMutationVariables>(UpdateFishboneBranchScenarioDocument, options);
      }
export type UpdateFishboneBranchScenarioMutationHookResult = ReturnType<typeof useUpdateFishboneBranchScenarioMutation>;
export type UpdateFishboneBranchScenarioMutationResult = Apollo.MutationResult<UpdateFishboneBranchScenarioMutation>;
export type UpdateFishboneBranchScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneBranchScenarioMutation, UpdateFishboneBranchScenarioMutationVariables>;
export const UpdateFishboneIndicatorLinkStrengthDocument = gql`
    mutation UpdateFishboneIndicatorLinkStrength($id: ID!, $strength: Int!) {
  updateFishboneIndicatorLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateFishboneIndicatorLinkStrengthMutationFn = Apollo.MutationFunction<UpdateFishboneIndicatorLinkStrengthMutation, UpdateFishboneIndicatorLinkStrengthMutationVariables>;

/**
 * __useUpdateFishboneIndicatorLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneIndicatorLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneIndicatorLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneIndicatorLinkStrengthMutation, { data, loading, error }] = useUpdateFishboneIndicatorLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateFishboneIndicatorLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneIndicatorLinkStrengthMutation, UpdateFishboneIndicatorLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneIndicatorLinkStrengthMutation, UpdateFishboneIndicatorLinkStrengthMutationVariables>(UpdateFishboneIndicatorLinkStrengthDocument, options);
      }
export type UpdateFishboneIndicatorLinkStrengthMutationHookResult = ReturnType<typeof useUpdateFishboneIndicatorLinkStrengthMutation>;
export type UpdateFishboneIndicatorLinkStrengthMutationResult = Apollo.MutationResult<UpdateFishboneIndicatorLinkStrengthMutation>;
export type UpdateFishboneIndicatorLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneIndicatorLinkStrengthMutation, UpdateFishboneIndicatorLinkStrengthMutationVariables>;
export const UpdateFishboneItemDocument = gql`
    mutation UpdateFishboneItem($completion: Int, $description: String, $enabled: Boolean, $endOn: String, $evaluatedAt: String, $icon: String, $id: ID!, $name: String, $position: Int, $reference: String, $responsible: String, $startOn: String, $trend: String, $weight: Int) {
  updateFishboneItem(
    completion: $completion
    description: $description
    enabled: $enabled
    endOn: $endOn
    evaluatedAt: $evaluatedAt
    icon: $icon
    id: $id
    name: $name
    position: $position
    reference: $reference
    responsible: $responsible
    startOn: $startOn
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateFishboneItemMutationFn = Apollo.MutationFunction<UpdateFishboneItemMutation, UpdateFishboneItemMutationVariables>;

/**
 * __useUpdateFishboneItemMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneItemMutation, { data, loading, error }] = useUpdateFishboneItemMutation({
 *   variables: {
 *      completion: // value for 'completion'
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      endOn: // value for 'endOn'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      icon: // value for 'icon'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      position: // value for 'position'
 *      reference: // value for 'reference'
 *      responsible: // value for 'responsible'
 *      startOn: // value for 'startOn'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateFishboneItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneItemMutation, UpdateFishboneItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneItemMutation, UpdateFishboneItemMutationVariables>(UpdateFishboneItemDocument, options);
      }
export type UpdateFishboneItemMutationHookResult = ReturnType<typeof useUpdateFishboneItemMutation>;
export type UpdateFishboneItemMutationResult = Apollo.MutationResult<UpdateFishboneItemMutation>;
export type UpdateFishboneItemMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneItemMutation, UpdateFishboneItemMutationVariables>;
export const UpdateFishboneItemBranchDocument = gql`
    mutation UpdateFishboneItemBranch($fishboneBranchId: String!, $id: ID!) {
  updateFishboneItemBranch(fishboneBranchId: $fishboneBranchId, id: $id)
}
    `;
export type UpdateFishboneItemBranchMutationFn = Apollo.MutationFunction<UpdateFishboneItemBranchMutation, UpdateFishboneItemBranchMutationVariables>;

/**
 * __useUpdateFishboneItemBranchMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneItemBranchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneItemBranchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneItemBranchMutation, { data, loading, error }] = useUpdateFishboneItemBranchMutation({
 *   variables: {
 *      fishboneBranchId: // value for 'fishboneBranchId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateFishboneItemBranchMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneItemBranchMutation, UpdateFishboneItemBranchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneItemBranchMutation, UpdateFishboneItemBranchMutationVariables>(UpdateFishboneItemBranchDocument, options);
      }
export type UpdateFishboneItemBranchMutationHookResult = ReturnType<typeof useUpdateFishboneItemBranchMutation>;
export type UpdateFishboneItemBranchMutationResult = Apollo.MutationResult<UpdateFishboneItemBranchMutation>;
export type UpdateFishboneItemBranchMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneItemBranchMutation, UpdateFishboneItemBranchMutationVariables>;
export const UpdateFishboneItemScenarioDocument = gql`
    mutation UpdateFishboneItemScenario($completion: Int, $enabled: Boolean, $id: ID!, $scenarioId: String, $trend: String, $weight: Int) {
  updateFishboneItemScenario(
    completion: $completion
    enabled: $enabled
    id: $id
    scenarioId: $scenarioId
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateFishboneItemScenarioMutationFn = Apollo.MutationFunction<UpdateFishboneItemScenarioMutation, UpdateFishboneItemScenarioMutationVariables>;

/**
 * __useUpdateFishboneItemScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneItemScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneItemScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneItemScenarioMutation, { data, loading, error }] = useUpdateFishboneItemScenarioMutation({
 *   variables: {
 *      completion: // value for 'completion'
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      scenarioId: // value for 'scenarioId'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateFishboneItemScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneItemScenarioMutation, UpdateFishboneItemScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneItemScenarioMutation, UpdateFishboneItemScenarioMutationVariables>(UpdateFishboneItemScenarioDocument, options);
      }
export type UpdateFishboneItemScenarioMutationHookResult = ReturnType<typeof useUpdateFishboneItemScenarioMutation>;
export type UpdateFishboneItemScenarioMutationResult = Apollo.MutationResult<UpdateFishboneItemScenarioMutation>;
export type UpdateFishboneItemScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneItemScenarioMutation, UpdateFishboneItemScenarioMutationVariables>;
export const UpdateFishboneRiskLinkStrengthDocument = gql`
    mutation UpdateFishboneRiskLinkStrength($id: ID!, $strength: Int!) {
  updateFishboneRiskLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateFishboneRiskLinkStrengthMutationFn = Apollo.MutationFunction<UpdateFishboneRiskLinkStrengthMutation, UpdateFishboneRiskLinkStrengthMutationVariables>;

/**
 * __useUpdateFishboneRiskLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneRiskLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneRiskLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneRiskLinkStrengthMutation, { data, loading, error }] = useUpdateFishboneRiskLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateFishboneRiskLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneRiskLinkStrengthMutation, UpdateFishboneRiskLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneRiskLinkStrengthMutation, UpdateFishboneRiskLinkStrengthMutationVariables>(UpdateFishboneRiskLinkStrengthDocument, options);
      }
export type UpdateFishboneRiskLinkStrengthMutationHookResult = ReturnType<typeof useUpdateFishboneRiskLinkStrengthMutation>;
export type UpdateFishboneRiskLinkStrengthMutationResult = Apollo.MutationResult<UpdateFishboneRiskLinkStrengthMutation>;
export type UpdateFishboneRiskLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneRiskLinkStrengthMutation, UpdateFishboneRiskLinkStrengthMutationVariables>;
export const UpdateFishboneStakeLinkStrengthDocument = gql`
    mutation UpdateFishboneStakeLinkStrength($id: ID!, $strength: Int!) {
  updateFishboneStakeLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateFishboneStakeLinkStrengthMutationFn = Apollo.MutationFunction<UpdateFishboneStakeLinkStrengthMutation, UpdateFishboneStakeLinkStrengthMutationVariables>;

/**
 * __useUpdateFishboneStakeLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneStakeLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneStakeLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneStakeLinkStrengthMutation, { data, loading, error }] = useUpdateFishboneStakeLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateFishboneStakeLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneStakeLinkStrengthMutation, UpdateFishboneStakeLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneStakeLinkStrengthMutation, UpdateFishboneStakeLinkStrengthMutationVariables>(UpdateFishboneStakeLinkStrengthDocument, options);
      }
export type UpdateFishboneStakeLinkStrengthMutationHookResult = ReturnType<typeof useUpdateFishboneStakeLinkStrengthMutation>;
export type UpdateFishboneStakeLinkStrengthMutationResult = Apollo.MutationResult<UpdateFishboneStakeLinkStrengthMutation>;
export type UpdateFishboneStakeLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneStakeLinkStrengthMutation, UpdateFishboneStakeLinkStrengthMutationVariables>;
export const UpdateFishboneStakeholderLinkStrengthDocument = gql`
    mutation UpdateFishboneStakeholderLinkStrength($id: ID!, $strength: Int!) {
  updateFishboneStakeholderLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateFishboneStakeholderLinkStrengthMutationFn = Apollo.MutationFunction<UpdateFishboneStakeholderLinkStrengthMutation, UpdateFishboneStakeholderLinkStrengthMutationVariables>;

/**
 * __useUpdateFishboneStakeholderLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateFishboneStakeholderLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFishboneStakeholderLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFishboneStakeholderLinkStrengthMutation, { data, loading, error }] = useUpdateFishboneStakeholderLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateFishboneStakeholderLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFishboneStakeholderLinkStrengthMutation, UpdateFishboneStakeholderLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFishboneStakeholderLinkStrengthMutation, UpdateFishboneStakeholderLinkStrengthMutationVariables>(UpdateFishboneStakeholderLinkStrengthDocument, options);
      }
export type UpdateFishboneStakeholderLinkStrengthMutationHookResult = ReturnType<typeof useUpdateFishboneStakeholderLinkStrengthMutation>;
export type UpdateFishboneStakeholderLinkStrengthMutationResult = Apollo.MutationResult<UpdateFishboneStakeholderLinkStrengthMutation>;
export type UpdateFishboneStakeholderLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateFishboneStakeholderLinkStrengthMutation, UpdateFishboneStakeholderLinkStrengthMutationVariables>;
export const UpdateIndicatorDocument = gql`
    mutation UpdateIndicator($description: String, $enabled: Boolean, $evaluatedAt: String, $frequency: String, $id: ID!, $indicatorCategoryId: String, $name: String, $reference: String, $trend: String, $weight: Int) {
  updateIndicator(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    frequency: $frequency
    id: $id
    indicatorCategoryId: $indicatorCategoryId
    name: $name
    reference: $reference
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateIndicatorMutationFn = Apollo.MutationFunction<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;

/**
 * __useUpdateIndicatorMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorMutation, { data, loading, error }] = useUpdateIndicatorMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      id: // value for 'id'
 *      indicatorCategoryId: // value for 'indicatorCategoryId'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateIndicatorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>(UpdateIndicatorDocument, options);
      }
export type UpdateIndicatorMutationHookResult = ReturnType<typeof useUpdateIndicatorMutation>;
export type UpdateIndicatorMutationResult = Apollo.MutationResult<UpdateIndicatorMutation>;
export type UpdateIndicatorMutationOptions = Apollo.BaseMutationOptions<UpdateIndicatorMutation, UpdateIndicatorMutationVariables>;
export const UpdateIndicatorCategoryDocument = gql`
    mutation UpdateIndicatorCategory($description: String, $id: ID!, $name: String, $weight: Int) {
  updateIndicatorCategory(
    description: $description
    id: $id
    name: $name
    weight: $weight
  )
}
    `;
export type UpdateIndicatorCategoryMutationFn = Apollo.MutationFunction<UpdateIndicatorCategoryMutation, UpdateIndicatorCategoryMutationVariables>;

/**
 * __useUpdateIndicatorCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorCategoryMutation, { data, loading, error }] = useUpdateIndicatorCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateIndicatorCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicatorCategoryMutation, UpdateIndicatorCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicatorCategoryMutation, UpdateIndicatorCategoryMutationVariables>(UpdateIndicatorCategoryDocument, options);
      }
export type UpdateIndicatorCategoryMutationHookResult = ReturnType<typeof useUpdateIndicatorCategoryMutation>;
export type UpdateIndicatorCategoryMutationResult = Apollo.MutationResult<UpdateIndicatorCategoryMutation>;
export type UpdateIndicatorCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateIndicatorCategoryMutation, UpdateIndicatorCategoryMutationVariables>;
export const UpdateIndicatorScenarioDocument = gql`
    mutation UpdateIndicatorScenario($enabled: Boolean, $id: ID!, $scenarioId: String, $trend: String, $weight: Int) {
  updateIndicatorScenario(
    enabled: $enabled
    id: $id
    scenarioId: $scenarioId
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateIndicatorScenarioMutationFn = Apollo.MutationFunction<UpdateIndicatorScenarioMutation, UpdateIndicatorScenarioMutationVariables>;

/**
 * __useUpdateIndicatorScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateIndicatorScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIndicatorScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIndicatorScenarioMutation, { data, loading, error }] = useUpdateIndicatorScenarioMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      scenarioId: // value for 'scenarioId'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateIndicatorScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIndicatorScenarioMutation, UpdateIndicatorScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIndicatorScenarioMutation, UpdateIndicatorScenarioMutationVariables>(UpdateIndicatorScenarioDocument, options);
      }
export type UpdateIndicatorScenarioMutationHookResult = ReturnType<typeof useUpdateIndicatorScenarioMutation>;
export type UpdateIndicatorScenarioMutationResult = Apollo.MutationResult<UpdateIndicatorScenarioMutation>;
export type UpdateIndicatorScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateIndicatorScenarioMutation, UpdateIndicatorScenarioMutationVariables>;
export const UpdateProjectDocument = gql`
    mutation UpdateProject($analysisSummary: String, $baselineScenarioDescription: String, $baselineScenarioImpacts: String, $description: String, $descriptionLong: String, $fishboneDescription: String, $fishboneEndOn: String, $fishboneStartOn: String, $id: ID!, $impacts: [ImpactLevelInput], $likelihoods: [LikelihoodLevelInput], $name: String, $reference: String, $responsible: String, $type: String, $vision: String) {
  updateProject(
    analysisSummary: $analysisSummary
    baselineScenarioDescription: $baselineScenarioDescription
    baselineScenarioImpacts: $baselineScenarioImpacts
    description: $description
    descriptionLong: $descriptionLong
    fishboneDescription: $fishboneDescription
    fishboneEndOn: $fishboneEndOn
    fishboneStartOn: $fishboneStartOn
    id: $id
    impacts: $impacts
    likelihoods: $likelihoods
    name: $name
    reference: $reference
    responsible: $responsible
    type: $type
    vision: $vision
  )
}
    `;
export type UpdateProjectMutationFn = Apollo.MutationFunction<UpdateProjectMutation, UpdateProjectMutationVariables>;

/**
 * __useUpdateProjectMutation__
 *
 * To run a mutation, you first call `useUpdateProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectMutation, { data, loading, error }] = useUpdateProjectMutation({
 *   variables: {
 *      analysisSummary: // value for 'analysisSummary'
 *      baselineScenarioDescription: // value for 'baselineScenarioDescription'
 *      baselineScenarioImpacts: // value for 'baselineScenarioImpacts'
 *      description: // value for 'description'
 *      descriptionLong: // value for 'descriptionLong'
 *      fishboneDescription: // value for 'fishboneDescription'
 *      fishboneEndOn: // value for 'fishboneEndOn'
 *      fishboneStartOn: // value for 'fishboneStartOn'
 *      id: // value for 'id'
 *      impacts: // value for 'impacts'
 *      likelihoods: // value for 'likelihoods'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      responsible: // value for 'responsible'
 *      type: // value for 'type'
 *      vision: // value for 'vision'
 *   },
 * });
 */
export function useUpdateProjectMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectMutation, UpdateProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectMutation, UpdateProjectMutationVariables>(UpdateProjectDocument, options);
      }
export type UpdateProjectMutationHookResult = ReturnType<typeof useUpdateProjectMutation>;
export type UpdateProjectMutationResult = Apollo.MutationResult<UpdateProjectMutation>;
export type UpdateProjectMutationOptions = Apollo.BaseMutationOptions<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateRiskDocument = gql`
    mutation UpdateRisk($description: String, $enabled: Boolean, $evaluatedAt: String, $id: ID!, $impact: Float, $isOpportunity: Boolean, $likelihood: Float, $name: String, $reference: String, $riskCategoryId: String) {
  updateRisk(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    id: $id
    impact: $impact
    isOpportunity: $isOpportunity
    likelihood: $likelihood
    name: $name
    reference: $reference
    riskCategoryId: $riskCategoryId
  )
}
    `;
export type UpdateRiskMutationFn = Apollo.MutationFunction<UpdateRiskMutation, UpdateRiskMutationVariables>;

/**
 * __useUpdateRiskMutation__
 *
 * To run a mutation, you first call `useUpdateRiskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskMutation, { data, loading, error }] = useUpdateRiskMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      id: // value for 'id'
 *      impact: // value for 'impact'
 *      isOpportunity: // value for 'isOpportunity'
 *      likelihood: // value for 'likelihood'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      riskCategoryId: // value for 'riskCategoryId'
 *   },
 * });
 */
export function useUpdateRiskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskMutation, UpdateRiskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskMutation, UpdateRiskMutationVariables>(UpdateRiskDocument, options);
      }
export type UpdateRiskMutationHookResult = ReturnType<typeof useUpdateRiskMutation>;
export type UpdateRiskMutationResult = Apollo.MutationResult<UpdateRiskMutation>;
export type UpdateRiskMutationOptions = Apollo.BaseMutationOptions<UpdateRiskMutation, UpdateRiskMutationVariables>;
export const UpdateRiskCategoryDocument = gql`
    mutation UpdateRiskCategory($description: String, $id: ID!, $name: String, $weight: Int) {
  updateRiskCategory(
    description: $description
    id: $id
    name: $name
    weight: $weight
  )
}
    `;
export type UpdateRiskCategoryMutationFn = Apollo.MutationFunction<UpdateRiskCategoryMutation, UpdateRiskCategoryMutationVariables>;

/**
 * __useUpdateRiskCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateRiskCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskCategoryMutation, { data, loading, error }] = useUpdateRiskCategoryMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateRiskCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskCategoryMutation, UpdateRiskCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskCategoryMutation, UpdateRiskCategoryMutationVariables>(UpdateRiskCategoryDocument, options);
      }
export type UpdateRiskCategoryMutationHookResult = ReturnType<typeof useUpdateRiskCategoryMutation>;
export type UpdateRiskCategoryMutationResult = Apollo.MutationResult<UpdateRiskCategoryMutation>;
export type UpdateRiskCategoryMutationOptions = Apollo.BaseMutationOptions<UpdateRiskCategoryMutation, UpdateRiskCategoryMutationVariables>;
export const UpdateRiskIndicatorImpactStrengthDocument = gql`
    mutation UpdateRiskIndicatorImpactStrength($id: ID!, $strength: Int!) {
  updateRiskIndicatorImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateRiskIndicatorImpactStrengthMutationFn = Apollo.MutationFunction<UpdateRiskIndicatorImpactStrengthMutation, UpdateRiskIndicatorImpactStrengthMutationVariables>;

/**
 * __useUpdateRiskIndicatorImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateRiskIndicatorImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskIndicatorImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskIndicatorImpactStrengthMutation, { data, loading, error }] = useUpdateRiskIndicatorImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateRiskIndicatorImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskIndicatorImpactStrengthMutation, UpdateRiskIndicatorImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskIndicatorImpactStrengthMutation, UpdateRiskIndicatorImpactStrengthMutationVariables>(UpdateRiskIndicatorImpactStrengthDocument, options);
      }
export type UpdateRiskIndicatorImpactStrengthMutationHookResult = ReturnType<typeof useUpdateRiskIndicatorImpactStrengthMutation>;
export type UpdateRiskIndicatorImpactStrengthMutationResult = Apollo.MutationResult<UpdateRiskIndicatorImpactStrengthMutation>;
export type UpdateRiskIndicatorImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateRiskIndicatorImpactStrengthMutation, UpdateRiskIndicatorImpactStrengthMutationVariables>;
export const UpdateRiskOpeningLinkStrengthDocument = gql`
    mutation UpdateRiskOpeningLinkStrength($id: ID!, $strength: Int!) {
  updateRiskOpeningLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateRiskOpeningLinkStrengthMutationFn = Apollo.MutationFunction<UpdateRiskOpeningLinkStrengthMutation, UpdateRiskOpeningLinkStrengthMutationVariables>;

/**
 * __useUpdateRiskOpeningLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateRiskOpeningLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskOpeningLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskOpeningLinkStrengthMutation, { data, loading, error }] = useUpdateRiskOpeningLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateRiskOpeningLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskOpeningLinkStrengthMutation, UpdateRiskOpeningLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskOpeningLinkStrengthMutation, UpdateRiskOpeningLinkStrengthMutationVariables>(UpdateRiskOpeningLinkStrengthDocument, options);
      }
export type UpdateRiskOpeningLinkStrengthMutationHookResult = ReturnType<typeof useUpdateRiskOpeningLinkStrengthMutation>;
export type UpdateRiskOpeningLinkStrengthMutationResult = Apollo.MutationResult<UpdateRiskOpeningLinkStrengthMutation>;
export type UpdateRiskOpeningLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateRiskOpeningLinkStrengthMutation, UpdateRiskOpeningLinkStrengthMutationVariables>;
export const UpdateRiskScenarioDocument = gql`
    mutation UpdateRiskScenario($enabled: Boolean, $id: ID!, $impact: Float, $likelihood: Float, $scenarioId: String) {
  updateRiskScenario(
    enabled: $enabled
    id: $id
    impact: $impact
    likelihood: $likelihood
    scenarioId: $scenarioId
  )
}
    `;
export type UpdateRiskScenarioMutationFn = Apollo.MutationFunction<UpdateRiskScenarioMutation, UpdateRiskScenarioMutationVariables>;

/**
 * __useUpdateRiskScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateRiskScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskScenarioMutation, { data, loading, error }] = useUpdateRiskScenarioMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      impact: // value for 'impact'
 *      likelihood: // value for 'likelihood'
 *      scenarioId: // value for 'scenarioId'
 *   },
 * });
 */
export function useUpdateRiskScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskScenarioMutation, UpdateRiskScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskScenarioMutation, UpdateRiskScenarioMutationVariables>(UpdateRiskScenarioDocument, options);
      }
export type UpdateRiskScenarioMutationHookResult = ReturnType<typeof useUpdateRiskScenarioMutation>;
export type UpdateRiskScenarioMutationResult = Apollo.MutationResult<UpdateRiskScenarioMutation>;
export type UpdateRiskScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateRiskScenarioMutation, UpdateRiskScenarioMutationVariables>;
export const UpdateRiskStakeImpactStrengthDocument = gql`
    mutation UpdateRiskStakeImpactStrength($id: ID!, $strength: Int!) {
  updateRiskStakeImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateRiskStakeImpactStrengthMutationFn = Apollo.MutationFunction<UpdateRiskStakeImpactStrengthMutation, UpdateRiskStakeImpactStrengthMutationVariables>;

/**
 * __useUpdateRiskStakeImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateRiskStakeImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRiskStakeImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRiskStakeImpactStrengthMutation, { data, loading, error }] = useUpdateRiskStakeImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateRiskStakeImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRiskStakeImpactStrengthMutation, UpdateRiskStakeImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRiskStakeImpactStrengthMutation, UpdateRiskStakeImpactStrengthMutationVariables>(UpdateRiskStakeImpactStrengthDocument, options);
      }
export type UpdateRiskStakeImpactStrengthMutationHookResult = ReturnType<typeof useUpdateRiskStakeImpactStrengthMutation>;
export type UpdateRiskStakeImpactStrengthMutationResult = Apollo.MutationResult<UpdateRiskStakeImpactStrengthMutation>;
export type UpdateRiskStakeImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateRiskStakeImpactStrengthMutation, UpdateRiskStakeImpactStrengthMutationVariables>;
export const UpdateScenarioDocument = gql`
    mutation UpdateScenario($description: String, $id: ID!, $impacts: String, $name: String) {
  updateScenario(
    description: $description
    id: $id
    impacts: $impacts
    name: $name
  )
}
    `;
export type UpdateScenarioMutationFn = Apollo.MutationFunction<UpdateScenarioMutation, UpdateScenarioMutationVariables>;

/**
 * __useUpdateScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScenarioMutation, { data, loading, error }] = useUpdateScenarioMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      impacts: // value for 'impacts'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScenarioMutation, UpdateScenarioMutationVariables>(UpdateScenarioDocument, options);
      }
export type UpdateScenarioMutationHookResult = ReturnType<typeof useUpdateScenarioMutation>;
export type UpdateScenarioMutationResult = Apollo.MutationResult<UpdateScenarioMutation>;
export type UpdateScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateScenarioMutation, UpdateScenarioMutationVariables>;
export const UpdateStakeDocument = gql`
    mutation UpdateStake($description: String, $enabled: Boolean, $evaluatedAt: String, $id: ID!, $name: String, $reference: String, $trend: String, $weight: Int) {
  updateStake(
    description: $description
    enabled: $enabled
    evaluatedAt: $evaluatedAt
    id: $id
    name: $name
    reference: $reference
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateStakeMutationFn = Apollo.MutationFunction<UpdateStakeMutation, UpdateStakeMutationVariables>;

/**
 * __useUpdateStakeMutation__
 *
 * To run a mutation, you first call `useUpdateStakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeMutation, { data, loading, error }] = useUpdateStakeMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      evaluatedAt: // value for 'evaluatedAt'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      reference: // value for 'reference'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateStakeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeMutation, UpdateStakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeMutation, UpdateStakeMutationVariables>(UpdateStakeDocument, options);
      }
export type UpdateStakeMutationHookResult = ReturnType<typeof useUpdateStakeMutation>;
export type UpdateStakeMutationResult = Apollo.MutationResult<UpdateStakeMutation>;
export type UpdateStakeMutationOptions = Apollo.BaseMutationOptions<UpdateStakeMutation, UpdateStakeMutationVariables>;
export const UpdateStakeIndicatorImpactStrengthDocument = gql`
    mutation UpdateStakeIndicatorImpactStrength($id: ID!, $strength: Int!) {
  updateStakeIndicatorImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateStakeIndicatorImpactStrengthMutationFn = Apollo.MutationFunction<UpdateStakeIndicatorImpactStrengthMutation, UpdateStakeIndicatorImpactStrengthMutationVariables>;

/**
 * __useUpdateStakeIndicatorImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateStakeIndicatorImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeIndicatorImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeIndicatorImpactStrengthMutation, { data, loading, error }] = useUpdateStakeIndicatorImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateStakeIndicatorImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeIndicatorImpactStrengthMutation, UpdateStakeIndicatorImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeIndicatorImpactStrengthMutation, UpdateStakeIndicatorImpactStrengthMutationVariables>(UpdateStakeIndicatorImpactStrengthDocument, options);
      }
export type UpdateStakeIndicatorImpactStrengthMutationHookResult = ReturnType<typeof useUpdateStakeIndicatorImpactStrengthMutation>;
export type UpdateStakeIndicatorImpactStrengthMutationResult = Apollo.MutationResult<UpdateStakeIndicatorImpactStrengthMutation>;
export type UpdateStakeIndicatorImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateStakeIndicatorImpactStrengthMutation, UpdateStakeIndicatorImpactStrengthMutationVariables>;
export const UpdateStakeScenarioDocument = gql`
    mutation UpdateStakeScenario($enabled: Boolean, $id: ID!, $scenarioId: String, $trend: String, $weight: Int) {
  updateStakeScenario(
    enabled: $enabled
    id: $id
    scenarioId: $scenarioId
    trend: $trend
    weight: $weight
  )
}
    `;
export type UpdateStakeScenarioMutationFn = Apollo.MutationFunction<UpdateStakeScenarioMutation, UpdateStakeScenarioMutationVariables>;

/**
 * __useUpdateStakeScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateStakeScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeScenarioMutation, { data, loading, error }] = useUpdateStakeScenarioMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      scenarioId: // value for 'scenarioId'
 *      trend: // value for 'trend'
 *      weight: // value for 'weight'
 *   },
 * });
 */
export function useUpdateStakeScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeScenarioMutation, UpdateStakeScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeScenarioMutation, UpdateStakeScenarioMutationVariables>(UpdateStakeScenarioDocument, options);
      }
export type UpdateStakeScenarioMutationHookResult = ReturnType<typeof useUpdateStakeScenarioMutation>;
export type UpdateStakeScenarioMutationResult = Apollo.MutationResult<UpdateStakeScenarioMutation>;
export type UpdateStakeScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateStakeScenarioMutation, UpdateStakeScenarioMutationVariables>;
export const UpdateStakeholderDocument = gql`
    mutation UpdateStakeholder($description: String, $enabled: Boolean, $icon: String, $id: ID!, $impact: String, $name: String, $trend: String, $x: Float, $y: Float) {
  updateStakeholder(
    description: $description
    enabled: $enabled
    icon: $icon
    id: $id
    impact: $impact
    name: $name
    trend: $trend
    x: $x
    y: $y
  )
}
    `;
export type UpdateStakeholderMutationFn = Apollo.MutationFunction<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>;

/**
 * __useUpdateStakeholderMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderMutation, { data, loading, error }] = useUpdateStakeholderMutation({
 *   variables: {
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      icon: // value for 'icon'
 *      id: // value for 'id'
 *      impact: // value for 'impact'
 *      name: // value for 'name'
 *      trend: // value for 'trend'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *   },
 * });
 */
export function useUpdateStakeholderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>(UpdateStakeholderDocument, options);
      }
export type UpdateStakeholderMutationHookResult = ReturnType<typeof useUpdateStakeholderMutation>;
export type UpdateStakeholderMutationResult = Apollo.MutationResult<UpdateStakeholderMutation>;
export type UpdateStakeholderMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderMutation, UpdateStakeholderMutationVariables>;
export const UpdateStakeholderIndicatorImpactStrengthDocument = gql`
    mutation UpdateStakeholderIndicatorImpactStrength($id: ID!, $strength: Int!) {
  updateStakeholderIndicatorImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateStakeholderIndicatorImpactStrengthMutationFn = Apollo.MutationFunction<UpdateStakeholderIndicatorImpactStrengthMutation, UpdateStakeholderIndicatorImpactStrengthMutationVariables>;

/**
 * __useUpdateStakeholderIndicatorImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderIndicatorImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderIndicatorImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderIndicatorImpactStrengthMutation, { data, loading, error }] = useUpdateStakeholderIndicatorImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateStakeholderIndicatorImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderIndicatorImpactStrengthMutation, UpdateStakeholderIndicatorImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderIndicatorImpactStrengthMutation, UpdateStakeholderIndicatorImpactStrengthMutationVariables>(UpdateStakeholderIndicatorImpactStrengthDocument, options);
      }
export type UpdateStakeholderIndicatorImpactStrengthMutationHookResult = ReturnType<typeof useUpdateStakeholderIndicatorImpactStrengthMutation>;
export type UpdateStakeholderIndicatorImpactStrengthMutationResult = Apollo.MutationResult<UpdateStakeholderIndicatorImpactStrengthMutation>;
export type UpdateStakeholderIndicatorImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderIndicatorImpactStrengthMutation, UpdateStakeholderIndicatorImpactStrengthMutationVariables>;
export const UpdateStakeholderLinkStrengthDocument = gql`
    mutation UpdateStakeholderLinkStrength($id: ID!, $strength: Int!) {
  updateStakeholderLinkStrength(id: $id, strength: $strength)
}
    `;
export type UpdateStakeholderLinkStrengthMutationFn = Apollo.MutationFunction<UpdateStakeholderLinkStrengthMutation, UpdateStakeholderLinkStrengthMutationVariables>;

/**
 * __useUpdateStakeholderLinkStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderLinkStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderLinkStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderLinkStrengthMutation, { data, loading, error }] = useUpdateStakeholderLinkStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateStakeholderLinkStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderLinkStrengthMutation, UpdateStakeholderLinkStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderLinkStrengthMutation, UpdateStakeholderLinkStrengthMutationVariables>(UpdateStakeholderLinkStrengthDocument, options);
      }
export type UpdateStakeholderLinkStrengthMutationHookResult = ReturnType<typeof useUpdateStakeholderLinkStrengthMutation>;
export type UpdateStakeholderLinkStrengthMutationResult = Apollo.MutationResult<UpdateStakeholderLinkStrengthMutation>;
export type UpdateStakeholderLinkStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderLinkStrengthMutation, UpdateStakeholderLinkStrengthMutationVariables>;
export const UpdateStakeholderRiskImpactStrengthDocument = gql`
    mutation UpdateStakeholderRiskImpactStrength($id: ID!, $strength: Int!) {
  updateStakeholderRiskImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateStakeholderRiskImpactStrengthMutationFn = Apollo.MutationFunction<UpdateStakeholderRiskImpactStrengthMutation, UpdateStakeholderRiskImpactStrengthMutationVariables>;

/**
 * __useUpdateStakeholderRiskImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderRiskImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderRiskImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderRiskImpactStrengthMutation, { data, loading, error }] = useUpdateStakeholderRiskImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateStakeholderRiskImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderRiskImpactStrengthMutation, UpdateStakeholderRiskImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderRiskImpactStrengthMutation, UpdateStakeholderRiskImpactStrengthMutationVariables>(UpdateStakeholderRiskImpactStrengthDocument, options);
      }
export type UpdateStakeholderRiskImpactStrengthMutationHookResult = ReturnType<typeof useUpdateStakeholderRiskImpactStrengthMutation>;
export type UpdateStakeholderRiskImpactStrengthMutationResult = Apollo.MutationResult<UpdateStakeholderRiskImpactStrengthMutation>;
export type UpdateStakeholderRiskImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderRiskImpactStrengthMutation, UpdateStakeholderRiskImpactStrengthMutationVariables>;
export const UpdateStakeholderScenarioDocument = gql`
    mutation UpdateStakeholderScenario($enabled: Boolean, $id: ID!, $impact: String, $scenarioId: String, $trend: String, $x: Float, $y: Float) {
  updateStakeholderScenario(
    enabled: $enabled
    id: $id
    impact: $impact
    scenarioId: $scenarioId
    trend: $trend
    x: $x
    y: $y
  )
}
    `;
export type UpdateStakeholderScenarioMutationFn = Apollo.MutationFunction<UpdateStakeholderScenarioMutation, UpdateStakeholderScenarioMutationVariables>;

/**
 * __useUpdateStakeholderScenarioMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderScenarioMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderScenarioMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderScenarioMutation, { data, loading, error }] = useUpdateStakeholderScenarioMutation({
 *   variables: {
 *      enabled: // value for 'enabled'
 *      id: // value for 'id'
 *      impact: // value for 'impact'
 *      scenarioId: // value for 'scenarioId'
 *      trend: // value for 'trend'
 *      x: // value for 'x'
 *      y: // value for 'y'
 *   },
 * });
 */
export function useUpdateStakeholderScenarioMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderScenarioMutation, UpdateStakeholderScenarioMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderScenarioMutation, UpdateStakeholderScenarioMutationVariables>(UpdateStakeholderScenarioDocument, options);
      }
export type UpdateStakeholderScenarioMutationHookResult = ReturnType<typeof useUpdateStakeholderScenarioMutation>;
export type UpdateStakeholderScenarioMutationResult = Apollo.MutationResult<UpdateStakeholderScenarioMutation>;
export type UpdateStakeholderScenarioMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderScenarioMutation, UpdateStakeholderScenarioMutationVariables>;
export const UpdateStakeholderStakeImpactStrengthDocument = gql`
    mutation UpdateStakeholderStakeImpactStrength($id: ID!, $strength: Int!) {
  updateStakeholderStakeImpactStrength(id: $id, strength: $strength)
}
    `;
export type UpdateStakeholderStakeImpactStrengthMutationFn = Apollo.MutationFunction<UpdateStakeholderStakeImpactStrengthMutation, UpdateStakeholderStakeImpactStrengthMutationVariables>;

/**
 * __useUpdateStakeholderStakeImpactStrengthMutation__
 *
 * To run a mutation, you first call `useUpdateStakeholderStakeImpactStrengthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStakeholderStakeImpactStrengthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStakeholderStakeImpactStrengthMutation, { data, loading, error }] = useUpdateStakeholderStakeImpactStrengthMutation({
 *   variables: {
 *      id: // value for 'id'
 *      strength: // value for 'strength'
 *   },
 * });
 */
export function useUpdateStakeholderStakeImpactStrengthMutation(baseOptions?: Apollo.MutationHookOptions<UpdateStakeholderStakeImpactStrengthMutation, UpdateStakeholderStakeImpactStrengthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateStakeholderStakeImpactStrengthMutation, UpdateStakeholderStakeImpactStrengthMutationVariables>(UpdateStakeholderStakeImpactStrengthDocument, options);
      }
export type UpdateStakeholderStakeImpactStrengthMutationHookResult = ReturnType<typeof useUpdateStakeholderStakeImpactStrengthMutation>;
export type UpdateStakeholderStakeImpactStrengthMutationResult = Apollo.MutationResult<UpdateStakeholderStakeImpactStrengthMutation>;
export type UpdateStakeholderStakeImpactStrengthMutationOptions = Apollo.BaseMutationOptions<UpdateStakeholderStakeImpactStrengthMutation, UpdateStakeholderStakeImpactStrengthMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($description: String, $id: ID!, $name: String) {
  updateTag(description: $description, id: $id, name: $name)
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      description: // value for 'description'
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const OnAttachmentStatusChangedDocument = gql`
    subscription OnAttachmentStatusChanged($projectId: String, $tempSessionId: String) {
  onAttachmentStatusChanged(projectId: $projectId, tempSessionId: $tempSessionId) {
    contentType
    filename
    id
    projectId
    scanError
    size
    status
    tempSessionId
    uploadedAt
  }
}
    `;

/**
 * __useOnAttachmentStatusChangedSubscription__
 *
 * To run a query within a React component, call `useOnAttachmentStatusChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnAttachmentStatusChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnAttachmentStatusChangedSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      tempSessionId: // value for 'tempSessionId'
 *   },
 * });
 */
export function useOnAttachmentStatusChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnAttachmentStatusChangedSubscription, OnAttachmentStatusChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnAttachmentStatusChangedSubscription, OnAttachmentStatusChangedSubscriptionVariables>(OnAttachmentStatusChangedDocument, options);
      }
export type OnAttachmentStatusChangedSubscriptionHookResult = ReturnType<typeof useOnAttachmentStatusChangedSubscription>;
export type OnAttachmentStatusChangedSubscriptionResult = Apollo.SubscriptionResult<OnAttachmentStatusChangedSubscription>;
export const OnCreateProjectDocument = gql`
    subscription OnCreateProject {
  onCreateProject {
    analysisSummary
    baselineScenarioDescription
    baselineScenarioImpacts
    createdAt
    description
    descriptionLong
    fishboneBranchs {
      createdAt
      description
      enabled
      endOn
      evaluatedAt
      icon
      id
      indicatorLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      items {
        completion
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        fishboneBranchId
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          completion
          enabled
          id
          scenarioId
          trend
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        trend
        updatedAt
        weight
      }
      name
      position
      reference
      responsible
      riskLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      scenarios {
        enabled
        id
        scenarioId
        weight
      }
      stakeLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      stakeholderLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      startOn
      updatedAt
      weight
    }
    fishboneDescription
    fishboneEndOn
    fishboneStartOn
    id
    impacts {
      id
      name
    }
    indicatorCategories {
      createdAt
      description
      id
      name
      weight
    }
    indicators {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      id
      indicatorCategoryId
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    likelihoods {
      id
      name
    }
    members {
      createdAt
      id
      invitedBy
      invitedEmail
      project {
        analysisSummary
        baselineScenarioDescription
        baselineScenarioImpacts
        createdAt
        description
        descriptionLong
        fishboneBranchs {
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          icon
          id
          name
          position
          reference
          responsible
          startOn
          updatedAt
          weight
        }
        fishboneDescription
        fishboneEndOn
        fishboneStartOn
        id
        impacts {
          id
          name
        }
        indicatorCategories {
          createdAt
          description
          id
          name
          weight
        }
        indicators {
          createdAt
          description
          enabled
          evaluatedAt
          id
          indicatorCategoryId
          name
          reference
          trend
          weight
        }
        likelihoods {
          id
          name
        }
        members {
          createdAt
          id
          invitedBy
          invitedEmail
          projectId
          role
          status
        }
        myRole
        name
        readerCount
        reference
        responsible
        riskCategories {
          createdAt
          description
          id
          name
          weight
        }
        risks {
          createdAt
          description
          enabled
          evaluatedAt
          id
          impact
          isOpportunity
          likelihood
          name
          reference
          riskCategoryId
        }
        scenarios {
          createdAt
          description
          enabled
          id
          impacts
          name
        }
        stakeholders {
          createdAt
          description
          enabled
          icon
          id
          impact
          name
          trend
          x
          y
        }
        stakes {
          createdAt
          description
          enabled
          evaluatedAt
          id
          name
          reference
          trend
          weight
        }
        tags {
          createdAt
          description
          id
          name
        }
        type
        vision
      }
      projectId
      role
      status
    }
    myRole
    name
    readerCount
    reference
    responsible
    riskCategories {
      createdAt
      description
      id
      name
      weight
    }
    risks {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        riskId
        strength
      }
      impactedStakes {
        createdAt
        id
        riskId
        stakeId
        strength
      }
      isOpportunity
      likelihood
      name
      openingLinks {
        createdAt
        id
        openingId
        projectId
        riskId
        strength
      }
      reference
      riskCategoryId
      scenarios {
        enabled
        id
        impact
        likelihood
        scenarioId
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
    }
    scenarios {
      createdAt
      description
      enabled
      id
      impacts
      name
    }
    stakeholders {
      createdAt
      description
      enabled
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      icon
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeholderId
        strength
      }
      impactedRisks {
        createdAt
        id
        riskId
        stakeholderId
        strength
      }
      impactedStakes {
        createdAt
        id
        stakeId
        stakeholderId
        strength
      }
      links {
        createdAt
        id
        originId
        strength
        targetId
      }
      name
      scenarios {
        enabled
        id
        impact
        scenarioId
        trend
        x
        y
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
      trend
      x
      y
    }
    stakes {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      id
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeId
        strength
      }
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    tags {
      createdAt
      description
      id
      name
    }
    type
    vision
  }
}
    `;

/**
 * __useOnCreateProjectSubscription__
 *
 * To run a query within a React component, call `useOnCreateProjectSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCreateProjectSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCreateProjectSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnCreateProjectSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnCreateProjectSubscription, OnCreateProjectSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnCreateProjectSubscription, OnCreateProjectSubscriptionVariables>(OnCreateProjectDocument, options);
      }
export type OnCreateProjectSubscriptionHookResult = ReturnType<typeof useOnCreateProjectSubscription>;
export type OnCreateProjectSubscriptionResult = Apollo.SubscriptionResult<OnCreateProjectSubscription>;
export const OnProjectAnyChangeDocument = gql`
    subscription OnProjectAnyChange {
  onProjectAnyChange {
    analysisSummary
    baselineScenarioDescription
    baselineScenarioImpacts
    createdAt
    description
    descriptionLong
    fishboneBranchs {
      createdAt
      description
      enabled
      endOn
      evaluatedAt
      icon
      id
      indicatorLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      items {
        completion
        createdAt
        description
        enabled
        endOn
        evaluatedAt
        fishboneBranchId
        icon
        id
        indicatorLinks {
          createdAt
          fishboneNodeId
          id
          indicatorId
          nodeType
          projectId
          strength
        }
        name
        position
        reference
        responsible
        riskLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          riskId
          strength
        }
        scenarios {
          completion
          enabled
          id
          scenarioId
          trend
          weight
        }
        stakeLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeId
          strength
        }
        stakeholderLinks {
          createdAt
          fishboneNodeId
          id
          nodeType
          projectId
          stakeholderId
          strength
        }
        startOn
        trend
        updatedAt
        weight
      }
      name
      position
      reference
      responsible
      riskLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      scenarios {
        enabled
        id
        scenarioId
        weight
      }
      stakeLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      stakeholderLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      startOn
      updatedAt
      weight
    }
    fishboneDescription
    fishboneEndOn
    fishboneStartOn
    id
    impacts {
      id
      name
    }
    indicatorCategories {
      createdAt
      description
      id
      name
      weight
    }
    indicators {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        indicatorId
        nodeType
        projectId
        strength
      }
      id
      indicatorCategoryId
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    likelihoods {
      id
      name
    }
    members {
      createdAt
      id
      invitedBy
      invitedEmail
      project {
        analysisSummary
        baselineScenarioDescription
        baselineScenarioImpacts
        createdAt
        description
        descriptionLong
        fishboneBranchs {
          createdAt
          description
          enabled
          endOn
          evaluatedAt
          icon
          id
          name
          position
          reference
          responsible
          startOn
          updatedAt
          weight
        }
        fishboneDescription
        fishboneEndOn
        fishboneStartOn
        id
        impacts {
          id
          name
        }
        indicatorCategories {
          createdAt
          description
          id
          name
          weight
        }
        indicators {
          createdAt
          description
          enabled
          evaluatedAt
          id
          indicatorCategoryId
          name
          reference
          trend
          weight
        }
        likelihoods {
          id
          name
        }
        members {
          createdAt
          id
          invitedBy
          invitedEmail
          projectId
          role
          status
        }
        myRole
        name
        readerCount
        reference
        responsible
        riskCategories {
          createdAt
          description
          id
          name
          weight
        }
        risks {
          createdAt
          description
          enabled
          evaluatedAt
          id
          impact
          isOpportunity
          likelihood
          name
          reference
          riskCategoryId
        }
        scenarios {
          createdAt
          description
          enabled
          id
          impacts
          name
        }
        stakeholders {
          createdAt
          description
          enabled
          icon
          id
          impact
          name
          trend
          x
          y
        }
        stakes {
          createdAt
          description
          enabled
          evaluatedAt
          id
          name
          reference
          trend
          weight
        }
        tags {
          createdAt
          description
          id
          name
        }
        type
        vision
      }
      projectId
      role
      status
    }
    myRole
    name
    readerCount
    reference
    responsible
    riskCategories {
      createdAt
      description
      id
      name
      weight
    }
    risks {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        riskId
        strength
      }
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        riskId
        strength
      }
      impactedStakes {
        createdAt
        id
        riskId
        stakeId
        strength
      }
      isOpportunity
      likelihood
      name
      openingLinks {
        createdAt
        id
        openingId
        projectId
        riskId
        strength
      }
      reference
      riskCategoryId
      scenarios {
        enabled
        id
        impact
        likelihood
        scenarioId
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
    }
    scenarios {
      createdAt
      description
      enabled
      id
      impacts
      name
    }
    stakeholders {
      createdAt
      description
      enabled
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeholderId
        strength
      }
      icon
      id
      impact
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeholderId
        strength
      }
      impactedRisks {
        createdAt
        id
        riskId
        stakeholderId
        strength
      }
      impactedStakes {
        createdAt
        id
        stakeId
        stakeholderId
        strength
      }
      links {
        createdAt
        id
        originId
        strength
        targetId
      }
      name
      scenarios {
        enabled
        id
        impact
        scenarioId
        trend
        x
        y
      }
      taggings {
        createdAt
        id
        objectId
        tagId
        type
      }
      trend
      x
      y
    }
    stakes {
      createdAt
      description
      enabled
      evaluatedAt
      fishboneLinks {
        createdAt
        fishboneNodeId
        id
        nodeType
        projectId
        stakeId
        strength
      }
      id
      impactedIndicators {
        createdAt
        id
        indicatorId
        stakeId
        strength
      }
      name
      reference
      scenarios {
        enabled
        id
        scenarioId
        trend
        weight
      }
      trend
      weight
    }
    tags {
      createdAt
      description
      id
      name
    }
    type
    vision
  }
}
    `;

/**
 * __useOnProjectAnyChangeSubscription__
 *
 * To run a query within a React component, call `useOnProjectAnyChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProjectAnyChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProjectAnyChangeSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnProjectAnyChangeSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnProjectAnyChangeSubscription, OnProjectAnyChangeSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnProjectAnyChangeSubscription, OnProjectAnyChangeSubscriptionVariables>(OnProjectAnyChangeDocument, options);
      }
export type OnProjectAnyChangeSubscriptionHookResult = ReturnType<typeof useOnProjectAnyChangeSubscription>;
export type OnProjectAnyChangeSubscriptionResult = Apollo.SubscriptionResult<OnProjectAnyChangeSubscription>;
export const OnProjectChangeDocument = gql`
    subscription OnProjectChange($projectId: String!) {
  onProjectChange(projectId: $projectId) {
    author
    changes
    objectId
    operation
    projectId
    type
  }
}
    `;

/**
 * __useOnProjectChangeSubscription__
 *
 * To run a query within a React component, call `useOnProjectChangeSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProjectChangeSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProjectChangeSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOnProjectChangeSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnProjectChangeSubscription, OnProjectChangeSubscriptionVariables> & ({ variables: OnProjectChangeSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnProjectChangeSubscription, OnProjectChangeSubscriptionVariables>(OnProjectChangeDocument, options);
      }
export type OnProjectChangeSubscriptionHookResult = ReturnType<typeof useOnProjectChangeSubscription>;
export type OnProjectChangeSubscriptionResult = Apollo.SubscriptionResult<OnProjectChangeSubscription>;
export const OnProjectMessageDocument = gql`
    subscription OnProjectMessage($projectId: String!) {
  onProjectMessage(projectId: $projectId) {
    message
    projectId
  }
}
    `;

/**
 * __useOnProjectMessageSubscription__
 *
 * To run a query within a React component, call `useOnProjectMessageSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnProjectMessageSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnProjectMessageSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useOnProjectMessageSubscription(baseOptions: Apollo.SubscriptionHookOptions<OnProjectMessageSubscription, OnProjectMessageSubscriptionVariables> & ({ variables: OnProjectMessageSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnProjectMessageSubscription, OnProjectMessageSubscriptionVariables>(OnProjectMessageDocument, options);
      }
export type OnProjectMessageSubscriptionHookResult = ReturnType<typeof useOnProjectMessageSubscription>;
export type OnProjectMessageSubscriptionResult = Apollo.SubscriptionResult<OnProjectMessageSubscription>;